import { IntrospectionQuery } from 'graphql';
export default {
  "__schema": {
    "queryType": {
      "name": "Query"
    },
    "mutationType": {
      "name": "Mutation"
    },
    "subscriptionType": null,
    "types": [
      {
        "kind": "INPUT_OBJECT",
        "name": "AcceptTosInput",
        "inputFields": [
          {
            "name": "token",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "Account",
        "fields": [
          {
            "name": "closeable",
            "type": {
              "kind": "SCALAR",
              "name": "Boolean",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "currency",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "Currency",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "details",
            "type": {
              "kind": "UNION",
              "name": "AccountDetails",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "hasVerificationLetter",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "isPayoutOnly",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "isPrimary",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "providerAccountId",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "restrictedFields",
            "type": {
              "kind": "OBJECT",
              "name": "AccountRestrictedFields",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "status",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "AccountStatus",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "type",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "AccountType",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "AccountDetails",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "CADAccountDetails"
          },
          {
            "kind": "OBJECT",
            "name": "CreditAccountDetails"
          },
          {
            "kind": "OBJECT",
            "name": "EURAccountDetails"
          },
          {
            "kind": "OBJECT",
            "name": "GBPAccountDetails"
          },
          {
            "kind": "OBJECT",
            "name": "SWIFTAccountDetails"
          },
          {
            "kind": "OBJECT",
            "name": "USDAccountDetails"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "AccountDetailsWithLocalPayIns",
        "fields": [
          {
            "name": "accountHolder",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "accountNumber",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "accountNumberIsIban",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "bankAddress",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "bankName",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "localPaymentRailName",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "swift",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "SWIFTAccountDetails",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": [],
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "CADAccountDetails"
          },
          {
            "kind": "OBJECT",
            "name": "EURAccountDetails"
          },
          {
            "kind": "OBJECT",
            "name": "GBPAccountDetails"
          },
          {
            "kind": "OBJECT",
            "name": "USDAccountDetails"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "AccountInfoResponse",
        "fields": [
          {
            "name": "accountInfo",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "AccountTypeInfo",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "AccountLimit",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "MoneyAccountLimit"
          },
          {
            "kind": "OBJECT",
            "name": "VolumeAccountLimit"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "AccountLimitInterface",
        "fields": [
          {
            "name": "limitType",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "AccountLimitType",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": [],
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "MoneyAccountLimit"
          },
          {
            "kind": "OBJECT",
            "name": "VolumeAccountLimit"
          }
        ]
      },
      {
        "kind": "ENUM",
        "name": "AccountLimitType",
        "enumValues": [
          {
            "name": "DAILY_ACH_CREDIT"
          },
          {
            "name": "DAILY_ACH_DEBIT"
          },
          {
            "name": "DAILY_CHECK_DEPOSIT"
          },
          {
            "name": "DAILY_PURCHASE"
          },
          {
            "name": "DAILY_WITHDRAWAL"
          },
          {
            "name": "MONTHLY_ACH_CREDIT"
          },
          {
            "name": "MONTHLY_ACH_DEBIT"
          },
          {
            "name": "MONTHLY_CHECK_DEPOSIT"
          },
          {
            "name": "MONTHLY_FREE_LOCAL_RAIL_PAYMENTS"
          },
          {
            "name": "MONTHLY_FREE_WIRE_PAYMENTS"
          },
          {
            "name": "MONTHLY_PURCHASE"
          },
          {
            "name": "MONTHLY_WITHDRAWAL"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "AccountRestrictedFields",
        "fields": [
          {
            "name": "apy",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Float",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "availableBalance",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "Money",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "currentBalance",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "Money",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "AccountStatement",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "CheckingAccountStatement"
          },
          {
            "kind": "OBJECT",
            "name": "ConsolidatedAccountStatement"
          },
          {
            "kind": "OBJECT",
            "name": "CreditAccountStatement"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "AccountStatementInterface",
        "fields": [
          {
            "name": "account",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "Account",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "balance",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "CreditStatementBalance",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "csvUrl",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "html",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "pdfUrl",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "period",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "Period",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "qboUrl",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "statementDate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Date",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": [],
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "CheckingAccountStatement"
          },
          {
            "kind": "OBJECT",
            "name": "CreditAccountStatement"
          }
        ]
      },
      {
        "kind": "ENUM",
        "name": "AccountStatus",
        "enumValues": [
          {
            "name": "CLOSED"
          },
          {
            "name": "FROZEN"
          },
          {
            "name": "OPEN"
          }
        ]
      },
      {
        "kind": "ENUM",
        "name": "AccountType",
        "enumValues": [
          {
            "name": "CHECKING"
          },
          {
            "name": "CREDIT"
          },
          {
            "name": "OPS"
          },
          {
            "name": "SAVINGS"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "AccountTypeInfo",
        "fields": [
          {
            "name": "achDebitClearingBusinessDays",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "apy",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Float",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "maxDebitVirtualCardsPerUser",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "minBalance",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Float",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "AccountingCategory",
        "fields": [
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "parentAccountingCategory",
            "type": {
              "kind": "OBJECT",
              "name": "AccountingCategory",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "status",
            "type": {
              "kind": "ENUM",
              "name": "AccountingCategoryStatus",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "type",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "AccountingCategoryType",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "ENUM",
        "name": "AccountingCategoryStatus",
        "enumValues": [
          {
            "name": "ACTIVE"
          },
          {
            "name": "ARCHIVED"
          },
          {
            "name": "PENDING"
          },
          {
            "name": "UNKNOWN"
          }
        ]
      },
      {
        "kind": "ENUM",
        "name": "AccountingCategoryType",
        "enumValues": [
          {
            "name": "CLASS"
          },
          {
            "name": "DEPARTMENT"
          },
          {
            "name": "LOCATION"
          },
          {
            "name": "UNKNOWN"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "AccountingConnection",
        "fields": [
          {
            "name": "astEnabled",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "lastSyncedAt",
            "type": {
              "kind": "SCALAR",
              "name": "DateTime",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "AccountingConnectionName",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "status",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "AccountingConnectionStatus",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "syncStatus",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "AccountingConnectionSyncStatus",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "ENUM",
        "name": "AccountingConnectionName",
        "enumValues": [
          {
            "name": "DYNAMICS_BUSINESS_CENTRAL"
          },
          {
            "name": "FRESHBOOKS"
          },
          {
            "name": "ORACLE_NETSUITE"
          },
          {
            "name": "QUICKBOOKS"
          },
          {
            "name": "QUICKBOOKS_DESKTOP"
          },
          {
            "name": "SAGE_BUSINESS_CLOUD"
          },
          {
            "name": "SAGE_INTACCT"
          },
          {
            "name": "WAVE"
          },
          {
            "name": "XERO"
          },
          {
            "name": "ZOHO_BOOKS"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "AccountingConnectionRequiredError",
        "fields": [
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "path",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "SCALAR",
                  "name": "String",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "stackTrace",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "ErrorInterface"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "AccountingConnectionResponse",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "AccountingConnection"
          },
          {
            "kind": "OBJECT",
            "name": "AccountingDeauthorized"
          },
          {
            "kind": "OBJECT",
            "name": "AccountingNotConnected"
          }
        ]
      },
      {
        "kind": "ENUM",
        "name": "AccountingConnectionStatus",
        "enumValues": [
          {
            "name": "ACTIVE"
          },
          {
            "name": "DEAUTHORIZED"
          },
          {
            "name": "DISCONNECTED"
          },
          {
            "name": "PENDING"
          }
        ]
      },
      {
        "kind": "ENUM",
        "name": "AccountingConnectionSyncStatus",
        "enumValues": [
          {
            "name": "COMPLETE"
          },
          {
            "name": "NEEDS_REAUTH"
          },
          {
            "name": "SYNCING"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "AccountingCustomer",
        "fields": [
          {
            "name": "contactName",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "email",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "status",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "AccountingCustomerStatus",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "ENUM",
        "name": "AccountingCustomerStatus",
        "enumValues": [
          {
            "name": "ACTIVE"
          },
          {
            "name": "ARCHIVED"
          },
          {
            "name": "UNKNOWN"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "AccountingDeauthorized",
        "fields": [
          {
            "name": "void",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "AccountingFilter",
        "inputFields": [
          {
            "name": "searchString",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            }
          }
        ]
      },
      {
        "kind": "ENUM",
        "name": "AccountingItemStatus",
        "enumValues": [
          {
            "name": "ACTIVE"
          },
          {
            "name": "ARCHIVED"
          },
          {
            "name": "UNKNOWN"
          }
        ]
      },
      {
        "kind": "ENUM",
        "name": "AccountingItemType",
        "enumValues": [
          {
            "name": "INVENTORY"
          },
          {
            "name": "NON_INVENTORY"
          },
          {
            "name": "SERVICE"
          },
          {
            "name": "UNKNOWN"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "AccountingNotConnected",
        "fields": [
          {
            "name": "neverConnected",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "AccountingTaxRate",
        "fields": [
          {
            "name": "code",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "effectiveTaxRate",
            "type": {
              "kind": "SCALAR",
              "name": "Float",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "totalTaxRate",
            "type": {
              "kind": "SCALAR",
              "name": "Float",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "AccountingVendor",
        "fields": [
          {
            "name": "contactName",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "currency",
            "type": {
              "kind": "ENUM",
              "name": "Currency",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "email",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "levroRecipientId",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "AccountingVendorSyncing",
        "fields": [
          {
            "name": "syncing",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "AccountsWidget",
        "fields": [
          {
            "name": "accounts",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "Account",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "title",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseWidget"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "ActivationChecklistItem",
        "fields": [
          {
            "name": "status",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "ChecklistItemStatus",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "step",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "ActivationChecklistStep",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "ChecklistItem"
          }
        ]
      },
      {
        "kind": "ENUM",
        "name": "ActivationChecklistStep",
        "enumValues": [
          {
            "name": "FIRST_CARD_TRANSACTION"
          },
          {
            "name": "FIRST_DEPOSIT"
          },
          {
            "name": "FIRST_PAYMENT"
          },
          {
            "name": "FIRST_RECIPIENT"
          },
          {
            "name": "INVITE_TEAM"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "Activity",
        "fields": [
          {
            "name": "approvalInfo",
            "type": {
              "kind": "OBJECT",
              "name": "ApprovalInfo",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "autoRetryInfo",
            "type": {
              "kind": "OBJECT",
              "name": "AutoRetryInfo",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "canAttachFiles",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "canWriteNote",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "comments",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "Comment",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "date",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Date",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "entity",
            "type": {
              "kind": "UNION",
              "name": "ActivityEntity",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "error",
            "type": {
              "kind": "UNION",
              "name": "ActivityError",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "files",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "File",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "note",
            "type": {
              "kind": "OBJECT",
              "name": "Note",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "receiptAvailable",
            "type": {
              "kind": "SCALAR",
              "name": "Boolean",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "receiptUrl",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "schedulingInfo",
            "type": {
              "kind": "OBJECT",
              "name": "SchedulingInfo",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "status",
            "type": {
              "kind": "ENUM",
              "name": "ExecutionStatus",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "summary",
            "type": {
              "kind": "UNION",
              "name": "ActivitySummary",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "type",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "ActivityType",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "ActivityEntity",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "Conversion"
          },
          {
            "kind": "OBJECT",
            "name": "Deposit"
          },
          {
            "kind": "OBJECT",
            "name": "InternalTransfer"
          },
          {
            "kind": "OBJECT",
            "name": "Payment"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "ActivityError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "ComplianceError"
          },
          {
            "kind": "OBJECT",
            "name": "DefaultError"
          },
          {
            "kind": "OBJECT",
            "name": "InvalidRecipientError"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "ActivitySummary",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "ConversionSummary"
          },
          {
            "kind": "OBJECT",
            "name": "DepositSummary"
          },
          {
            "kind": "OBJECT",
            "name": "InternalTransferSummary"
          },
          {
            "kind": "OBJECT",
            "name": "PaymentSummary"
          }
        ]
      },
      {
        "kind": "ENUM",
        "name": "ActivityType",
        "enumValues": [
          {
            "name": "CONVERSION"
          },
          {
            "name": "DEPOSIT"
          },
          {
            "name": "INTERNAL_TRANSFER"
          },
          {
            "name": "PAYMENT"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "AddContractsToSeriesInput",
        "inputFields": [
          {
            "name": "contractIds",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID",
                    "ofType": null
                  }
                }
              }
            }
          },
          {
            "name": "contractInDestinationSeriesId",
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            }
          },
          {
            "name": "setActiveContractInDestinationSeries",
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "setActiveContractInSourceSeries",
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "AddContractsToSeriesResponse",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "Address",
        "fields": [
          {
            "name": "city",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "countryCode",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "postalCode",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "state",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "street",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "street2",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "AddressInput",
        "inputFields": [
          {
            "name": "city",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            }
          },
          {
            "name": "countryCode",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            }
          },
          {
            "name": "postalCode",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            }
          },
          {
            "name": "state",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            }
          },
          {
            "name": "street",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            }
          },
          {
            "name": "street2",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "AdminContract",
        "fields": [
          {
            "name": "contract",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "Contract",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "contractRawJson",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "customer",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "Customer",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "AdminCustomerOrg",
        "fields": [
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "AdminGetContractsInput",
        "inputFields": [
          {
            "name": "contractId",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "orgId",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            }
          },
          {
            "name": "unannotated",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "defaultValue": "true"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "AdminGetContractsResponse",
        "fields": [
          {
            "name": "contracts",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "AdminContract",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "AdminGetCustomerOrgsResponse",
        "fields": [
          {
            "name": "customerOrgs",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "AdminCustomerOrg",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "AdminUpdateContractInput",
        "inputFields": [
          {
            "name": "annotatedJson",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            }
          },
          {
            "name": "contractId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "AdminUpdateContractResponse",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "updatedContract",
            "type": {
              "kind": "OBJECT",
              "name": "Contract",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "AmountThresholdCriterion",
        "fields": [
          {
            "name": "amountThreshold",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "Money",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "AmountThresholdCriterionInput",
        "inputFields": [
          {
            "name": "amountThreshold",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Float",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "AnalyzeBulkPaymentFileInput",
        "inputFields": [
          {
            "name": "data",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "AnalyzeBulkPaymentRowInput",
                    "ofType": null
                  }
                }
              }
            }
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "AnalyzeBulkPaymentRowInput",
        "inputFields": [
          {
            "name": "values",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "SpreadsheetValueInput",
                  "ofType": null
                }
              }
            }
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "AnnotatedObject",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "ContractAnnotationObject"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "Annotation",
        "fields": [
          {
            "name": "annotationJson",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "annotatorIdentityId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "task",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "AnnotationTask",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "AnnotationTask",
        "fields": [
          {
            "name": "annotatedObject",
            "type": {
              "kind": "UNION",
              "name": "AnnotatedObject",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "annotations",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "Annotation",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "customer",
            "type": {
              "kind": "OBJECT",
              "name": "Org",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "file",
            "type": {
              "kind": "OBJECT",
              "name": "File",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "inputJson",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "schemaJson",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "schemaType",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "SchemaType",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "schemaVersion",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "status",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "AnnotationTaskStatus",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "ENUM",
        "name": "AnnotationTaskStatus",
        "enumValues": [
          {
            "name": "ACTIVE"
          },
          {
            "name": "CANCELED"
          },
          {
            "name": "COMPLETED"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "ApiKey",
        "fields": [
          {
            "name": "createdAt",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "DateTime",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "description",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "expiredAt",
            "type": {
              "kind": "SCALAR",
              "name": "DateTime",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "prefix",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "Application",
        "fields": [
          {
            "name": "applicationUrl",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "dbaName",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "documents",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "ApplicationDocument",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "legalName",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "status",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "ApplicationStatus",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ApplicationDocument",
        "fields": [
          {
            "name": "address",
            "type": {
              "kind": "OBJECT",
              "name": "Address",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "dateOfBirth",
            "type": {
              "kind": "SCALAR",
              "name": "Date",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "description",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "documentType",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "ApplicationDocumentType",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "ein",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "passport",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "reason",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "reasonCode",
            "type": {
              "kind": "ENUM",
              "name": "ApplicationDocumentReasonCode",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "status",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "ApplicationDocumentStatus",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "ENUM",
        "name": "ApplicationDocumentReasonCode",
        "enumValues": [
          {
            "name": "ADDRESS_MISMATCH"
          },
          {
            "name": "DOB_MISMATCH"
          },
          {
            "name": "EIN_MISMATCH"
          },
          {
            "name": "EXPIRED_ID"
          },
          {
            "name": "NAME_MISMATCH"
          },
          {
            "name": "OTHER"
          },
          {
            "name": "POOR_QUALITY"
          },
          {
            "name": "SSN_MISMATCH"
          },
          {
            "name": "STATE_MISMATCH"
          }
        ]
      },
      {
        "kind": "ENUM",
        "name": "ApplicationDocumentStatus",
        "enumValues": [
          {
            "name": "APPROVED"
          },
          {
            "name": "INVALID"
          },
          {
            "name": "PENDING_REVIEW"
          },
          {
            "name": "RECEIVED_BACK"
          },
          {
            "name": "RECEIVED_FRONT"
          },
          {
            "name": "REQUIRED"
          }
        ]
      },
      {
        "kind": "ENUM",
        "name": "ApplicationDocumentType",
        "enumValues": [
          {
            "name": "ADDRESS_VERIFICATION"
          },
          {
            "name": "CERTIFICATE_OF_INCORPORATION"
          },
          {
            "name": "CLIENT_REQUESTED"
          },
          {
            "name": "EMPLOYER_IDENTIFICATION_NUMBER_CONFIRMATION"
          },
          {
            "name": "ID_DOCUMENT"
          },
          {
            "name": "PASSPORT"
          },
          {
            "name": "POWER_OF_ATTORNEY"
          },
          {
            "name": "SELFIE_VERIFICATION"
          },
          {
            "name": "SOCIAL_SECURITY_CARD"
          }
        ]
      },
      {
        "kind": "ENUM",
        "name": "ApplicationStatus",
        "enumValues": [
          {
            "name": "ACCOUNT_SETUP"
          },
          {
            "name": "APPROVED"
          },
          {
            "name": "AWAITING_DOCUMENTS"
          },
          {
            "name": "CANCELED"
          },
          {
            "name": "DENIED"
          },
          {
            "name": "NEW"
          },
          {
            "name": "PENDING"
          },
          {
            "name": "PENDING_REVIEW"
          },
          {
            "name": "SUBMISSION_ERROR"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "ApplicationSummary",
        "fields": [
          {
            "name": "dbaName",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "legalName",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "status",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "ApplicationStatus",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "ApplyCreditAccountInput",
        "inputFields": [
          {
            "name": "autoPayAccountId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            }
          },
          {
            "name": "autoPayAccountType",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "RepaymentAccountType",
                "ofType": null
              }
            }
          },
          {
            "name": "dateOfIncorporation",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Date",
                "ofType": null
              }
            }
          },
          {
            "name": "estimatedAnnualRevenue",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "INPUT_OBJECT",
                "name": "MoneyInput",
                "ofType": null
              }
            }
          },
          {
            "name": "naicsIndustry",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "ApplyCreditAccountResponse",
        "fields": [
          {
            "name": "application",
            "type": {
              "kind": "OBJECT",
              "name": "CreditApplication",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "Approval",
        "fields": [
          {
            "name": "timestamp",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "DateTime",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "type",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "ApprovalType",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "user",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "User",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ApprovalFlow",
        "fields": [
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "layerConfigs",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "LayerConfig",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ApprovalFlowAndCriterion",
        "fields": [
          {
            "name": "approvalFlow",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ApprovalFlow",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "criterion",
            "type": {
              "kind": "UNION",
              "name": "ApprovalFlowCriterion",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "ApprovalFlowAndCriterionInput",
        "inputFields": [
          {
            "name": "approvalFlow",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "INPUT_OBJECT",
                "name": "ApprovalFlowInput",
                "ofType": null
              }
            }
          },
          {
            "name": "criterion",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "ApprovalFlowCriterionInput",
              "ofType": null
            }
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "ApprovalFlowCriterion",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "AmountThresholdCriterion"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "ApprovalFlowCriterionInput",
        "inputFields": [
          {
            "name": "amountThresholdCriterion",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "AmountThresholdCriterionInput",
              "ofType": null
            }
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "ApprovalFlowInput",
        "inputFields": [
          {
            "name": "layerConfigs",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "LayerConfigInput",
                    "ofType": null
                  }
                }
              }
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "ApprovalFlowWidget",
        "fields": [
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "title",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseWidget"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "ApprovalInfo",
        "fields": [
          {
            "name": "multiLayerApprovalState",
            "type": {
              "kind": "OBJECT",
              "name": "MultiLayerApprovalState",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "requestedAt",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "DateTime",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "requester",
            "type": {
              "kind": "OBJECT",
              "name": "User",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "resolvedAt",
            "type": {
              "kind": "SCALAR",
              "name": "DateTime",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "resolver",
            "type": {
              "kind": "OBJECT",
              "name": "User",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "selfApproved",
            "type": {
              "kind": "SCALAR",
              "name": "Boolean",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "status",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "ApprovalRequestStatus",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "ENUM",
        "name": "ApprovalLogic",
        "enumValues": [
          {
            "name": "ALL"
          },
          {
            "name": "ANY"
          }
        ]
      },
      {
        "kind": "ENUM",
        "name": "ApprovalRequestStatus",
        "enumValues": [
          {
            "name": "APPROVED"
          },
          {
            "name": "PENDING"
          },
          {
            "name": "PENDING_RELEASE"
          },
          {
            "name": "REJECTED"
          }
        ]
      },
      {
        "kind": "ENUM",
        "name": "ApprovalType",
        "enumValues": [
          {
            "name": "IMPLICIT_BY_REQUESTER"
          },
          {
            "name": "REGULAR"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "ApproveCreditApplicationInput",
        "inputFields": [
          {
            "name": "creditApplicationId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            }
          },
          {
            "name": "creditLimit",
            "type": {
              "kind": "SCALAR",
              "name": "Int",
              "ofType": null
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "ApproveCreditApplicationResponse",
        "fields": [
          {
            "name": "creditApplication",
            "type": {
              "kind": "OBJECT",
              "name": "CreditApplication",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "Approver",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "RoleApprover"
          },
          {
            "kind": "OBJECT",
            "name": "SingleUserApprover"
          },
          {
            "kind": "OBJECT",
            "name": "UserGroupApprover"
          },
          {
            "kind": "OBJECT",
            "name": "VendorManagerApprover"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "ApproverInput",
        "inputFields": [
          {
            "name": "roleApprover",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "RoleApproverInput",
              "ofType": null
            }
          },
          {
            "name": "singleUserApprover",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "SingleUserApproverInput",
              "ofType": null
            }
          },
          {
            "name": "userGroupApprover",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "UserGroupApproverInput",
              "ofType": null
            }
          },
          {
            "name": "vendorManagerApprover",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "VendorManagerApproverInput",
              "ofType": null
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "ApproverState",
        "fields": [
          {
            "name": "approvals",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "Approval",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "config",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "UNION",
                "name": "Approver",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "pendingApprovers",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "User",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "satisfied",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "ENUM",
        "name": "ApproverUserRole",
        "enumValues": [
          {
            "name": "ACCOUNTANT"
          },
          {
            "name": "ADMINISTRATOR"
          },
          {
            "name": "LITE_ADMIN"
          },
          {
            "name": "REVIEWER"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "AssistantBoard",
        "fields": [
          {
            "name": "createdAt",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "DateTime",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "status",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "AssistantEventStatus",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "title",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "updatedAt",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "DateTime",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "widgets",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "Widget",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseAssistantEvent"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "AssistantEvent",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "AssistantBoard"
          },
          {
            "kind": "OBJECT",
            "name": "AssistantMessage"
          },
          {
            "kind": "OBJECT",
            "name": "AssistantPythonSession"
          },
          {
            "kind": "OBJECT",
            "name": "AssistantToolCall"
          },
          {
            "kind": "OBJECT",
            "name": "AssistantToolSelection"
          },
          {
            "kind": "OBJECT",
            "name": "AssistantVariableDefinitions"
          },
          {
            "kind": "OBJECT",
            "name": "AssistantWorkflowSelection"
          }
        ]
      },
      {
        "kind": "ENUM",
        "name": "AssistantEventStatus",
        "enumValues": [
          {
            "name": "ERROR"
          },
          {
            "name": "PENDING"
          },
          {
            "name": "SUCCESS"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "AssistantInvoicePrefill",
        "fields": [
          {
            "name": "account",
            "type": {
              "kind": "OBJECT",
              "name": "Account",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "description",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "dueDate",
            "type": {
              "kind": "SCALAR",
              "name": "Date",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "invoiceAmount",
            "type": {
              "kind": "OBJECT",
              "name": "Money",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "invoiceDate",
            "type": {
              "kind": "SCALAR",
              "name": "Date",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "invoiceNumber",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "lineItems",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "InvoiceLineItem",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "payer",
            "type": {
              "kind": "OBJECT",
              "name": "Payer",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "payerRequest",
            "type": {
              "kind": "OBJECT",
              "name": "AssistantPayerPrefill",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "AssistantMessage",
        "fields": [
          {
            "name": "createdAt",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "DateTime",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "files",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "File",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "role",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "AssistantMessageRole",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "status",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "AssistantEventStatus",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "text",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseAssistantEvent"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "AssistantMessageInput",
        "inputFields": [
          {
            "name": "textInput",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            }
          }
        ]
      },
      {
        "kind": "ENUM",
        "name": "AssistantMessageRole",
        "enumValues": [
          {
            "name": "ASSISTANT"
          },
          {
            "name": "USER"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "AssistantPayerPrefill",
        "fields": [
          {
            "name": "defaultAccount",
            "type": {
              "kind": "OBJECT",
              "name": "Account",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "email",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "payerName",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "AssistantProgress",
        "fields": [
          {
            "name": "ongoingAction",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "AssistantPythonSession",
        "fields": [
          {
            "name": "createdAt",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "DateTime",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "error",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "instructions",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "status",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "AssistantEventStatus",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "transcript",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseAssistantEvent"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "AssistantRecipientPrefill",
        "fields": [
          {
            "name": "accountNumber",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "address",
            "type": {
              "kind": "OBJECT",
              "name": "Address",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "companyName",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "country",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "currency",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "email",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "firstName",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "lastName",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "paypalEmail",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "routingNumber",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "routingNumber2",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "swift",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "venmoHandle",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "AssistantThread",
        "fields": [
          {
            "name": "createdAt",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "DateTime",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "events",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "AssistantEvent",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "lastActiveAt",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "DateTime",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "progress",
            "type": {
              "kind": "OBJECT",
              "name": "AssistantProgress",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "status",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "AssistantEventStatus",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "subject",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "AssistantToolCall",
        "fields": [
          {
            "name": "createdAt",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "DateTime",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "error",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "status",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "AssistantEventStatus",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "toolArgs",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "JSON",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "toolName",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "toolOutput",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseAssistantEvent"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "AssistantToolSelection",
        "fields": [
          {
            "name": "createdAt",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "DateTime",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "selectedTools",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "String",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "status",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "AssistantEventStatus",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseAssistantEvent"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "AssistantVariableDefinition",
        "fields": [
          {
            "name": "instructions",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "type",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "value",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "AssistantVariableDefinitions",
        "fields": [
          {
            "name": "createdAt",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "DateTime",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "status",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "AssistantEventStatus",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "variables",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "AssistantVariableDefinition",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseAssistantEvent"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "AssistantWorkflowAnalysis",
        "fields": [
          {
            "name": "cons",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "pros",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "score",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "workflowName",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "AssistantWorkflowSelection",
        "fields": [
          {
            "name": "analysis",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "AssistantWorkflowAnalysis",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "createdAt",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "DateTime",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "decision",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "status",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "AssistantEventStatus",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseAssistantEvent"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "AtmTransactionMetadata",
        "fields": [
          {
            "name": "atmLocation",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "atmName",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "cardId",
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "originalCurrencyAmount",
            "type": {
              "kind": "OBJECT",
              "name": "Money",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "surcharge",
            "type": {
              "kind": "OBJECT",
              "name": "Money",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "AttachActivityFilesInput",
        "inputFields": [
          {
            "name": "activityId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            }
          },
          {
            "name": "fileIds",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID",
                    "ofType": null
                  }
                }
              }
            }
          },
          {
            "name": "showToRecipient",
            "type": {
              "kind": "SCALAR",
              "name": "Boolean",
              "ofType": null
            },
            "defaultValue": "false"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "AttachActivityFilesResponse",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "files",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "File",
                  "ofType": null
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "AttachEventInstanceFilesInput",
        "inputFields": [
          {
            "name": "eventId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            }
          },
          {
            "name": "fileIds",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID",
                    "ofType": null
                  }
                }
              }
            }
          },
          {
            "name": "ordinal",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            }
          },
          {
            "name": "showToRecipient",
            "type": {
              "kind": "SCALAR",
              "name": "Boolean",
              "ofType": null
            },
            "defaultValue": "false"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "AttachEventInstanceFilesResponse",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "files",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "File",
                  "ofType": null
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "AttachScheduledEventFilesInput",
        "inputFields": [
          {
            "name": "eventId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            }
          },
          {
            "name": "fileIds",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID",
                    "ofType": null
                  }
                }
              }
            }
          },
          {
            "name": "showToRecipient",
            "type": {
              "kind": "SCALAR",
              "name": "Boolean",
              "ofType": null
            },
            "defaultValue": "false"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "AttachScheduledEventFilesResponse",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "files",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "File",
                  "ofType": null
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "AttachTransactionFilesInput",
        "inputFields": [
          {
            "name": "fileIds",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID",
                    "ofType": null
                  }
                }
              }
            }
          },
          {
            "name": "showToRecipient",
            "type": {
              "kind": "SCALAR",
              "name": "Boolean",
              "ofType": null
            },
            "defaultValue": "false"
          },
          {
            "name": "transactionId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "AttachTransactionFilesResponse",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "files",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "File",
                  "ofType": null
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "AuthInfo",
        "fields": [
          {
            "name": "isMfaSetUp",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "phoneNumber",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "usesPhoneNumberForMfa",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "AutoRetryInfo",
        "fields": [
          {
            "name": "until",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Date",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "BankDetail",
        "fields": [
          {
            "name": "accountNumber",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "bankAddress",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "bankBranch",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "bankCity",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "bankCountry",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "bankCountryIso",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "bankName",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "bankPostCode",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "bankState",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "bicSwift",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "currency",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "identifierType",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "identifierValue",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "valid",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "ENUM",
        "name": "BankDetailIdentifier",
        "enumValues": [
          {
            "name": "ABA"
          },
          {
            "name": "BIC_SWIFT"
          },
          {
            "name": "BSB_CODE"
          },
          {
            "name": "CNAPS"
          },
          {
            "name": "IBAN"
          },
          {
            "name": "ROUTING_NUMBER"
          },
          {
            "name": "SORT_CODE"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "BaseAssistantEvent",
        "fields": [
          {
            "name": "createdAt",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "DateTime",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "status",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "AssistantEventStatus",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": [],
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "AssistantBoard"
          },
          {
            "kind": "OBJECT",
            "name": "AssistantMessage"
          },
          {
            "kind": "OBJECT",
            "name": "AssistantPythonSession"
          },
          {
            "kind": "OBJECT",
            "name": "AssistantToolCall"
          },
          {
            "kind": "OBJECT",
            "name": "AssistantToolSelection"
          },
          {
            "kind": "OBJECT",
            "name": "AssistantVariableDefinitions"
          },
          {
            "kind": "OBJECT",
            "name": "AssistantWorkflowSelection"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "BaseRate",
        "fields": [
          {
            "name": "client",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Float",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "markup",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Float",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "midmarket",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Float",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": [],
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "CachedRate"
          },
          {
            "kind": "OBJECT",
            "name": "LiveRate"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "BaseResponse",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": [],
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "AddContractsToSeriesResponse"
          },
          {
            "kind": "OBJECT",
            "name": "AdminGetContractsResponse"
          },
          {
            "kind": "OBJECT",
            "name": "AdminGetCustomerOrgsResponse"
          },
          {
            "kind": "OBJECT",
            "name": "AdminUpdateContractResponse"
          },
          {
            "kind": "OBJECT",
            "name": "ApplyCreditAccountResponse"
          },
          {
            "kind": "OBJECT",
            "name": "ApproveCreditApplicationResponse"
          },
          {
            "kind": "OBJECT",
            "name": "AttachActivityFilesResponse"
          },
          {
            "kind": "OBJECT",
            "name": "AttachEventInstanceFilesResponse"
          },
          {
            "kind": "OBJECT",
            "name": "AttachScheduledEventFilesResponse"
          },
          {
            "kind": "OBJECT",
            "name": "AttachTransactionFilesResponse"
          },
          {
            "kind": "OBJECT",
            "name": "BulkPaymentAnalysisResponse"
          },
          {
            "kind": "OBJECT",
            "name": "CancelBillResponse"
          },
          {
            "kind": "OBJECT",
            "name": "CancelEventInstanceResponse"
          },
          {
            "kind": "OBJECT",
            "name": "CancelScheduledEventResponse"
          },
          {
            "kind": "OBJECT",
            "name": "CardActionResponse"
          },
          {
            "kind": "OBJECT",
            "name": "CardsResponse"
          },
          {
            "kind": "OBJECT",
            "name": "CheckRecipientInvitationTokenResponse"
          },
          {
            "kind": "OBJECT",
            "name": "CheckVerificationResponse"
          },
          {
            "kind": "OBJECT",
            "name": "CloseAccountResponse"
          },
          {
            "kind": "OBJECT",
            "name": "CloseCustomerAccountResponse"
          },
          {
            "kind": "OBJECT",
            "name": "ConnectAccountResponse"
          },
          {
            "kind": "OBJECT",
            "name": "ConnectedAccount"
          },
          {
            "kind": "OBJECT",
            "name": "ConvertVendorMissingContractResponse"
          },
          {
            "kind": "OBJECT",
            "name": "CreateAccountResponse"
          },
          {
            "kind": "OBJECT",
            "name": "CreateActivityCommentResponse"
          },
          {
            "kind": "OBJECT",
            "name": "CreateAndLinkAccountingVendorResponse"
          },
          {
            "kind": "OBJECT",
            "name": "CreateBillResponse"
          },
          {
            "kind": "OBJECT",
            "name": "CreateCardResponse"
          },
          {
            "kind": "OBJECT",
            "name": "CreateCheckDepositResponse"
          },
          {
            "kind": "OBJECT",
            "name": "CreateContractCommentResponse"
          },
          {
            "kind": "OBJECT",
            "name": "CreateContractFromProcurementRequestResponse"
          },
          {
            "kind": "OBJECT",
            "name": "CreateDepartmentResponse"
          },
          {
            "kind": "OBJECT",
            "name": "CreateEventInstanceCommentResponse"
          },
          {
            "kind": "OBJECT",
            "name": "CreateFileResponse"
          },
          {
            "kind": "OBJECT",
            "name": "CreateInvoiceResponse"
          },
          {
            "kind": "OBJECT",
            "name": "CreatePayerResponse"
          },
          {
            "kind": "OBJECT",
            "name": "CreatePlaidLinkTokenResponse"
          },
          {
            "kind": "OBJECT",
            "name": "CreateProcurementRequestResponse"
          },
          {
            "kind": "OBJECT",
            "name": "CreateRecipientUserFromInvitationResponse"
          },
          {
            "kind": "OBJECT",
            "name": "CreateScheduledEventCommentResponse"
          },
          {
            "kind": "OBJECT",
            "name": "CreateTransactionCommentResponse"
          },
          {
            "kind": "OBJECT",
            "name": "CreateVerificationResponse"
          },
          {
            "kind": "OBJECT",
            "name": "CreditAccountPaymentResponse"
          },
          {
            "kind": "OBJECT",
            "name": "CreditApplication"
          },
          {
            "kind": "OBJECT",
            "name": "CustomerResponse"
          },
          {
            "kind": "OBJECT",
            "name": "DeleteActivityCommentResponse"
          },
          {
            "kind": "OBJECT",
            "name": "DeleteContractCommentResponse"
          },
          {
            "kind": "OBJECT",
            "name": "DeleteContractsResponse"
          },
          {
            "kind": "OBJECT",
            "name": "DeleteEventInstanceCommentResponse"
          },
          {
            "kind": "OBJECT",
            "name": "DeleteScheduledEventCommentResponse"
          },
          {
            "kind": "OBJECT",
            "name": "DeleteTransactionCommentResponse"
          },
          {
            "kind": "OBJECT",
            "name": "DisableRecipientResponse"
          },
          {
            "kind": "OBJECT",
            "name": "DisconnectExternalAccountResponse"
          },
          {
            "kind": "OBJECT",
            "name": "EmptyResponse"
          },
          {
            "kind": "OBJECT",
            "name": "ExpectedApprovalInfoResponse"
          },
          {
            "kind": "OBJECT",
            "name": "ExpenseAccrualResponse"
          },
          {
            "kind": "OBJECT",
            "name": "ExpenseAccrualsResponse"
          },
          {
            "kind": "OBJECT",
            "name": "ExportAccrualsResponse"
          },
          {
            "kind": "OBJECT",
            "name": "ExportPaymentsResponse"
          },
          {
            "kind": "OBJECT",
            "name": "ExportTransactionsResponse"
          },
          {
            "kind": "OBJECT",
            "name": "FileUrlResponse"
          },
          {
            "kind": "OBJECT",
            "name": "GenerateApiKeyResponse"
          },
          {
            "kind": "OBJECT",
            "name": "GenerateDocusignAuthUrlResponse"
          },
          {
            "kind": "OBJECT",
            "name": "GenerateOAuthUrlResponse"
          },
          {
            "kind": "OBJECT",
            "name": "GenerateStripeCheckoutSessionResponse"
          },
          {
            "kind": "OBJECT",
            "name": "GenerateStripeCustomerSession"
          },
          {
            "kind": "OBJECT",
            "name": "GenerateStripePortalUrlResponse"
          },
          {
            "kind": "OBJECT",
            "name": "GenerateStripeSubscriptionResponse"
          },
          {
            "kind": "OBJECT",
            "name": "GeneratedVendorFeedbackTokenResponse"
          },
          {
            "kind": "OBJECT",
            "name": "GetAccountResponse"
          },
          {
            "kind": "OBJECT",
            "name": "GetAccountStatementResponse"
          },
          {
            "kind": "OBJECT",
            "name": "GetAccountStatementsResponse"
          },
          {
            "kind": "OBJECT",
            "name": "GetAccountingCategoriesResponse"
          },
          {
            "kind": "OBJECT",
            "name": "GetAccountingConnectionResponse"
          },
          {
            "kind": "OBJECT",
            "name": "GetAccountingCustomersResponse"
          },
          {
            "kind": "OBJECT",
            "name": "GetAccountingDefaultsResponse"
          },
          {
            "kind": "OBJECT",
            "name": "GetAccountingItemsResponse"
          },
          {
            "kind": "OBJECT",
            "name": "GetAccountingTaxRatesResponse"
          },
          {
            "kind": "OBJECT",
            "name": "GetAccountingVendorResponse"
          },
          {
            "kind": "OBJECT",
            "name": "GetAccountingVendorsResponse"
          },
          {
            "kind": "OBJECT",
            "name": "GetAccountsResponse"
          },
          {
            "kind": "OBJECT",
            "name": "GetAccrualsResponse"
          },
          {
            "kind": "OBJECT",
            "name": "GetActivationChecklistResponse"
          },
          {
            "kind": "OBJECT",
            "name": "GetActivitiesResponse"
          },
          {
            "kind": "OBJECT",
            "name": "GetActivityResponse"
          },
          {
            "kind": "OBJECT",
            "name": "GetAnnotationTasksResponse"
          },
          {
            "kind": "OBJECT",
            "name": "GetApiKeysResponse"
          },
          {
            "kind": "OBJECT",
            "name": "GetApplicationResponse"
          },
          {
            "kind": "OBJECT",
            "name": "GetApplicationsResponse"
          },
          {
            "kind": "OBJECT",
            "name": "GetAssistantBoardResponse"
          },
          {
            "kind": "OBJECT",
            "name": "GetAssistantThreadResponse"
          },
          {
            "kind": "OBJECT",
            "name": "GetAssistantThreadsResponse"
          },
          {
            "kind": "OBJECT",
            "name": "GetBillResponse"
          },
          {
            "kind": "OBJECT",
            "name": "GetBillingAddressResponse"
          },
          {
            "kind": "OBJECT",
            "name": "GetBillsEmailInboxAddressResponse"
          },
          {
            "kind": "OBJECT",
            "name": "GetBillsResponse"
          },
          {
            "kind": "OBJECT",
            "name": "GetBrandingPreferencesResponse"
          },
          {
            "kind": "OBJECT",
            "name": "GetBulkPaymentResponse"
          },
          {
            "kind": "OBJECT",
            "name": "GetCardAuthorizationsResponse"
          },
          {
            "kind": "OBJECT",
            "name": "GetConnectedAccountResponse"
          },
          {
            "kind": "OBJECT",
            "name": "GetConnectedAccountsResponse"
          },
          {
            "kind": "OBJECT",
            "name": "GetContractResponse"
          },
          {
            "kind": "OBJECT",
            "name": "GetContractsCashflowResponse"
          },
          {
            "kind": "OBJECT",
            "name": "GetContractsResponse"
          },
          {
            "kind": "OBJECT",
            "name": "GetCreditApplicationResponse"
          },
          {
            "kind": "OBJECT",
            "name": "GetCurrentUserCustomersResponse"
          },
          {
            "kind": "OBJECT",
            "name": "GetCustomerTierSettingsResponse"
          },
          {
            "kind": "OBJECT",
            "name": "GetDepartmentsResponse"
          },
          {
            "kind": "OBJECT",
            "name": "GetDocusignConnectionsResponse"
          },
          {
            "kind": "OBJECT",
            "name": "GetEligibleBusinessContactUsersResponse"
          },
          {
            "kind": "OBJECT",
            "name": "GetEventInstanceResponse"
          },
          {
            "kind": "OBJECT",
            "name": "GetEventInstancesResponse"
          },
          {
            "kind": "OBJECT",
            "name": "GetFileResponse"
          },
          {
            "kind": "OBJECT",
            "name": "GetFundingInstructionsPdfResponse"
          },
          {
            "kind": "OBJECT",
            "name": "GetGoogleConnectionResponse"
          },
          {
            "kind": "OBJECT",
            "name": "GetInvoiceResponse"
          },
          {
            "kind": "OBJECT",
            "name": "GetInvoicesResponse"
          },
          {
            "kind": "OBJECT",
            "name": "GetMultiLayerApprovalRulesResponse"
          },
          {
            "kind": "OBJECT",
            "name": "GetMultiLayerApprovalRulesVersionsResponse"
          },
          {
            "kind": "OBJECT",
            "name": "GetNominalAccountsResponse"
          },
          {
            "kind": "OBJECT",
            "name": "GetOmiUserProfileResponse"
          },
          {
            "kind": "OBJECT",
            "name": "GetOrgsWithTasksResponse"
          },
          {
            "kind": "OBJECT",
            "name": "GetPayerResponse"
          },
          {
            "kind": "OBJECT",
            "name": "GetPayersResponse"
          },
          {
            "kind": "OBJECT",
            "name": "GetPayment2Response"
          },
          {
            "kind": "OBJECT",
            "name": "GetPaymentFeesResponse"
          },
          {
            "kind": "OBJECT",
            "name": "GetPayments2Response"
          },
          {
            "kind": "OBJECT",
            "name": "GetPendingCreditAccountRepaymentsResponse"
          },
          {
            "kind": "OBJECT",
            "name": "GetPendingCreditApplicationsResponse"
          },
          {
            "kind": "OBJECT",
            "name": "GetPreferencesResponse"
          },
          {
            "kind": "OBJECT",
            "name": "GetProcurementRequestsResponse"
          },
          {
            "kind": "OBJECT",
            "name": "GetRatesResponse"
          },
          {
            "kind": "OBJECT",
            "name": "GetRecipientInvitationsResponse"
          },
          {
            "kind": "OBJECT",
            "name": "GetRecipientPaymentResponse"
          },
          {
            "kind": "OBJECT",
            "name": "GetRecipientPaymentsResponse"
          },
          {
            "kind": "OBJECT",
            "name": "GetRecipientResponse"
          },
          {
            "kind": "OBJECT",
            "name": "GetRecipientTaxFormResponse"
          },
          {
            "kind": "OBJECT",
            "name": "GetRecipientsResponse"
          },
          {
            "kind": "OBJECT",
            "name": "GetRecipientsWithoutContractResponse"
          },
          {
            "kind": "OBJECT",
            "name": "GetScheduledEventResponse"
          },
          {
            "kind": "OBJECT",
            "name": "GetScheduledEventsResponse"
          },
          {
            "kind": "OBJECT",
            "name": "GetSheetsTierSettingsResponse"
          },
          {
            "kind": "OBJECT",
            "name": "GetSlackConnectionResponse"
          },
          {
            "kind": "OBJECT",
            "name": "GetTransactionResponse"
          },
          {
            "kind": "OBJECT",
            "name": "GetTransactionsResponse"
          },
          {
            "kind": "OBJECT",
            "name": "GetVendorFeedbackFormDataResponse"
          },
          {
            "kind": "OBJECT",
            "name": "GetVendorFeedbackResponse"
          },
          {
            "kind": "OBJECT",
            "name": "GetVendorsMissingContractsResponse"
          },
          {
            "kind": "OBJECT",
            "name": "GetVerificationLetterResponse"
          },
          {
            "kind": "OBJECT",
            "name": "GetWireAmountForExternalFundingResponse"
          },
          {
            "kind": "OBJECT",
            "name": "InitiateACHDebitResponse"
          },
          {
            "kind": "OBJECT",
            "name": "InviteRecipientResponse"
          },
          {
            "kind": "OBJECT",
            "name": "InviteUserResponse"
          },
          {
            "kind": "OBJECT",
            "name": "LinkAccountingVendorResponse"
          },
          {
            "kind": "OBJECT",
            "name": "LinkManuallyVerifiedPlaidAccountResponse"
          },
          {
            "kind": "OBJECT",
            "name": "LiteGetCurrentUserProfileResponse"
          },
          {
            "kind": "OBJECT",
            "name": "LiteInviteUserResponse"
          },
          {
            "kind": "OBJECT",
            "name": "MapDocVaultFormFieldsResponse"
          },
          {
            "kind": "OBJECT",
            "name": "OverrideRecipientTINVerificationResponse"
          },
          {
            "kind": "OBJECT",
            "name": "PayPalCredentialsResponse"
          },
          {
            "kind": "OBJECT",
            "name": "PaymentTimelineResponse"
          },
          {
            "kind": "OBJECT",
            "name": "ProcessAssistantMessageResponse"
          },
          {
            "kind": "OBJECT",
            "name": "ReplaceCardResponse"
          },
          {
            "kind": "OBJECT",
            "name": "RequestInternalTransferResponse"
          },
          {
            "kind": "OBJECT",
            "name": "RequestPaymentsResponse"
          },
          {
            "kind": "OBJECT",
            "name": "RequestRecipientFromInvitationResponse"
          },
          {
            "kind": "OBJECT",
            "name": "RequestRecipientResponse"
          },
          {
            "kind": "OBJECT",
            "name": "RequestTINNameMatchResponse"
          },
          {
            "kind": "OBJECT",
            "name": "ResetUserMFAResponse"
          },
          {
            "kind": "OBJECT",
            "name": "ResolvePaymentResult"
          },
          {
            "kind": "OBJECT",
            "name": "ResolvePaymentsResponse"
          },
          {
            "kind": "OBJECT",
            "name": "ResolveProcurementRequestResponse"
          },
          {
            "kind": "OBJECT",
            "name": "ResolveRecipientRequestResponse"
          },
          {
            "kind": "OBJECT",
            "name": "ResolveRecipientRequestsResponse"
          },
          {
            "kind": "OBJECT",
            "name": "RevokeApiKeyResponse"
          },
          {
            "kind": "OBJECT",
            "name": "RevokeRecipientInvitationResponse"
          },
          {
            "kind": "OBJECT",
            "name": "SetActiveContractVersionResponse"
          },
          {
            "kind": "OBJECT",
            "name": "SetDefaultsResponse"
          },
          {
            "kind": "OBJECT",
            "name": "SetMultiLayerApprovalRulesResponse"
          },
          {
            "kind": "OBJECT",
            "name": "SuperSheetsPaymentResponse"
          },
          {
            "kind": "OBJECT",
            "name": "SuperSheetsPaymentsResponse"
          },
          {
            "kind": "OBJECT",
            "name": "ToggleCustomerFeatureFlagResponse"
          },
          {
            "kind": "OBJECT",
            "name": "ToggleCustomerFreezeResponse"
          },
          {
            "kind": "OBJECT",
            "name": "UpdateAccountResponse"
          },
          {
            "kind": "OBJECT",
            "name": "UpdateBillResponse"
          },
          {
            "kind": "OBJECT",
            "name": "UpdateBusinessContactResponse"
          },
          {
            "kind": "OBJECT",
            "name": "UpdateCardResponse"
          },
          {
            "kind": "OBJECT",
            "name": "UpdateContractCashflowPeriodDatesResponse"
          },
          {
            "kind": "OBJECT",
            "name": "UpdateContractCashflowPeriodTotalsResponse"
          },
          {
            "kind": "OBJECT",
            "name": "UpdateContractResponse"
          },
          {
            "kind": "OBJECT",
            "name": "UpdateCustomerInfoResponse"
          },
          {
            "kind": "OBJECT",
            "name": "UpdateCustomerTierResponse"
          },
          {
            "kind": "OBJECT",
            "name": "UpdateInvoiceStatusResponse"
          },
          {
            "kind": "OBJECT",
            "name": "UpdateLevroOpsUserRoleResponse"
          },
          {
            "kind": "OBJECT",
            "name": "UpdateProcurementRequestResponse"
          },
          {
            "kind": "OBJECT",
            "name": "UpdateRecipientResponse"
          },
          {
            "kind": "OBJECT",
            "name": "UserResponse"
          },
          {
            "kind": "OBJECT",
            "name": "UserRolesInfo"
          },
          {
            "kind": "OBJECT",
            "name": "UsersResponse"
          },
          {
            "kind": "OBJECT",
            "name": "VerifyDocumentResponse"
          },
          {
            "kind": "OBJECT",
            "name": "WriteActivityNoteResponse"
          },
          {
            "kind": "OBJECT",
            "name": "WriteAnnotationResponse"
          },
          {
            "kind": "OBJECT",
            "name": "WriteEventInstanceNoteResponse"
          },
          {
            "kind": "OBJECT",
            "name": "WriteScheduledEventNoteResponse"
          },
          {
            "kind": "OBJECT",
            "name": "WriteTransactionNoteResponse"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "BaseWidget",
        "fields": [
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "title",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": [],
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "AccountsWidget"
          },
          {
            "kind": "OBJECT",
            "name": "ApprovalFlowWidget"
          },
          {
            "kind": "OBJECT",
            "name": "BillDetailsWidget"
          },
          {
            "kind": "OBJECT",
            "name": "BillPayWidget"
          },
          {
            "kind": "OBJECT",
            "name": "BillTableWidget"
          },
          {
            "kind": "OBJECT",
            "name": "CardActionWidget"
          },
          {
            "kind": "OBJECT",
            "name": "CheckDepositWidget"
          },
          {
            "kind": "OBJECT",
            "name": "ContractCashflowWidget"
          },
          {
            "kind": "OBJECT",
            "name": "ContractDetailsWidget"
          },
          {
            "kind": "OBJECT",
            "name": "ContractTableWidget"
          },
          {
            "kind": "OBJECT",
            "name": "CreateConversionWidget"
          },
          {
            "kind": "OBJECT",
            "name": "CreateInvoiceWidget"
          },
          {
            "kind": "OBJECT",
            "name": "CreateRecipientWidget"
          },
          {
            "kind": "OBJECT",
            "name": "DownloadStatementsWidget"
          },
          {
            "kind": "OBJECT",
            "name": "FxRateHistoryWidget"
          },
          {
            "kind": "OBJECT",
            "name": "InvalidWidget"
          },
          {
            "kind": "OBJECT",
            "name": "PaymentDetailsWidget"
          },
          {
            "kind": "OBJECT",
            "name": "PaymentTableWidget"
          },
          {
            "kind": "OBJECT",
            "name": "RecipientTableWidget"
          },
          {
            "kind": "OBJECT",
            "name": "SendBulkPaymentWidget"
          },
          {
            "kind": "OBJECT",
            "name": "SendPaymentWidget"
          },
          {
            "kind": "OBJECT",
            "name": "StaticContentWidget"
          },
          {
            "kind": "OBJECT",
            "name": "TableWidget"
          },
          {
            "kind": "OBJECT",
            "name": "TransactionTableWidget"
          },
          {
            "kind": "OBJECT",
            "name": "UpdateCustomerInfoWidget"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "BaseWidgetStatus",
        "fields": [
          {
            "name": "status",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "WidgetStatusCategory",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": [],
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "BulkPaymentWidgetStatus"
          },
          {
            "kind": "OBJECT",
            "name": "CreateRecipientWidgetStatus"
          },
          {
            "kind": "OBJECT",
            "name": "SendPaymentWidgetStatus"
          },
          {
            "kind": "OBJECT",
            "name": "WidgetStatus"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "Bill",
        "fields": [
          {
            "name": "attachments",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "File",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "createdAt",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "DateTime",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "details",
            "type": {
              "kind": "OBJECT",
              "name": "BillDetails",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "payment",
            "type": {
              "kind": "UNION",
              "name": "BillPayment",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "provenance",
            "type": {
              "kind": "OBJECT",
              "name": "BillProvenance",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "status",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "BillStatus",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "summary",
            "type": {
              "kind": "OBJECT",
              "name": "BillSummary",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "BillAccountingItem",
        "fields": [
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "status",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "AccountingItemStatus",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "type",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "AccountingItemType",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "BillDetails",
        "fields": [
          {
            "name": "billPaymentNominalAccount",
            "type": {
              "kind": "OBJECT",
              "name": "NominalAccount",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "lineItems",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "BillLineItem",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "parsedRecipient",
            "type": {
              "kind": "OBJECT",
              "name": "ParsedRecipient",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "recipient",
            "type": {
              "kind": "OBJECT",
              "name": "Recipient",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "BillDetailsWidget",
        "fields": [
          {
            "name": "bill",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "Bill",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "title",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseWidget"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "BillLineItem",
        "fields": [
          {
            "name": "accountingClass",
            "type": {
              "kind": "OBJECT",
              "name": "AccountingCategory",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "accountingCustomer",
            "type": {
              "kind": "OBJECT",
              "name": "AccountingCustomer",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "accountingDepartment",
            "type": {
              "kind": "OBJECT",
              "name": "AccountingCategory",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "accountingItem",
            "type": {
              "kind": "OBJECT",
              "name": "BillAccountingItem",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "accountingLocation",
            "type": {
              "kind": "OBJECT",
              "name": "AccountingCategory",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "accountingTaxRate",
            "type": {
              "kind": "OBJECT",
              "name": "AccountingTaxRate",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "billId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "billable",
            "type": {
              "kind": "SCALAR",
              "name": "Boolean",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "description",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "nominalAccount",
            "type": {
              "kind": "OBJECT",
              "name": "NominalAccount",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "ordinal",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "quantity",
            "type": {
              "kind": "SCALAR",
              "name": "Float",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "subTotal",
            "type": {
              "kind": "SCALAR",
              "name": "Float",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "tax",
            "type": {
              "kind": "SCALAR",
              "name": "Float",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "total",
            "type": {
              "kind": "SCALAR",
              "name": "Float",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "unitAmount",
            "type": {
              "kind": "SCALAR",
              "name": "Float",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "BillLineItemInput",
        "inputFields": [
          {
            "name": "accountingClassId",
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "accountingCustomerId",
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "accountingDepartmentId",
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "accountingItemId",
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "accountingLocationId",
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "accountingTaxRateId",
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "billable",
            "type": {
              "kind": "SCALAR",
              "name": "Boolean",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "description",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            }
          },
          {
            "name": "nominalAccountId",
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "ordinal",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            }
          },
          {
            "name": "quantity",
            "type": {
              "kind": "SCALAR",
              "name": "Float",
              "ofType": null
            }
          },
          {
            "name": "subTotal",
            "type": {
              "kind": "SCALAR",
              "name": "Float",
              "ofType": null
            }
          },
          {
            "name": "tax",
            "type": {
              "kind": "SCALAR",
              "name": "Float",
              "ofType": null
            }
          },
          {
            "name": "total",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Float",
                "ofType": null
              }
            }
          },
          {
            "name": "unitAmount",
            "type": {
              "kind": "SCALAR",
              "name": "Float",
              "ofType": null
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "BillPayLineItemPreferences",
        "fields": [
          {
            "name": "showBillable",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ToggleConstrainedValue",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "showClass",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ToggleConstrainedValue",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "showCustomer",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ToggleConstrainedValue",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "showDepartment",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ToggleConstrainedValue",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "showLocation",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ToggleConstrainedValue",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "BillPayLineItemPreferencesInput",
        "inputFields": [
          {
            "name": "showBillable",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "ToggleValueInput",
              "ofType": null
            }
          },
          {
            "name": "showClass",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "ToggleValueInput",
              "ofType": null
            }
          },
          {
            "name": "showCustomer",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "ToggleValueInput",
              "ofType": null
            }
          },
          {
            "name": "showDepartment",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "ToggleValueInput",
              "ofType": null
            }
          },
          {
            "name": "showLocation",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "ToggleValueInput",
              "ofType": null
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "BillPayPreferences",
        "fields": [
          {
            "name": "lineItems",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "BillPayLineItemPreferences",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "showNominalPaymentAccounts",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ToggleConstrainedValue",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "BillPayPreferencesInput",
        "inputFields": [
          {
            "name": "lineItems",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BillPayLineItemPreferencesInput",
              "ofType": null
            }
          },
          {
            "name": "showNominalPaymentAccounts",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "ToggleValueInput",
              "ofType": null
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "BillPayWidget",
        "fields": [
          {
            "name": "bill",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "Bill",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "title",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseWidget"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "BillPayment",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "Activity"
          },
          {
            "kind": "OBJECT",
            "name": "ScheduledPayment"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "BillProcessingState",
        "fields": [
          {
            "name": "expectedProcessingTimeSeconds",
            "type": {
              "kind": "SCALAR",
              "name": "Float",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "status",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "BillStatus",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "BillProvenance",
        "fields": [
          {
            "name": "invoiceEmail",
            "type": {
              "kind": "OBJECT",
              "name": "InvoiceEmail",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "invoiceFile",
            "type": {
              "kind": "OBJECT",
              "name": "File",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "ENUM",
        "name": "BillStatus",
        "enumValues": [
          {
            "name": "CANCELED"
          },
          {
            "name": "FULLY_APPROVED"
          },
          {
            "name": "NO_INVOICE_PROCESSED"
          },
          {
            "name": "OVERWRITTEN"
          },
          {
            "name": "PAID"
          },
          {
            "name": "PENDING_APPROVAL"
          },
          {
            "name": "PROCESSED"
          },
          {
            "name": "PROCESSING"
          },
          {
            "name": "PROCESSING_FAILED"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "BillSummary",
        "fields": [
          {
            "name": "amount",
            "type": {
              "kind": "SCALAR",
              "name": "Float",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "billDate",
            "type": {
              "kind": "SCALAR",
              "name": "Date",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "currency",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "description",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "dueDate",
            "type": {
              "kind": "SCALAR",
              "name": "Date",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "invoiceNumber",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "method",
            "type": {
              "kind": "ENUM",
              "name": "PaymentMethod",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "reason",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "recipientName",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "BillTableWidget",
        "fields": [
          {
            "name": "bills",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "Bill",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "title",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseWidget"
          }
        ]
      },
      {
        "kind": "ENUM",
        "name": "BillingTerms",
        "enumValues": [
          {
            "name": "AD_HOC"
          },
          {
            "name": "DAILY"
          },
          {
            "name": "MONTHLY"
          },
          {
            "name": "QUARTERLY"
          },
          {
            "name": "WEEKLY"
          },
          {
            "name": "YEARLY"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "BlobConstrainedValue",
        "fields": [
          {
            "name": "blob",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "isDefault",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "version",
            "type": {
              "kind": "SCALAR",
              "name": "Int",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "BlobValueInput",
        "inputFields": [
          {
            "name": "blob",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            }
          },
          {
            "name": "version",
            "type": {
              "kind": "SCALAR",
              "name": "Int",
              "ofType": null
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "BoolBulkPaymentColumn",
        "fields": [
          {
            "name": "sourceColumn",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "values",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "SCALAR",
                  "name": "Boolean",
                  "ofType": null
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "SCALAR",
        "name": "Boolean"
      },
      {
        "kind": "OBJECT",
        "name": "BrandingPreferences",
        "fields": [
          {
            "name": "logoFile",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "FileConstrainedValue",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "primaryColorHex",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "TextConstrainedValue",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "secondaryColorHex",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "TextConstrainedValue",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "BrandingPreferencesInput",
        "inputFields": [
          {
            "name": "logoFile",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "FileValueInput",
              "ofType": null
            }
          },
          {
            "name": "primaryColorHex",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "TextValueInput",
              "ofType": null
            }
          },
          {
            "name": "secondaryColorHex",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "TextValueInput",
              "ofType": null
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "BulkPayment",
        "fields": [
          {
            "name": "files",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "File",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "BulkPaymentAnalysisResponse",
        "fields": [
          {
            "name": "coverWireFees",
            "type": {
              "kind": "OBJECT",
              "name": "BoolBulkPaymentColumn",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "destinationAmount",
            "type": {
              "kind": "OBJECT",
              "name": "FloatBulkPaymentColumn",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "destinationCurrency",
            "type": {
              "kind": "OBJECT",
              "name": "StrBulkPaymentColumn",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "invoiceDate",
            "type": {
              "kind": "OBJECT",
              "name": "DateBulkPaymentColumn",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "invoiceNumber",
            "type": {
              "kind": "OBJECT",
              "name": "StrBulkPaymentColumn",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "levroRecipientId",
            "type": {
              "kind": "OBJECT",
              "name": "StrBulkPaymentColumn",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "method",
            "type": {
              "kind": "OBJECT",
              "name": "PaymentMethodBulkPaymentColumn",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "numRows",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "purposeCode",
            "type": {
              "kind": "OBJECT",
              "name": "StrBulkPaymentColumn",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "reason",
            "type": {
              "kind": "OBJECT",
              "name": "StrBulkPaymentColumn",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "recipientEmail",
            "type": {
              "kind": "OBJECT",
              "name": "StrBulkPaymentColumn",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "recipientName",
            "type": {
              "kind": "OBJECT",
              "name": "StrBulkPaymentColumn",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "reference",
            "type": {
              "kind": "OBJECT",
              "name": "StrBulkPaymentColumn",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "sourceAmount",
            "type": {
              "kind": "OBJECT",
              "name": "FloatBulkPaymentColumn",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "sourceCurrency",
            "type": {
              "kind": "OBJECT",
              "name": "StrBulkPaymentColumn",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "unmappedColumns",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "UnmappedBulkPaymentColumn",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "BulkPaymentWidgetStatus",
        "fields": [
          {
            "name": "bulkPaymentId",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "status",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "WidgetStatusCategory",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseWidgetStatus"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "CADAccountDetails",
        "fields": [
          {
            "name": "accountHolder",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "accountNumber",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "accountNumberIsIban",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "bankAddress",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "bankName",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "branchTransitNumber",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "institutionNumber",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "localPaymentRailName",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "routingCode",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "swift",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "SWIFTAccountDetails",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "transitNumberMicr",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "AccountDetailsWithLocalPayIns"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "CachedRate",
        "fields": [
          {
            "name": "asOf",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "DateTime",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "client",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Float",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "markup",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Float",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "midmarket",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Float",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseRate"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "CancelBillInput",
        "inputFields": [
          {
            "name": "billId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "CancelBillResponse",
        "fields": [
          {
            "name": "bill",
            "type": {
              "kind": "OBJECT",
              "name": "Bill",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "CancelEventInstanceInput",
        "inputFields": [
          {
            "name": "eventId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            }
          },
          {
            "name": "ordinal",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "CancelEventInstanceResponse",
        "fields": [
          {
            "name": "canceled",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "eventInstance",
            "type": {
              "kind": "UNION",
              "name": "EventInstance",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "CancelScheduledEventInput",
        "inputFields": [
          {
            "name": "eventId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "CancelScheduledEventResponse",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "event",
            "type": {
              "kind": "UNION",
              "name": "ScheduledEvent",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "CannotReduceRecipientManagerPermissionError",
        "fields": [
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "nRecipientsManaged",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "path",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "SCALAR",
                  "name": "String",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "stackTrace",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "ErrorInterface"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "CannotUpdateBusinessContactRoleError",
        "fields": [
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "path",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "SCALAR",
                  "name": "String",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "stackTrace",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "ErrorInterface"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "Card",
        "fields": [
          {
            "name": "billingAddress",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "Address",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "cardHolderEmail",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "cardHolderFullName",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "cardHolderPhone",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "cardLast4",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "cardLimit",
            "type": {
              "kind": "UNION",
              "name": "CardLimit",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "cardName",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "cardType",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "CardType",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "expirationDate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Date",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "funding",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "FundingType",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "pinStatus",
            "type": {
              "kind": "ENUM",
              "name": "PinStatus",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "shippingAddress",
            "type": {
              "kind": "OBJECT",
              "name": "Address",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "status",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "CardStatus",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "userId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "CardActionResponse",
        "fields": [
          {
            "name": "card",
            "type": {
              "kind": "OBJECT",
              "name": "Card",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "CardActionWidget",
        "fields": [
          {
            "name": "action",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "cardId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "status",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "WidgetStatus",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "title",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseWidget"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "CardAuthorization",
        "fields": [
          {
            "name": "amount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "Money",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "cardLast4",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "createdAt",
            "type": {
              "kind": "SCALAR",
              "name": "DateTime",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "metadata",
            "type": {
              "kind": "UNION",
              "name": "CardTransactionMetadata",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "status",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "CardAuthorizationStatus",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "summary",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "ENUM",
        "name": "CardAuthorizationStatus",
        "enumValues": [
          {
            "name": "AUTHORIZED"
          },
          {
            "name": "CANCELED"
          },
          {
            "name": "COMPLETED"
          },
          {
            "name": "DECLINED"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "CardLimit",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "CreditCardLimit"
          },
          {
            "kind": "OBJECT",
            "name": "DebitCardLimit"
          }
        ]
      },
      {
        "kind": "ENUM",
        "name": "CardPaymentMethod",
        "enumValues": [
          {
            "name": "CHIP_AND_PIN"
          },
          {
            "name": "CONTACTLESS"
          },
          {
            "name": "MANUAL"
          },
          {
            "name": "OTHER"
          },
          {
            "name": "STORED"
          },
          {
            "name": "SWIPE"
          }
        ]
      },
      {
        "kind": "ENUM",
        "name": "CardStatus",
        "enumValues": [
          {
            "name": "ACTIVE"
          },
          {
            "name": "CLOSED_BY_CUSTOMER"
          },
          {
            "name": "FROZEN"
          },
          {
            "name": "INACTIVE"
          },
          {
            "name": "LOST"
          },
          {
            "name": "STOLEN"
          },
          {
            "name": "SUSPECTED_FRAUD"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "CardTransactionMetadata",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "AtmTransactionMetadata"
          },
          {
            "kind": "OBJECT",
            "name": "PurchaseTransactionMetadata"
          }
        ]
      },
      {
        "kind": "ENUM",
        "name": "CardTransactionType",
        "enumValues": [
          {
            "name": "ATM"
          },
          {
            "name": "CARD"
          },
          {
            "name": "CARD_REVERSAL"
          },
          {
            "name": "PURCHASE"
          }
        ]
      },
      {
        "kind": "ENUM",
        "name": "CardType",
        "enumValues": [
          {
            "name": "PHYSICAL"
          },
          {
            "name": "VIRTUAL"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "CardsInput",
        "inputFields": [
          {
            "name": "accountId",
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "cardHolderUserId",
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "cardId",
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "funding",
            "type": {
              "kind": "ENUM",
              "name": "FundingType",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "paginationInput",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "PaginationInput",
              "ofType": null
            },
            "defaultValue": "null"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "CardsResponse",
        "fields": [
          {
            "name": "cards",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "Card",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "pageInfo",
            "type": {
              "kind": "OBJECT",
              "name": "Pagination",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          },
          {
            "kind": "INTERFACE",
            "name": "PaginatedResponse"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "CashManagementVariancePeriodData",
        "fields": [
          {
            "name": "actual",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "MultiCurrencyMoney",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "actualIncludesUnpaidBill",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "planned",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "MultiCurrencyMoneyFormula",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "plannedIsAverageFromNPeriods",
            "type": {
              "kind": "SCALAR",
              "name": "Int",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "variance",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "MultiCurrencyMoneyFormula",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "CheckDepositWidget",
        "fields": [
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "title",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseWidget"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "CheckRecipientInvitationTokenResponse",
        "fields": [
          {
            "name": "activeFeatures",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "ENUM",
                    "name": "FeatureFlag",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "recipientInvitation",
            "type": {
              "kind": "OBJECT",
              "name": "RecipientInvitationForRecipient",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "CheckVerificationForCustomerInput",
        "inputFields": [
          {
            "name": "code",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "CheckVerificationInput",
        "inputFields": [
          {
            "name": "code",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            }
          },
          {
            "name": "phoneNumber",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "CheckVerificationResponse",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "success",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "CheckingAccountStatement",
        "fields": [
          {
            "name": "account",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "Account",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "balance",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "CreditStatementBalance",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "csvUrl",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "html",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "pdfUrl",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "period",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "Period",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "qboUrl",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "statementDate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Date",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "AccountStatementInterface"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "ChecklistItem",
        "fields": [
          {
            "name": "status",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "ChecklistItemStatus",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": [],
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "ActivationChecklistItem"
          }
        ]
      },
      {
        "kind": "ENUM",
        "name": "ChecklistItemStatus",
        "enumValues": [
          {
            "name": "COMPLETE"
          },
          {
            "name": "INCOMPLETE"
          },
          {
            "name": "PENDING"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "CloseAccountInput",
        "inputFields": [
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "CloseAccountResponse",
        "fields": [
          {
            "name": "account",
            "type": {
              "kind": "OBJECT",
              "name": "Account",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "CloseCustomerAccountInput",
        "inputFields": [
          {
            "name": "customerId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            }
          },
          {
            "name": "reason",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "CloseReason",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "CloseCustomerAccountResponse",
        "fields": [
          {
            "name": "customer",
            "type": {
              "kind": "OBJECT",
              "name": "Customer",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "ENUM",
        "name": "CloseReason",
        "enumValues": [
          {
            "name": "BREACH_OF_TC"
          },
          {
            "name": "BY_BANK"
          },
          {
            "name": "BY_BANK_SUSPECTED_FRAUD"
          },
          {
            "name": "BY_CUSTOMER"
          },
          {
            "name": "FRAUD"
          },
          {
            "name": "NEGATIVE_BALANCE"
          },
          {
            "name": "NO_ACCOUNT_ACTIVITY"
          },
          {
            "name": "OVERDUE"
          },
          {
            "name": "PROGRAM_CHANGE"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "Comment",
        "fields": [
          {
            "name": "author",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "User",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "content",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "createdAt",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "DateTime",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "deleted",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "CommentInput",
        "inputFields": [
          {
            "name": "content",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "ComplianceError",
        "fields": [
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "path",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "SCALAR",
                  "name": "String",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "stackTrace",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "ErrorInterface"
          }
        ]
      },
      {
        "kind": "ENUM",
        "name": "Confidence",
        "enumValues": [
          {
            "name": "PARSED_CERTAIN"
          },
          {
            "name": "PARSED_UNCERTAIN"
          },
          {
            "name": "USER_VALIDATED"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "ConnectAccountInput",
        "inputFields": [
          {
            "name": "plaidAccounts",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "PlaidAccount",
                    "ofType": null
                  }
                }
              }
            }
          },
          {
            "name": "publicPlaidToken",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "ConnectAccountResponse",
        "fields": [
          {
            "name": "accounts",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "ConnectedAccount",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "ConnectedAccount",
        "fields": [
          {
            "name": "accountNumberLast4",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "accountType",
            "type": {
              "kind": "ENUM",
              "name": "AccountType",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "balances",
            "type": {
              "kind": "OBJECT",
              "name": "ConnectedAccountBalances",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "bankName",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "isAutoPay",
            "type": {
              "kind": "SCALAR",
              "name": "Boolean",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "recipientId",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "routingNumber",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "ConnectedAccountBalances",
        "fields": [
          {
            "name": "availableBalance",
            "type": {
              "kind": "OBJECT",
              "name": "Money",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "currentBalance",
            "type": {
              "kind": "OBJECT",
              "name": "Money",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "PlaidError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "isMicrodepositAccount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ConsolidatedAccountStatement",
        "fields": [
          {
            "name": "csvZipUrl",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "pdfZipUrl",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "period",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "Period",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "qboZipUrl",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "statementDate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Date",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "Contract",
        "fields": [
          {
            "name": "accountingCategories",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "AccountingCategory",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "allVersions",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "Contract",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "annualContractValue",
            "type": {
              "kind": "OBJECT",
              "name": "MoneyFormula",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "autoRenews",
            "type": {
              "kind": "SCALAR",
              "name": "Boolean",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "billingTerms",
            "type": {
              "kind": "ENUM",
              "name": "BillingTerms",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "comments",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "Comment",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "confidences",
            "type": {
              "kind": "OBJECT",
              "name": "ContractConfidences",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "department",
            "type": {
              "kind": "OBJECT",
              "name": "Department",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "displayName",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "endDate",
            "type": {
              "kind": "SCALAR",
              "name": "Date",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "file",
            "type": {
              "kind": "OBJECT",
              "name": "File",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "gated",
            "type": {
              "kind": "SCALAR",
              "name": "Boolean",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "hasEnded",
            "type": {
              "kind": "SCALAR",
              "name": "Boolean",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "isActiveVersion",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "isSample",
            "type": {
              "kind": "SCALAR",
              "name": "Boolean",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "locations",
            "type": {
              "kind": "OBJECT",
              "name": "ContractLocations",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "nominalAccounts",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "NominalAccount",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "notValidatedFieldsOmitted",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "notes",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "noticePeriodDays",
            "type": {
              "kind": "SCALAR",
              "name": "Int",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "owner",
            "type": {
              "kind": "OBJECT",
              "name": "User",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "ownerName",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "parsedRecipient",
            "type": {
              "kind": "OBJECT",
              "name": "ParsedRecipient",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "paymentObligations",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "ContractPaymentObligation",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "paymentSummary",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "paymentTerms",
            "type": {
              "kind": "OBJECT",
              "name": "PaymentTerms",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "processingStatus",
            "type": {
              "kind": "ENUM",
              "name": "ContractProcessingStatus",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "purchaseOrderId",
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "recipient",
            "type": {
              "kind": "OBJECT",
              "name": "Recipient",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "recipientDisplayName",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "renewalDate",
            "type": {
              "kind": "SCALAR",
              "name": "Date",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "signatureDate",
            "type": {
              "kind": "SCALAR",
              "name": "Date",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "startDate",
            "type": {
              "kind": "SCALAR",
              "name": "Date",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "status",
            "type": {
              "kind": "ENUM",
              "name": "ContractStatus",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "termsUrls",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "SCALAR",
                  "name": "String",
                  "ofType": null
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ContractAnnotationObject",
        "fields": [
          {
            "name": "termsUrls",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "SCALAR",
                  "name": "String",
                  "ofType": null
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ContractCashflowWidget",
        "fields": [
          {
            "name": "cashflow",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ContractsCashflow",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "title",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseWidget"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "ContractConfidences",
        "fields": [
          {
            "name": "annualContractValueConfidence",
            "type": {
              "kind": "ENUM",
              "name": "Confidence",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "autoRenewsConfidence",
            "type": {
              "kind": "ENUM",
              "name": "Confidence",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "billingFrequencyConfidence",
            "type": {
              "kind": "ENUM",
              "name": "Confidence",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "endDateConfidence",
            "type": {
              "kind": "ENUM",
              "name": "Confidence",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "noticePeriodDaysConfidence",
            "type": {
              "kind": "ENUM",
              "name": "Confidence",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "paymentTermsConfidence",
            "type": {
              "kind": "ENUM",
              "name": "Confidence",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "recipientConfidence",
            "type": {
              "kind": "ENUM",
              "name": "Confidence",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "renewalDateConfidence",
            "type": {
              "kind": "ENUM",
              "name": "Confidence",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "signatureDateConfidence",
            "type": {
              "kind": "ENUM",
              "name": "Confidence",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "startDateConfidence",
            "type": {
              "kind": "ENUM",
              "name": "Confidence",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ContractDetailsWidget",
        "fields": [
          {
            "name": "contract",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "Contract",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "title",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseWidget"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "ContractLocations",
        "fields": [
          {
            "name": "autoRenewsLocation",
            "type": {
              "kind": "OBJECT",
              "name": "Location",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "billingFrequencyLocation",
            "type": {
              "kind": "OBJECT",
              "name": "Location",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "endDateLocation",
            "type": {
              "kind": "OBJECT",
              "name": "Location",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "noticePeriodDaysLocation",
            "type": {
              "kind": "OBJECT",
              "name": "Location",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "paymentTermsLocation",
            "type": {
              "kind": "OBJECT",
              "name": "Location",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "paymentsLocations",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PaymentsLocations",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "recipientLocations",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "RecipientLocations",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "renewalDateLocation",
            "type": {
              "kind": "OBJECT",
              "name": "Location",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "signatureDateLocation",
            "type": {
              "kind": "OBJECT",
              "name": "Location",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "startDateLocation",
            "type": {
              "kind": "OBJECT",
              "name": "Location",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ContractPaymentObligation",
        "fields": [
          {
            "name": "amount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "VariableMoney",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "billDate",
            "type": {
              "kind": "SCALAR",
              "name": "Date",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "contractId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "dueDate",
            "type": {
              "kind": "SCALAR",
              "name": "Date",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "hasVariableComponent",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "purpose",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "ContractPaymentObligationInput",
        "inputFields": [
          {
            "name": "amount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "INPUT_OBJECT",
                "name": "VariableMoneyInput",
                "ofType": null
              }
            }
          },
          {
            "name": "billDate",
            "type": {
              "kind": "SCALAR",
              "name": "Date",
              "ofType": null
            }
          },
          {
            "name": "hasVariableComponent",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            }
          },
          {
            "name": "id",
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "idempotencyKey",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "purpose",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "ENUM",
        "name": "ContractProcessingStatus",
        "enumValues": [
          {
            "name": "DELETED"
          },
          {
            "name": "FAILED"
          },
          {
            "name": "PROCESSED"
          },
          {
            "name": "PROCESSING"
          }
        ]
      },
      {
        "kind": "ENUM",
        "name": "ContractStatus",
        "enumValues": [
          {
            "name": "ACTIVE"
          },
          {
            "name": "COMPLETED"
          },
          {
            "name": "UPCOMING"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "ContractTableWidget",
        "fields": [
          {
            "name": "contracts",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "Contract",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "title",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseWidget"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "ContractsCashManagementPeriod",
        "fields": [
          {
            "name": "endDate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Date",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "isAggregate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "label",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "startDate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Date",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ContractsCashManagementRecipient",
        "fields": [
          {
            "name": "accountingDataOnly",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "amounts",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "CashManagementVariancePeriodData",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "contracts",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "Contract",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ContractsCashflow",
        "fields": [
          {
            "name": "cells",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "OBJECT",
                        "name": "ContractsCashflowCell",
                        "ofType": null
                      }
                    }
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "columnAggregates",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "ContractsCashflowAggregate",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "columnMetadata",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "ContractsCashflowColumnMetadata",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "rowAggregateColumnMetadata",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "ContractsCashflowColumnMetadata",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "rowAggregates",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "OBJECT",
                        "name": "ContractsCashflowAggregate",
                        "ofType": null
                      }
                    }
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "rowMetadata",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "ContractsCashflowRowMetadata",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "tableAggregates",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "ContractsCashflowAggregate",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ContractsCashflowAggregate",
        "fields": [
          {
            "name": "perCurrencyTotals",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "MoneyFormula",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "ENUM",
        "name": "ContractsCashflowAggregatePeriod",
        "enumValues": [
          {
            "name": "MONTH"
          },
          {
            "name": "QUARTER"
          },
          {
            "name": "WEEKS_13"
          },
          {
            "name": "YEAR"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "ContractsCashflowCell",
        "fields": [
          {
            "name": "perCurrencyTotals",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "MoneyFormula",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ContractsCashflowColumnMetadata",
        "fields": [
          {
            "name": "periodEnd",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Date",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "periodLabel",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "periodStart",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Date",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ContractsCashflowContractRowMetadata",
        "fields": [
          {
            "name": "contract",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "Contract",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ContractsCashflowDepartmentRowMetadata",
        "fields": [
          {
            "name": "contracts",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "Contract",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "department",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "Department",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ContractsCashflowOwnerRowMetadata",
        "fields": [
          {
            "name": "contracts",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "Contract",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "ownerName",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ContractsCashflowRecipientRowMetadata",
        "fields": [
          {
            "name": "contracts",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "Contract",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "parsedRecipient",
            "type": {
              "kind": "OBJECT",
              "name": "ParsedRecipient",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "recipient",
            "type": {
              "kind": "OBJECT",
              "name": "Recipient",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "recipientDisplayName",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "ENUM",
        "name": "ContractsCashflowRowCategory",
        "enumValues": [
          {
            "name": "CONTRACT"
          },
          {
            "name": "DEPARTMENT"
          },
          {
            "name": "OWNER"
          },
          {
            "name": "RECIPIENT"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "ContractsCashflowRowMetadata",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "ContractsCashflowContractRowMetadata"
          },
          {
            "kind": "OBJECT",
            "name": "ContractsCashflowDepartmentRowMetadata"
          },
          {
            "kind": "OBJECT",
            "name": "ContractsCashflowOwnerRowMetadata"
          },
          {
            "kind": "OBJECT",
            "name": "ContractsCashflowRecipientRowMetadata"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "ContractsVariance",
        "fields": [
          {
            "name": "periods",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "ContractsCashManagementPeriod",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "recipients",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "ContractsCashManagementRecipient",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "totals",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "CashManagementVariancePeriodData",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "Conversion",
        "fields": [
          {
            "name": "confirmationNumber",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "destinationAmount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "Money",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "payment",
            "type": {
              "kind": "OBJECT",
              "name": "Payment",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "rate",
            "type": {
              "kind": "OBJECT",
              "name": "CachedRate",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "settlementDate",
            "type": {
              "kind": "SCALAR",
              "name": "DateTime",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "sourceAmount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "Money",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "status",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "ExecutionStatus",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "transactions",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "ConversionTransactions",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ConversionBelowLimitError",
        "fields": [
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "path",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "SCALAR",
                  "name": "String",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "stackTrace",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "ErrorInterface"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "ConversionFailedError",
        "fields": [
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "path",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "SCALAR",
                  "name": "String",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "stackTrace",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "ErrorInterface"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "ConversionRateChangedError",
        "fields": [
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "path",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "SCALAR",
                  "name": "String",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "stackTrace",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "ErrorInterface"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "ConversionSummary",
        "fields": [
          {
            "name": "confirmationNumber",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "destinationAmount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "VariableMoney",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "sourceAmount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "VariableMoney",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ConversionTransactions",
        "fields": [
          {
            "name": "destinationTransaction",
            "type": {
              "kind": "OBJECT",
              "name": "Transaction",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "sourceTransaction",
            "type": {
              "kind": "OBJECT",
              "name": "Transaction",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "TransactionPair"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "ConvertVendorMissingContractInput",
        "inputFields": [
          {
            "name": "fileId",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "vendorId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "ConvertVendorMissingContractResponse",
        "fields": [
          {
            "name": "contract",
            "type": {
              "kind": "OBJECT",
              "name": "Contract",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "Coordinates",
        "fields": [
          {
            "name": "latitude",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Float",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "longitude",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Float",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "Counterparty",
        "fields": [
          {
            "name": "displayText",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "CreateAccountInput",
        "inputFields": [
          {
            "name": "currency",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "Currency",
                "ofType": null
              }
            }
          },
          {
            "name": "name",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "CreateAccountResponse",
        "fields": [
          {
            "name": "account",
            "type": {
              "kind": "OBJECT",
              "name": "Account",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "CreateActivityCommentInput",
        "inputFields": [
          {
            "name": "activityId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            }
          },
          {
            "name": "comment",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "INPUT_OBJECT",
                "name": "CommentInput",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "CreateActivityCommentResponse",
        "fields": [
          {
            "name": "comment",
            "type": {
              "kind": "OBJECT",
              "name": "Comment",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "CreateAndLinkAccountingVendorInput",
        "inputFields": [
          {
            "name": "levroRecipientId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "CreateAndLinkAccountingVendorResponse",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "levroRecipientId",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "CreateBillInput",
        "inputFields": [
          {
            "name": "attachmentIds",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                }
              }
            },
            "defaultValue": "null"
          },
          {
            "name": "fileId",
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "defaultValue": "null"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "CreateBillResponse",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "processingState",
            "type": {
              "kind": "OBJECT",
              "name": "BillProcessingState",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "CreateCardInput",
        "inputFields": [
          {
            "name": "cardHolderUserId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            }
          },
          {
            "name": "cardName",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            }
          },
          {
            "name": "creditCardLimit",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CreditCardLimitInput",
              "ofType": null
            }
          },
          {
            "name": "dateOfBirth",
            "type": {
              "kind": "SCALAR",
              "name": "Date",
              "ofType": null
            }
          },
          {
            "name": "debitCardLimit",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "DebitCardLimitInput",
              "ofType": null
            }
          },
          {
            "name": "funding",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "FundingType",
                "ofType": null
              }
            }
          },
          {
            "name": "idempotencyKey",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            }
          },
          {
            "name": "shippingAddress",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "AddressInput",
              "ofType": null
            }
          },
          {
            "name": "type",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "CardType",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "CreateCardResponse",
        "fields": [
          {
            "name": "card",
            "type": {
              "kind": "OBJECT",
              "name": "Card",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "CreateCheckDepositInput",
        "inputFields": [
          {
            "name": "amount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "INPUT_OBJECT",
                "name": "MoneyInput",
                "ofType": null
              }
            }
          },
          {
            "name": "depositAccountId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            }
          },
          {
            "name": "description",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            }
          },
          {
            "name": "idempotencyKey",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "CreateCheckDepositResponse",
        "fields": [
          {
            "name": "activity",
            "type": {
              "kind": "OBJECT",
              "name": "Activity",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "checkDepositId",
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "CreateContractCommentInput",
        "inputFields": [
          {
            "name": "comment",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "INPUT_OBJECT",
                "name": "CommentInput",
                "ofType": null
              }
            }
          },
          {
            "name": "contractId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "CreateContractCommentResponse",
        "fields": [
          {
            "name": "comment",
            "type": {
              "kind": "OBJECT",
              "name": "Comment",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "CreateContractFromProcurementRequestInput",
        "inputFields": [
          {
            "name": "procurementRequestId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "CreateContractFromProcurementRequestResponse",
        "fields": [
          {
            "name": "contract",
            "type": {
              "kind": "OBJECT",
              "name": "Contract",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "CreateConversionWidget",
        "fields": [
          {
            "name": "amortized",
            "type": {
              "kind": "SCALAR",
              "name": "Boolean",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "destinationAccountId",
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "destinationAmount",
            "type": {
              "kind": "OBJECT",
              "name": "VariableMoney",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "note",
            "type": {
              "kind": "OBJECT",
              "name": "Note",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "rrule",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "sourceAccountId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "sourceAmount",
            "type": {
              "kind": "OBJECT",
              "name": "VariableMoney",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "status",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "WidgetStatus",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "targetDate",
            "type": {
              "kind": "SCALAR",
              "name": "Date",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "title",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseWidget"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "CreateDepartmentInput",
        "inputFields": [
          {
            "name": "departmentName",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "CreateDepartmentResponse",
        "fields": [
          {
            "name": "department",
            "type": {
              "kind": "OBJECT",
              "name": "Department",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "CreateDraftAccrualInput",
        "inputFields": [
          {
            "name": "accountingClassId",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "accountingDepartmentId",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "accountingExpenseAccountId",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "accountingJournalEntryId",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "accountingLiabilityAccountId",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "accountingLocationId",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "accountingVendorId",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "accrualDateUtc",
            "type": {
              "kind": "SCALAR",
              "name": "Date",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "amount",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "VariableMoneyInput",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "contractId",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "description",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "idempotencyKey",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            }
          },
          {
            "name": "postedAtUtc",
            "type": {
              "kind": "SCALAR",
              "name": "DateTime",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "quantity",
            "type": {
              "kind": "SCALAR",
              "name": "Float",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "recipientId",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "unitAmount",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "VariableMoneyInput",
              "ofType": null
            },
            "defaultValue": "null"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "CreateDraftAccrualsInput",
        "inputFields": [
          {
            "name": "expenseAccruals",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "CreateDraftAccrualInput",
                    "ofType": null
                  }
                }
              }
            }
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "CreateDraftPaymentError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "DefaultError"
          },
          {
            "kind": "OBJECT",
            "name": "DuplicatePaymentCreationError"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "CreateDraftPaymentInput",
        "inputFields": [
          {
            "name": "amount",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "MoneyInput",
              "ofType": null
            }
          },
          {
            "name": "dueDateUtc",
            "type": {
              "kind": "SCALAR",
              "name": "Date",
              "ofType": null
            }
          },
          {
            "name": "idempotencyKey",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            }
          },
          {
            "name": "method",
            "type": {
              "kind": "ENUM",
              "name": "PaymentMethod",
              "ofType": null
            }
          },
          {
            "name": "paymentReason",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            }
          },
          {
            "name": "recipient",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "SuperSheetsRecipientInput",
              "ofType": null
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "CreateDraftPaymentsError",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "CreateDraftPaymentError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "idempotencyKey",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "CreateDraftPaymentsInput",
        "inputFields": [
          {
            "name": "payments",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "CreateDraftPaymentInput",
                    "ofType": null
                  }
                }
              }
            }
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "CreateEventInstanceCommentInput",
        "inputFields": [
          {
            "name": "comment",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "INPUT_OBJECT",
                "name": "CommentInput",
                "ofType": null
              }
            }
          },
          {
            "name": "eventId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            }
          },
          {
            "name": "ordinal",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "CreateEventInstanceCommentResponse",
        "fields": [
          {
            "name": "comment",
            "type": {
              "kind": "OBJECT",
              "name": "Comment",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "CreateFileInput",
        "inputFields": [
          {
            "name": "category",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "FileCategory",
                "ofType": null
              }
            }
          },
          {
            "name": "mimeType",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            }
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "CreateFileResponse",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "urlForUpload",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "CreateInvoiceInput",
        "inputFields": [
          {
            "name": "depositAccountId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            }
          },
          {
            "name": "description",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            }
          },
          {
            "name": "dueDate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Date",
                "ofType": null
              }
            }
          },
          {
            "name": "fileIds",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID",
                    "ofType": null
                  }
                }
              }
            }
          },
          {
            "name": "invoiceAmount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "INPUT_OBJECT",
                "name": "MoneyInput",
                "ofType": null
              }
            }
          },
          {
            "name": "invoiceDate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Date",
                "ofType": null
              }
            }
          },
          {
            "name": "invoiceNumber",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            }
          },
          {
            "name": "lineItems",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "InvoiceLineItemInput",
                    "ofType": null
                  }
                }
              }
            }
          },
          {
            "name": "method",
            "type": {
              "kind": "ENUM",
              "name": "PaymentMethod",
              "ofType": null
            }
          },
          {
            "name": "note",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "NoteInput",
              "ofType": null
            }
          },
          {
            "name": "payerId",
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            }
          },
          {
            "name": "payerNote",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            }
          },
          {
            "name": "payerRequest",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CreatePayerInput",
              "ofType": null
            }
          },
          {
            "name": "sendEmail",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "CreateInvoiceResponse",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "invoice",
            "type": {
              "kind": "OBJECT",
              "name": "Invoice",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "CreateInvoiceWidget",
        "fields": [
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "invoice",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "AssistantInvoicePrefill",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "status",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "WidgetStatus",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "title",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseWidget"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "CreatePayerInput",
        "inputFields": [
          {
            "name": "address",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "AddressInput",
              "ofType": null
            }
          },
          {
            "name": "contactName",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            }
          },
          {
            "name": "defaultDepositAccountId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            }
          },
          {
            "name": "email",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            }
          },
          {
            "name": "payerName",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            }
          },
          {
            "name": "phoneNumber",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "CreatePayerResponse",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "payer",
            "type": {
              "kind": "OBJECT",
              "name": "Payer",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "CreatePlaidLinkTokenResponse",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "plaidLinkToken",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "CreateProcurementRequestInput",
        "inputFields": [
          {
            "name": "annualContractValue",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "MoneyFormulaInput",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "departmentId",
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "estimatedStartDate",
            "type": {
              "kind": "SCALAR",
              "name": "Date",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "fileId",
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "notes",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "ownerId",
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "vendorId",
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "vendorName",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "CreateProcurementRequestResponse",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "request",
            "type": {
              "kind": "OBJECT",
              "name": "ProcurementRequest",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "CreateRecipientUserFromInvitationInput",
        "inputFields": [
          {
            "name": "newAccountInfo",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "INPUT_OBJECT",
                "name": "RecipientUserIdentityInput",
                "ofType": null
              }
            }
          },
          {
            "name": "token",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "CreateRecipientUserFromInvitationResponse",
        "fields": [
          {
            "name": "accountCreated",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "passwordResetUrl",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "CreateRecipientWidget",
        "fields": [
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "recipient",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "AssistantRecipientPrefill",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "status",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "CreateRecipientWidgetStatus",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "title",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseWidget"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "CreateRecipientWidgetStatus",
        "fields": [
          {
            "name": "recipientId",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "status",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "WidgetStatusCategory",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseWidgetStatus"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "CreateScheduledEventCommentInput",
        "inputFields": [
          {
            "name": "comment",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "INPUT_OBJECT",
                "name": "CommentInput",
                "ofType": null
              }
            }
          },
          {
            "name": "eventId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "CreateScheduledEventCommentResponse",
        "fields": [
          {
            "name": "comment",
            "type": {
              "kind": "OBJECT",
              "name": "Comment",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "CreateSuperSheetsPaymentResponse",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "UNION",
                  "name": "CreateDraftPaymentError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "payment",
            "type": {
              "kind": "OBJECT",
              "name": "SuperSheetsPayment",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "CreateSuperSheetsPaymentsResponse",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "CreateDraftPaymentsError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "payment",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "SuperSheetsPayment",
                  "ofType": null
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "CreateTransactionCommentInput",
        "inputFields": [
          {
            "name": "comment",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "INPUT_OBJECT",
                "name": "CommentInput",
                "ofType": null
              }
            }
          },
          {
            "name": "transactionId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "CreateTransactionCommentResponse",
        "fields": [
          {
            "name": "comment",
            "type": {
              "kind": "OBJECT",
              "name": "Comment",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "CreateVerificationInput",
        "inputFields": [
          {
            "name": "phoneNumber",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "CreateVerificationResponse",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "success",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "CreditAccountDetails",
        "fields": [
          {
            "name": "autoPayInfo",
            "type": {
              "kind": "OBJECT",
              "name": "RepaymentInfo",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "available",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "Money",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "balance",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "Money",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "createdAt",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "DateTime",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "creditLimit",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "Money",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "creditTerms",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "freezeReason",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "hold",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "Money",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "status",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "AccountStatus",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "updatedAt",
            "type": {
              "kind": "SCALAR",
              "name": "DateTime",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "CreditAccountPaymentInput",
        "inputFields": [
          {
            "name": "creditAccountId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            }
          },
          {
            "name": "idempotencyKey",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            }
          },
          {
            "name": "paymentAccountId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            }
          },
          {
            "name": "paymentAccountType",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "RepaymentAccountType",
                "ofType": null
              }
            }
          },
          {
            "name": "paymentAmount",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "MoneyInput",
              "ofType": null
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "CreditAccountPaymentResponse",
        "fields": [
          {
            "name": "amount",
            "type": {
              "kind": "OBJECT",
              "name": "Money",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "paymentSettlementDate",
            "type": {
              "kind": "SCALAR",
              "name": "Date",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "CreditAccountRepayment",
        "fields": [
          {
            "name": "amount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "Money",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "createdOn",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Date",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "postsOn",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Date",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "CreditAccountStatement",
        "fields": [
          {
            "name": "account",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "Account",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "balance",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "CreditStatementBalance",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "csvUrl",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "html",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "paymentDueDate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Date",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "pdfUrl",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "period",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "Period",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "qboUrl",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "statementDate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Date",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "AccountStatementInterface"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "CreditApplication",
        "fields": [
          {
            "name": "autoPayInfo",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "RepaymentInfo",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "creditLimit",
            "type": {
              "kind": "OBJECT",
              "name": "Money",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "status",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "CreditApplicationStatus",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "ENUM",
        "name": "CreditApplicationStatus",
        "enumValues": [
          {
            "name": "APPROVED"
          },
          {
            "name": "DENIED"
          },
          {
            "name": "PENDING_APPROVAL"
          },
          {
            "name": "PENDING_EXTERNAL_ACCOUNT_RECONNECT"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "CreditCardLimit",
        "fields": [
          {
            "name": "purchase",
            "type": {
              "kind": "OBJECT",
              "name": "Limit",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "CreditCardLimitInput",
        "inputFields": [
          {
            "name": "purchase",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "INPUT_OBJECT",
                "name": "LimitInput",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "CreditStatementBalance",
        "fields": [
          {
            "name": "closingBalance",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "Money",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "openingBalance",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "Money",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "ENUM",
        "name": "Currency",
        "enumValues": [
          {
            "name": "aed"
          },
          {
            "name": "afn"
          },
          {
            "name": "all"
          },
          {
            "name": "amd"
          },
          {
            "name": "ang"
          },
          {
            "name": "aoa"
          },
          {
            "name": "ars"
          },
          {
            "name": "aud"
          },
          {
            "name": "awg"
          },
          {
            "name": "azn"
          },
          {
            "name": "bam"
          },
          {
            "name": "bbd"
          },
          {
            "name": "bdt"
          },
          {
            "name": "bgn"
          },
          {
            "name": "bhd"
          },
          {
            "name": "bif"
          },
          {
            "name": "bmd"
          },
          {
            "name": "bnd"
          },
          {
            "name": "bob"
          },
          {
            "name": "bov"
          },
          {
            "name": "brl"
          },
          {
            "name": "bsd"
          },
          {
            "name": "btn"
          },
          {
            "name": "bwp"
          },
          {
            "name": "byn"
          },
          {
            "name": "bzd"
          },
          {
            "name": "cad"
          },
          {
            "name": "cdf"
          },
          {
            "name": "che"
          },
          {
            "name": "chf"
          },
          {
            "name": "chw"
          },
          {
            "name": "clf"
          },
          {
            "name": "clp"
          },
          {
            "name": "cny"
          },
          {
            "name": "cop"
          },
          {
            "name": "cou"
          },
          {
            "name": "crc"
          },
          {
            "name": "cuc"
          },
          {
            "name": "cup"
          },
          {
            "name": "cve"
          },
          {
            "name": "czk"
          },
          {
            "name": "djf"
          },
          {
            "name": "dkk"
          },
          {
            "name": "dop"
          },
          {
            "name": "dzd"
          },
          {
            "name": "egp"
          },
          {
            "name": "ern"
          },
          {
            "name": "etb"
          },
          {
            "name": "eur"
          },
          {
            "name": "fjd"
          },
          {
            "name": "fkp"
          },
          {
            "name": "gbp"
          },
          {
            "name": "gel"
          },
          {
            "name": "ghs"
          },
          {
            "name": "gip"
          },
          {
            "name": "gmd"
          },
          {
            "name": "gnf"
          },
          {
            "name": "gtq"
          },
          {
            "name": "gyd"
          },
          {
            "name": "hkd"
          },
          {
            "name": "hnl"
          },
          {
            "name": "hrk"
          },
          {
            "name": "htg"
          },
          {
            "name": "huf"
          },
          {
            "name": "idr"
          },
          {
            "name": "ils"
          },
          {
            "name": "inr"
          },
          {
            "name": "iqd"
          },
          {
            "name": "irr"
          },
          {
            "name": "isk"
          },
          {
            "name": "jmd"
          },
          {
            "name": "jod"
          },
          {
            "name": "jpy"
          },
          {
            "name": "kes"
          },
          {
            "name": "kgs"
          },
          {
            "name": "khr"
          },
          {
            "name": "kmf"
          },
          {
            "name": "kpw"
          },
          {
            "name": "krw"
          },
          {
            "name": "kwd"
          },
          {
            "name": "kyd"
          },
          {
            "name": "kzt"
          },
          {
            "name": "lak"
          },
          {
            "name": "lbp"
          },
          {
            "name": "lkr"
          },
          {
            "name": "lrd"
          },
          {
            "name": "lsl"
          },
          {
            "name": "lyd"
          },
          {
            "name": "mad"
          },
          {
            "name": "mdl"
          },
          {
            "name": "mga"
          },
          {
            "name": "mkd"
          },
          {
            "name": "mmk"
          },
          {
            "name": "mnt"
          },
          {
            "name": "mop"
          },
          {
            "name": "mru"
          },
          {
            "name": "mur"
          },
          {
            "name": "mvr"
          },
          {
            "name": "mwk"
          },
          {
            "name": "mxn"
          },
          {
            "name": "mxv"
          },
          {
            "name": "myr"
          },
          {
            "name": "mzn"
          },
          {
            "name": "nad"
          },
          {
            "name": "ngn"
          },
          {
            "name": "nio"
          },
          {
            "name": "nok"
          },
          {
            "name": "npr"
          },
          {
            "name": "nzd"
          },
          {
            "name": "omr"
          },
          {
            "name": "pab"
          },
          {
            "name": "pen"
          },
          {
            "name": "pgk"
          },
          {
            "name": "php"
          },
          {
            "name": "pkr"
          },
          {
            "name": "pln"
          },
          {
            "name": "pyg"
          },
          {
            "name": "qar"
          },
          {
            "name": "ron"
          },
          {
            "name": "rsd"
          },
          {
            "name": "rub"
          },
          {
            "name": "rwf"
          },
          {
            "name": "sar"
          },
          {
            "name": "sbd"
          },
          {
            "name": "scr"
          },
          {
            "name": "sdg"
          },
          {
            "name": "sek"
          },
          {
            "name": "sgd"
          },
          {
            "name": "shp"
          },
          {
            "name": "sle"
          },
          {
            "name": "sll"
          },
          {
            "name": "sos"
          },
          {
            "name": "srd"
          },
          {
            "name": "ssp"
          },
          {
            "name": "stn"
          },
          {
            "name": "svc"
          },
          {
            "name": "syp"
          },
          {
            "name": "szl"
          },
          {
            "name": "thb"
          },
          {
            "name": "tjs"
          },
          {
            "name": "tmt"
          },
          {
            "name": "tnd"
          },
          {
            "name": "top"
          },
          {
            "name": "try"
          },
          {
            "name": "ttd"
          },
          {
            "name": "twd"
          },
          {
            "name": "tzs"
          },
          {
            "name": "uah"
          },
          {
            "name": "ugx"
          },
          {
            "name": "usd"
          },
          {
            "name": "usn"
          },
          {
            "name": "uyi"
          },
          {
            "name": "uyu"
          },
          {
            "name": "uyw"
          },
          {
            "name": "uzs"
          },
          {
            "name": "ved"
          },
          {
            "name": "ves"
          },
          {
            "name": "vnd"
          },
          {
            "name": "vuv"
          },
          {
            "name": "wst"
          },
          {
            "name": "xaf"
          },
          {
            "name": "xag"
          },
          {
            "name": "xau"
          },
          {
            "name": "xba"
          },
          {
            "name": "xbb"
          },
          {
            "name": "xbc"
          },
          {
            "name": "xbd"
          },
          {
            "name": "xcd"
          },
          {
            "name": "xdr"
          },
          {
            "name": "xof"
          },
          {
            "name": "xpd"
          },
          {
            "name": "xpf"
          },
          {
            "name": "xpt"
          },
          {
            "name": "xsu"
          },
          {
            "name": "xts"
          },
          {
            "name": "xua"
          },
          {
            "name": "xxx"
          },
          {
            "name": "yer"
          },
          {
            "name": "zar"
          },
          {
            "name": "zmw"
          },
          {
            "name": "zwl"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "CurrencyCostAveragingState",
        "fields": [
          {
            "name": "completedDestinationAmount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "Money",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "completedSourceAmount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "Money",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "fixedAmount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "FixedAmount",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "nCompletedSplits",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "nTotalSplits",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "status",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "ExecutionStatus",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "totalFixedAmount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "Money",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "CurrencyPairNotTradeableError",
        "fields": [
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "path",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "SCALAR",
                  "name": "String",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "stackTrace",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "ErrorInterface"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "Customer",
        "fields": [
          {
            "name": "approvedAt",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "DateTime",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "canRefer",
            "type": {
              "kind": "SCALAR",
              "name": "Boolean",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "legalName",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "products",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "ENUM",
                    "name": "Product",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "referral",
            "type": {
              "kind": "UNION",
              "name": "ReferralResponse",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "sheetsTier",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "SheetsCustomerTier",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "status",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "CustomerStatus",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "tier",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "CustomerTier",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "trusted",
            "type": {
              "kind": "SCALAR",
              "name": "Boolean",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "usesPaymentReleaseStep",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "CustomerPayPalFunding",
        "fields": [
          {
            "name": "void",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "CustomerResponse",
        "fields": [
          {
            "name": "customer",
            "type": {
              "kind": "OBJECT",
              "name": "Customer",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "ENUM",
        "name": "CustomerStatus",
        "enumValues": [
          {
            "name": "CLOSED"
          },
          {
            "name": "FROZEN"
          },
          {
            "name": "OPEN"
          },
          {
            "name": "PRE_KYC"
          }
        ]
      },
      {
        "kind": "ENUM",
        "name": "CustomerTier",
        "enumValues": [
          {
            "name": "ESSENTIAL"
          },
          {
            "name": "ESSENTIAL_THREAD"
          },
          {
            "name": "LEGACY_PREMIUM"
          },
          {
            "name": "LEGACY_PREMIUM_THREAD"
          },
          {
            "name": "LITE"
          },
          {
            "name": "PAYMENTS_THREAD"
          },
          {
            "name": "PLATINUM"
          },
          {
            "name": "PLATINUM_THREAD"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "CustomerTierSettings",
        "fields": [
          {
            "name": "debitCardCashBackPercent",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Float",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "freeLocalRailPaymentsPerMonth",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "freeWirePaymentsPerMonth",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "outgoingLocalRailFee",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Float",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "outgoingWireFee",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Float",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "SCALAR",
        "name": "Date"
      },
      {
        "kind": "OBJECT",
        "name": "DateBulkPaymentColumn",
        "fields": [
          {
            "name": "sourceColumn",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "values",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "SCALAR",
                  "name": "Date",
                  "ofType": null
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "SCALAR",
        "name": "DateTime"
      },
      {
        "kind": "OBJECT",
        "name": "DebitCardLimit",
        "fields": [
          {
            "name": "purchase",
            "type": {
              "kind": "OBJECT",
              "name": "Limit",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "withdrawal",
            "type": {
              "kind": "OBJECT",
              "name": "Limit",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "DebitCardLimitInput",
        "inputFields": [
          {
            "name": "purchase",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "LimitInput",
              "ofType": null
            }
          },
          {
            "name": "withdrawal",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "LimitInput",
              "ofType": null
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "DefaultError",
        "fields": [
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "path",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "SCALAR",
                  "name": "String",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "stackTrace",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "ErrorInterface"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "DefaultOrAccountingConnectionRequiredError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "AccountingConnectionRequiredError"
          },
          {
            "kind": "OBJECT",
            "name": "DefaultError"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "DefaultParseContractError",
        "fields": [
          {
            "name": "fileId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "path",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "SCALAR",
                  "name": "String",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "stackTrace",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "ErrorInterface"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "DeleteActivityCommentInput",
        "inputFields": [
          {
            "name": "activityId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            }
          },
          {
            "name": "commentId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "DeleteActivityCommentResponse",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "DeleteContractCommentInput",
        "inputFields": [
          {
            "name": "commentId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            }
          },
          {
            "name": "contractId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "DeleteContractCommentResponse",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "DeleteContractsInput",
        "inputFields": [
          {
            "name": "ids",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID",
                    "ofType": null
                  }
                }
              }
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "DeleteContractsResponse",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "DeleteDepartmentInput",
        "inputFields": [
          {
            "name": "departmentId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "DeleteEventInstanceCommentInput",
        "inputFields": [
          {
            "name": "commentId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            }
          },
          {
            "name": "eventId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            }
          },
          {
            "name": "ordinal",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "DeleteEventInstanceCommentResponse",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "DeleteScheduledEventCommentInput",
        "inputFields": [
          {
            "name": "commentId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            }
          },
          {
            "name": "eventId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "DeleteScheduledEventCommentResponse",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "DeleteTransactionCommentInput",
        "inputFields": [
          {
            "name": "commentId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            }
          },
          {
            "name": "transactionId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "DeleteTransactionCommentResponse",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "DeleteVendorFeedbackInput",
        "inputFields": [
          {
            "name": "feedbackId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "Department",
        "fields": [
          {
            "name": "departmentName",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "Deposit",
        "fields": [
          {
            "name": "amount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "Money",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "description",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "method",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "DepositMethod",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "sender",
            "type": {
              "kind": "OBJECT",
              "name": "Sender",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "settlementDate",
            "type": {
              "kind": "SCALAR",
              "name": "Date",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "status",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "ExecutionStatus",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "transaction",
            "type": {
              "kind": "OBJECT",
              "name": "Transaction",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "ENUM",
        "name": "DepositMethod",
        "enumValues": [
          {
            "name": "ACH"
          },
          {
            "name": "CHECK"
          },
          {
            "name": "FED_WIRE"
          },
          {
            "name": "LOCAL"
          },
          {
            "name": "SWIFT"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "DepositSummary",
        "fields": [
          {
            "name": "amount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "VariableMoney",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "method",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "DepositMethod",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "senderName",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "ENUM",
        "name": "DigitalWalletType",
        "enumValues": [
          {
            "name": "APPLE"
          },
          {
            "name": "GOOGLE"
          },
          {
            "name": "OTHER"
          }
        ]
      },
      {
        "kind": "ENUM",
        "name": "Direction",
        "enumValues": [
          {
            "name": "CREDIT"
          },
          {
            "name": "DEBIT"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "DisableRecipientInput",
        "inputFields": [
          {
            "name": "recipientId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "DisableRecipientResponse",
        "fields": [
          {
            "name": "disabled",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "DisconnectExternalAccountInput",
        "inputFields": [
          {
            "name": "connectedAccountId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "DisconnectExternalAccountResponse",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "DismissVendorMissingContractInput",
        "inputFields": [
          {
            "name": "vendorId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "DocusignConnection",
        "fields": [
          {
            "name": "accountName",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "email",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "DownloadStatementsWidget",
        "fields": [
          {
            "name": "endDate",
            "type": {
              "kind": "SCALAR",
              "name": "Date",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "startDate",
            "type": {
              "kind": "SCALAR",
              "name": "Date",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "title",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseWidget"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "DuplicatePaymentCreationError",
        "fields": [
          {
            "name": "existingPaymentId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "idempotencyKey",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "path",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "SCALAR",
                  "name": "String",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "stackTrace",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "ErrorInterface"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "DuplicatePaymentError",
        "fields": [
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "originalEventApprovalStatus",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "ApprovalRequestStatus",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "originalEventId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "path",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "SCALAR",
                  "name": "String",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "stackTrace",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "ErrorInterface"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "DuplicateScheduledEventIdempotencyKeyError",
        "fields": [
          {
            "name": "activityId",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "eventId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "idempotencyKey",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "path",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "SCALAR",
                  "name": "String",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "stackTrace",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "ErrorInterface"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "EURAccountDetails",
        "fields": [
          {
            "name": "accountHolder",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "accountNumber",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "accountNumberIsIban",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "bankAddress",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "bankName",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "localPaymentRailName",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "sepaSwift",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "swift",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "SWIFTAccountDetails",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "AccountDetailsWithLocalPayIns"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "EmptyResponse",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "ErrorInterface",
        "fields": [
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "path",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "SCALAR",
                  "name": "String",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "stackTrace",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": [],
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "AccountingConnectionRequiredError"
          },
          {
            "kind": "OBJECT",
            "name": "CannotReduceRecipientManagerPermissionError"
          },
          {
            "kind": "OBJECT",
            "name": "CannotUpdateBusinessContactRoleError"
          },
          {
            "kind": "OBJECT",
            "name": "ComplianceError"
          },
          {
            "kind": "OBJECT",
            "name": "ConversionBelowLimitError"
          },
          {
            "kind": "OBJECT",
            "name": "ConversionFailedError"
          },
          {
            "kind": "OBJECT",
            "name": "ConversionRateChangedError"
          },
          {
            "kind": "OBJECT",
            "name": "CurrencyPairNotTradeableError"
          },
          {
            "kind": "OBJECT",
            "name": "DefaultError"
          },
          {
            "kind": "OBJECT",
            "name": "DefaultParseContractError"
          },
          {
            "kind": "OBJECT",
            "name": "DuplicatePaymentCreationError"
          },
          {
            "kind": "OBJECT",
            "name": "DuplicatePaymentError"
          },
          {
            "kind": "OBJECT",
            "name": "DuplicateScheduledEventIdempotencyKeyError"
          },
          {
            "kind": "OBJECT",
            "name": "FXConversionUnavailableError"
          },
          {
            "kind": "OBJECT",
            "name": "FXMarketsClosedError"
          },
          {
            "kind": "OBJECT",
            "name": "InsufficientBalanceError"
          },
          {
            "kind": "OBJECT",
            "name": "InvalidRecipientError"
          },
          {
            "kind": "OBJECT",
            "name": "PaymentError"
          },
          {
            "kind": "OBJECT",
            "name": "PlaidError"
          },
          {
            "kind": "OBJECT",
            "name": "RecipientNameNoMatchError"
          },
          {
            "kind": "OBJECT",
            "name": "RecipientNamePartialMatchError"
          },
          {
            "kind": "OBJECT",
            "name": "UserNotFoundError"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "EventInstance",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "ExecutedEventInstance"
          },
          {
            "kind": "OBJECT",
            "name": "ScheduledEventInstance"
          }
        ]
      },
      {
        "kind": "ENUM",
        "name": "EventInstanceType",
        "enumValues": [
          {
            "name": "CANCELED"
          },
          {
            "name": "EXECUTED"
          },
          {
            "name": "SCHEDULED"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "ExecutedEventInstance",
        "fields": [
          {
            "name": "activity",
            "type": {
              "kind": "OBJECT",
              "name": "Activity",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "activityId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "canAttachFiles",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "canCancel",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "canWriteNote",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "comments",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "Comment",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "event",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "UNION",
                "name": "ScheduledEvent",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "eventId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "executionTime",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "DateTime",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "files",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "File",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "note",
            "type": {
              "kind": "OBJECT",
              "name": "Note",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "ordinal",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "scheduledDateEt",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Date",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "schedulingStatus",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "ScheduledEventInstanceStatus",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "ScheduledEventInstanceInterface"
          }
        ]
      },
      {
        "kind": "ENUM",
        "name": "ExecutionStatus",
        "enumValues": [
          {
            "name": "CANCELED"
          },
          {
            "name": "COMPLETED"
          },
          {
            "name": "FAILED"
          },
          {
            "name": "PENDING"
          },
          {
            "name": "UNKNOWN"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "ExpectedApprovalInfoResponse",
        "fields": [
          {
            "name": "automaticallyApproved",
            "type": {
              "kind": "SCALAR",
              "name": "Boolean",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "initialState",
            "type": {
              "kind": "OBJECT",
              "name": "MultiLayerApprovalState",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "manualApprovalRequiredReason",
            "type": {
              "kind": "ENUM",
              "name": "ManualApprovalRequiredReason",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "ExpenseAccrual",
        "fields": [
          {
            "name": "accountingClass",
            "type": {
              "kind": "OBJECT",
              "name": "AccountingCategory",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "accountingDepartment",
            "type": {
              "kind": "OBJECT",
              "name": "AccountingCategory",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "accountingLocation",
            "type": {
              "kind": "OBJECT",
              "name": "AccountingCategory",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "accrualDateUtc",
            "type": {
              "kind": "SCALAR",
              "name": "Date",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "amount",
            "type": {
              "kind": "OBJECT",
              "name": "VariableMoney",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "contract",
            "type": {
              "kind": "OBJECT",
              "name": "Contract",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "createdAtUtc",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "DateTime",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "expenseAccount",
            "type": {
              "kind": "OBJECT",
              "name": "NominalAccount",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "liabilityAccount",
            "type": {
              "kind": "OBJECT",
              "name": "NominalAccount",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "postedAtUtc",
            "type": {
              "kind": "SCALAR",
              "name": "DateTime",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "quantity",
            "type": {
              "kind": "SCALAR",
              "name": "Float",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "status",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "SuperSheetsAccrualStatus",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "unitAmount",
            "type": {
              "kind": "OBJECT",
              "name": "VariableMoney",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "updatedAtUtc",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "DateTime",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "ExpenseAccrualIDInput",
        "inputFields": [
          {
            "name": "expenseAccrualId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "ExpenseAccrualIDsInput",
        "inputFields": [
          {
            "name": "expenseAccrualIds",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID",
                    "ofType": null
                  }
                }
              }
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "ExpenseAccrualResponse",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "expenseAccrual",
            "type": {
              "kind": "OBJECT",
              "name": "ExpenseAccrual",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "ExpenseAccrualsResponse",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "expenseAccruals",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "ExpenseAccrual",
                  "ofType": null
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "ExportAccrualsInput",
        "inputFields": [
          {
            "name": "filter",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "INPUT_OBJECT",
                "name": "GetAccrualsFilterInput",
                "ofType": null
              }
            }
          },
          {
            "name": "sort",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "INPUT_OBJECT",
                "name": "GetAccrualsSortInput",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "ExportAccrualsResponse",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "fileUrl",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "ExportPaymentsInput",
        "inputFields": [
          {
            "name": "filter",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "GetPaymentsFilterInput",
              "ofType": null
            }
          },
          {
            "name": "sort",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "GetPaymentsSortInput",
              "ofType": null
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "ExportPaymentsResponse",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "fileUrl",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "ExportTransactionsInput",
        "inputFields": [
          {
            "name": "filter",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "GetTransactionsFilterInput",
              "ofType": null
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "ExportTransactionsResponse",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "fileUrl",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "FXConversionUnavailableError",
        "fields": [
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "path",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "SCALAR",
                  "name": "String",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "stackTrace",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "ErrorInterface"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "FXMarketStatusResponse",
        "fields": [
          {
            "name": "isOpen",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "nextOpenTimeIso",
            "type": {
              "kind": "SCALAR",
              "name": "DateTime",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "FXMarketsClosedError",
        "fields": [
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "path",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "SCALAR",
                  "name": "String",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "stackTrace",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "ErrorInterface"
          }
        ]
      },
      {
        "kind": "ENUM",
        "name": "FeatureFlag",
        "enumValues": [
          {
            "name": "ACCOUNT_CLOSURE_NOTIFICATION"
          },
          {
            "name": "ACTIVATION_CHECKLIST"
          },
          {
            "name": "ASSISTANT_BULK_PAYMENTS"
          },
          {
            "name": "ASSISTANT_CHAT"
          },
          {
            "name": "ASSISTANT_DEBUG"
          },
          {
            "name": "ASSISTANT_FREE_TEXT_INPUT"
          },
          {
            "name": "ASSISTANT_PYTHON_MODE"
          },
          {
            "name": "ASSISTANT_WORKFLOWS"
          },
          {
            "name": "ASSISTANT_WORKFLOWS_STRICT"
          },
          {
            "name": "BULK_RECIPIENT_UPLOAD"
          },
          {
            "name": "CB_SUPPRESS_AMBIGUOUS_BENEFICIARY_MATCH"
          },
          {
            "name": "CB_SUPPRESS_CC_SERVICE_UNAVAILABLE_ERROR"
          },
          {
            "name": "CB_SUPPRESS_CC_TOO_MANY_REQUESTS_ERROR"
          },
          {
            "name": "CB_SUPPRESS_TX_ORDER_DISAMBG_ERROR"
          },
          {
            "name": "CC_DISABLE_BOOK_TRANSFERS"
          },
          {
            "name": "CHARGE_CARDS"
          },
          {
            "name": "DEMO_FEATURES"
          },
          {
            "name": "ENABLE_GBP_LOCAL_PAYMENTS"
          },
          {
            "name": "EXTERNAL_API"
          },
          {
            "name": "EXTERNAL_FUNDING_FIXED_SOURCE_ONLY"
          },
          {
            "name": "FORECAST_VIEW"
          },
          {
            "name": "FREE_ENTERPRISE_TIER"
          },
          {
            "name": "FREE_TEAMS_TIER"
          },
          {
            "name": "IGNORE_ACCOUNT_DETAILS_ERRORS"
          },
          {
            "name": "LEVRO_2_SHEETS"
          },
          {
            "name": "MULTI_LAYER_APPROVALS"
          },
          {
            "name": "NO_CC_LOCAL_PAYMENT_FEES"
          },
          {
            "name": "PLAID_MICRODEPOSIT_VERIFICATION"
          },
          {
            "name": "PROCUREMENT_V1"
          },
          {
            "name": "SELECT_PAYMENT_FUNDING_METHOD"
          },
          {
            "name": "SELFIE_VERIFICATION"
          },
          {
            "name": "SPLIT_PHP_PAYMENTS"
          },
          {
            "name": "STRIPE_BILLING_ENABLED"
          },
          {
            "name": "TIN_VERIFICATION"
          },
          {
            "name": "ZERO_CC_PAYMENT_FEES"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "Fee",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "FeeExempt"
          },
          {
            "kind": "OBJECT",
            "name": "Money"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "FeeExempt",
        "fields": [
          {
            "name": "void",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "File",
        "fields": [
          {
            "name": "category",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "FileCategory",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "createdAt",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "DateTime",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "creator",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "User",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "mimeType",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "status",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "FileStatus",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "urlForDownload",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "urlForInline",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "ENUM",
        "name": "FileCategory",
        "enumValues": [
          {
            "name": "ASSISTANT_ATTACHMENT"
          },
          {
            "name": "BILL_ATTACHMENT"
          },
          {
            "name": "BRANDING_LOGO"
          },
          {
            "name": "INVOICE"
          },
          {
            "name": "INVOICE_ATTACHMENT"
          },
          {
            "name": "LITE_CONTRACT"
          },
          {
            "name": "LITE_IMPORTED_CONTRACT"
          },
          {
            "name": "PROCUREMENT_REQUEST"
          },
          {
            "name": "RECEIPT"
          },
          {
            "name": "WEB_CONTRACT_TERMS"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "FileConstrainedValue",
        "fields": [
          {
            "name": "file",
            "type": {
              "kind": "OBJECT",
              "name": "File",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "isDefault",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "ENUM",
        "name": "FileStatus",
        "enumValues": [
          {
            "name": "PENDING_UPLOAD"
          },
          {
            "name": "SOFT_DELETED"
          },
          {
            "name": "SOFT_DELETED_VIOLATING"
          },
          {
            "name": "UPLOADED"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "FileUrlResponse",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "url",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "FileValueInput",
        "inputFields": [
          {
            "name": "fileId",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            }
          }
        ]
      },
      {
        "kind": "ENUM",
        "name": "FixedAmount",
        "enumValues": [
          {
            "name": "DESTINATION"
          },
          {
            "name": "SOURCE"
          }
        ]
      },
      {
        "kind": "SCALAR",
        "name": "Float"
      },
      {
        "kind": "OBJECT",
        "name": "FloatBulkPaymentColumn",
        "fields": [
          {
            "name": "sourceColumn",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "values",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "SCALAR",
                  "name": "Float",
                  "ofType": null
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "ENUM",
        "name": "FreezeReason",
        "enumValues": [
          {
            "name": "FRAUD"
          },
          {
            "name": "OTHER"
          }
        ]
      },
      {
        "kind": "ENUM",
        "name": "Frequency",
        "enumValues": [
          {
            "name": "BIMONTHLY"
          },
          {
            "name": "BIWEEKLY"
          },
          {
            "name": "DAILY"
          },
          {
            "name": "MONTHLY"
          },
          {
            "name": "QUARTERLY"
          },
          {
            "name": "WEEKLY"
          },
          {
            "name": "YEARLY"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "FundingMethod",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "ConnectedAccount"
          },
          {
            "kind": "OBJECT",
            "name": "CustomerPayPalFunding"
          },
          {
            "kind": "OBJECT",
            "name": "LevroBalanceFunding"
          },
          {
            "kind": "OBJECT",
            "name": "WireFunding"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "FundingMethodInput",
        "inputFields": [
          {
            "name": "connectedAccountId",
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            }
          },
          {
            "name": "customerPaypalAccount",
            "type": {
              "kind": "SCALAR",
              "name": "Boolean",
              "ofType": null
            }
          },
          {
            "name": "levroBalance",
            "type": {
              "kind": "SCALAR",
              "name": "Boolean",
              "ofType": null
            }
          },
          {
            "name": "wire",
            "type": {
              "kind": "SCALAR",
              "name": "Boolean",
              "ofType": null
            }
          }
        ]
      },
      {
        "kind": "ENUM",
        "name": "FundingStatus",
        "enumValues": [
          {
            "name": "AWAITING_EXECUTION"
          },
          {
            "name": "AWAITING_FUNDS"
          },
          {
            "name": "AWAITING_INITIALIZATION"
          },
          {
            "name": "CANCELED"
          },
          {
            "name": "FUNDED"
          }
        ]
      },
      {
        "kind": "ENUM",
        "name": "FundingType",
        "enumValues": [
          {
            "name": "CREDIT"
          },
          {
            "name": "DEBIT"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "FxRateHistoryWidget",
        "fields": [
          {
            "name": "amountToConvert",
            "type": {
              "kind": "SCALAR",
              "name": "Float",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "currentRate",
            "type": {
              "kind": "SCALAR",
              "name": "Float",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "destinationCurrency",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "rateHistoryDates",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Date",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "rateHistoryValues",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "Float",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "sourceCurrency",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "title",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseWidget"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "GBPAccountDetails",
        "fields": [
          {
            "name": "accountHolder",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "accountNumber",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "accountNumberIsIban",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "bankAddress",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "bankName",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "localPaymentRailName",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "sortCode",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "swift",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "SWIFTAccountDetails",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "AccountDetailsWithLocalPayIns"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "GenerateApiKeyInput",
        "inputFields": [
          {
            "name": "description",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "GenerateApiKeyResponse",
        "fields": [
          {
            "name": "apiKey",
            "type": {
              "kind": "OBJECT",
              "name": "ApiKey",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "plainTextApiKey",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "GenerateDocusignAuthUrlResponse",
        "fields": [
          {
            "name": "authUrl",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "GenerateOAuthUrlInput",
        "inputFields": [
          {
            "name": "sessionState",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "GenerateOAuthUrlResponse",
        "fields": [
          {
            "name": "authUrl",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "GenerateStripeCheckoutSessionResponse",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "sessionKey",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "GenerateStripeCustomerSession",
        "fields": [
          {
            "name": "clientSecret",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "GenerateStripePortalUrlResponse",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "url",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "GenerateStripeSubscriptionResponse",
        "fields": [
          {
            "name": "clientSecret",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "subscriptionId",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "GenerateVendorFeedbackTokenInput",
        "inputFields": [
          {
            "name": "vendorId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "GeneratedVendorFeedbackTokenResponse",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "token",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "GetAccountInput",
        "inputFields": [
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "GetAccountResponse",
        "fields": [
          {
            "name": "account",
            "type": {
              "kind": "OBJECT",
              "name": "Account",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "GetAccountStatementFilterInput",
        "inputFields": [
          {
            "name": "accountId",
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            }
          },
          {
            "name": "period",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "PeriodInput",
              "ofType": null
            }
          },
          {
            "name": "statementId",
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "GetAccountStatementResponse",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "statement",
            "type": {
              "kind": "UNION",
              "name": "AccountStatement",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "GetAccountStatementsFilterInput",
        "inputFields": [
          {
            "name": "accountId",
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            }
          },
          {
            "name": "period",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "PeriodInput",
              "ofType": null
            }
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "GetAccountStatementsInput",
        "inputFields": [
          {
            "name": "filter",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "GetAccountStatementsFilterInput",
              "ofType": null
            }
          },
          {
            "name": "paginationInput",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "PaginationInput",
              "ofType": null
            }
          },
          {
            "name": "sort",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "GetAccountStatementsSortInput",
              "ofType": null
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "GetAccountStatementsResponse",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "pageInfo",
            "type": {
              "kind": "OBJECT",
              "name": "Pagination",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "statements",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "UNION",
                  "name": "AccountStatement",
                  "ofType": null
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          },
          {
            "kind": "INTERFACE",
            "name": "PaginatedResponse"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "GetAccountStatementsSortInput",
        "inputFields": [
          {
            "name": "sortColumn",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "GetStatementsSortColumn",
                "ofType": null
              }
            }
          },
          {
            "name": "sortOrder",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "OrderBy",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "GetAccountingCategoriesResponse",
        "fields": [
          {
            "name": "categories",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "AccountingCategory",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "GetAccountingConnectionResponse",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "response",
            "type": {
              "kind": "UNION",
              "name": "AccountingConnectionResponse",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "GetAccountingCustomersInput",
        "inputFields": [
          {
            "name": "filter",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "AccountingFilter",
              "ofType": null
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "GetAccountingCustomersResponse",
        "fields": [
          {
            "name": "customers",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "AccountingCustomer",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "GetAccountingDefaultsResponse",
        "fields": [
          {
            "name": "department",
            "type": {
              "kind": "OBJECT",
              "name": "AccountingCategory",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "klass",
            "type": {
              "kind": "OBJECT",
              "name": "AccountingCategory",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "location",
            "type": {
              "kind": "OBJECT",
              "name": "AccountingCategory",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "nominalExpenseAccount",
            "type": {
              "kind": "OBJECT",
              "name": "NominalAccount",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "nominalPaymentAccount",
            "type": {
              "kind": "OBJECT",
              "name": "NominalAccount",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "GetAccountingItemsResponse",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "items",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "BillAccountingItem",
                  "ofType": null
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "GetAccountingTaxRatesResponse",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "taxRates",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "AccountingTaxRate",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "GetAccountingVendorInput",
        "inputFields": [
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "GetAccountingVendorResponse",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "vendor",
            "type": {
              "kind": "OBJECT",
              "name": "AccountingVendor",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "GetAccountingVendorsFilterInput",
        "inputFields": [
          {
            "name": "nameSearchQuery",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            }
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "GetAccountingVendorsInput",
        "inputFields": [
          {
            "name": "filter",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "GetAccountingVendorsFilterInput",
              "ofType": null
            }
          },
          {
            "name": "paginationInput",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "PaginationInput",
              "ofType": null
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "GetAccountingVendorsResponse",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "pageInfo",
            "type": {
              "kind": "OBJECT",
              "name": "Pagination",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "vendors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "AccountingVendor",
                  "ofType": null
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          },
          {
            "kind": "INTERFACE",
            "name": "PaginatedResponse"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "GetAccountsFilterInput",
        "inputFields": [
          {
            "name": "accountType",
            "type": {
              "kind": "ENUM",
              "name": "AccountType",
              "ofType": null
            }
          },
          {
            "name": "creditAccountRepaymentEligible",
            "type": {
              "kind": "SCALAR",
              "name": "Boolean",
              "ofType": null
            }
          },
          {
            "name": "currency",
            "type": {
              "kind": "ENUM",
              "name": "Currency",
              "ofType": null
            }
          },
          {
            "name": "payoutOnly",
            "type": {
              "kind": "SCALAR",
              "name": "Boolean",
              "ofType": null
            }
          },
          {
            "name": "statuses",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "ENUM",
                  "name": "AccountStatus",
                  "ofType": null
                }
              }
            }
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "GetAccountsInput",
        "inputFields": [
          {
            "name": "filter",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "GetAccountsFilterInput",
              "ofType": null
            }
          },
          {
            "name": "paginationInput",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "PaginationInput",
              "ofType": null
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "GetAccountsResponse",
        "fields": [
          {
            "name": "accounts",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "Account",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "pageInfo",
            "type": {
              "kind": "OBJECT",
              "name": "Pagination",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          },
          {
            "kind": "INTERFACE",
            "name": "PaginatedResponse"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "GetAccrualsFilterInput",
        "inputFields": [
          {
            "name": "accountingClassIds",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "SCALAR",
                  "name": "String",
                  "ofType": null
                }
              }
            }
          },
          {
            "name": "accountingDepartmentIds",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "SCALAR",
                  "name": "String",
                  "ofType": null
                }
              }
            }
          },
          {
            "name": "accountingLocationIds",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "SCALAR",
                  "name": "String",
                  "ofType": null
                }
              }
            }
          },
          {
            "name": "accrualDateSinceUtc",
            "type": {
              "kind": "SCALAR",
              "name": "Date",
              "ofType": null
            }
          },
          {
            "name": "accrualDateUntilUtc",
            "type": {
              "kind": "SCALAR",
              "name": "Date",
              "ofType": null
            }
          },
          {
            "name": "amountMax",
            "type": {
              "kind": "SCALAR",
              "name": "Float",
              "ofType": null
            }
          },
          {
            "name": "amountMin",
            "type": {
              "kind": "SCALAR",
              "name": "Float",
              "ofType": null
            }
          },
          {
            "name": "expenseAccountIds",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "SCALAR",
                  "name": "String",
                  "ofType": null
                }
              }
            }
          },
          {
            "name": "liabilityAccountIds",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "SCALAR",
                  "name": "String",
                  "ofType": null
                }
              }
            }
          },
          {
            "name": "recipientIds",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "SCALAR",
                  "name": "String",
                  "ofType": null
                }
              }
            }
          },
          {
            "name": "statuses",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "ENUM",
                  "name": "SuperSheetsAccrualStatus",
                  "ofType": null
                }
              }
            }
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "GetAccrualsInput",
        "inputFields": [
          {
            "name": "filter",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "INPUT_OBJECT",
                "name": "GetAccrualsFilterInput",
                "ofType": null
              }
            }
          },
          {
            "name": "pagination",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "INPUT_OBJECT",
                "name": "PaginationInput",
                "ofType": null
              }
            }
          },
          {
            "name": "sort",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "INPUT_OBJECT",
                "name": "GetAccrualsSortInput",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "GetAccrualsResponse",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "expenseAccruals",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "ExpenseAccrual",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "pageInfo",
            "type": {
              "kind": "OBJECT",
              "name": "Pagination",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          },
          {
            "kind": "INTERFACE",
            "name": "PaginatedResponse"
          }
        ]
      },
      {
        "kind": "ENUM",
        "name": "GetAccrualsSortColumn",
        "enumValues": [
          {
            "name": "ACCRUAL_DATE"
          },
          {
            "name": "AMOUNT"
          },
          {
            "name": "CREATED_AT"
          },
          {
            "name": "POSTED_AT"
          },
          {
            "name": "RECIPIENT_NAME"
          },
          {
            "name": "STATUS"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "GetAccrualsSortInput",
        "inputFields": [
          {
            "name": "sortColumn",
            "type": {
              "kind": "ENUM",
              "name": "GetAccrualsSortColumn",
              "ofType": null
            }
          },
          {
            "name": "sortOrder",
            "type": {
              "kind": "ENUM",
              "name": "OrderBy",
              "ofType": null
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "GetActivationChecklistResponse",
        "fields": [
          {
            "name": "checklist",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "ActivationChecklistItem",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "GetActivitiesFilterInput",
        "inputFields": [
          {
            "name": "activityTypes",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "ENUM",
                  "name": "ActivityType",
                  "ofType": null
                }
              }
            },
            "defaultValue": "null"
          },
          {
            "name": "amountMax",
            "type": {
              "kind": "SCALAR",
              "name": "Float",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "amountMin",
            "type": {
              "kind": "SCALAR",
              "name": "Float",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "currencies",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "ENUM",
                  "name": "Currency",
                  "ofType": null
                }
              }
            },
            "defaultValue": "null"
          },
          {
            "name": "isBillPayment",
            "type": {
              "kind": "SCALAR",
              "name": "Boolean",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "paymentMethod",
            "type": {
              "kind": "ENUM",
              "name": "PaymentMethod",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "recipientIds",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                }
              }
            },
            "defaultValue": "null"
          },
          {
            "name": "searchQuery",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "since",
            "type": {
              "kind": "SCALAR",
              "name": "DateTime",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "statuses",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "ENUM",
                  "name": "ExecutionStatus",
                  "ofType": null
                }
              }
            },
            "defaultValue": "[COMPLETED]"
          },
          {
            "name": "until",
            "type": {
              "kind": "SCALAR",
              "name": "DateTime",
              "ofType": null
            },
            "defaultValue": "null"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "GetActivitiesInput",
        "inputFields": [
          {
            "name": "filter",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "GetActivitiesFilterInput",
              "ofType": null
            }
          },
          {
            "name": "paginationInput",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "PaginationInput",
              "ofType": null
            }
          },
          {
            "name": "sort",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "GetActivitiesSortInput",
              "ofType": null
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "GetActivitiesResponse",
        "fields": [
          {
            "name": "activities",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "Activity",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "pageInfo",
            "type": {
              "kind": "OBJECT",
              "name": "Pagination",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          },
          {
            "kind": "INTERFACE",
            "name": "PaginatedResponse"
          }
        ]
      },
      {
        "kind": "ENUM",
        "name": "GetActivitiesSortColumn",
        "enumValues": [
          {
            "name": "DATE"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "GetActivitiesSortInput",
        "inputFields": [
          {
            "name": "sortColumn",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "GetActivitiesSortColumn",
                "ofType": null
              }
            }
          },
          {
            "name": "sortOrder",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "OrderBy",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "GetActivityInput",
        "inputFields": [
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "GetActivityResponse",
        "fields": [
          {
            "name": "activity",
            "type": {
              "kind": "OBJECT",
              "name": "Activity",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "GetAnnotationTasksFilterInput",
        "inputFields": [
          {
            "name": "objectOrgId",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "schemaType",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "SchemaType",
                "ofType": null
              }
            }
          },
          {
            "name": "status",
            "type": {
              "kind": "ENUM",
              "name": "AnnotationTaskStatus",
              "ofType": null
            },
            "defaultValue": "ACTIVE"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "GetAnnotationTasksInput",
        "inputFields": [
          {
            "name": "filter",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "INPUT_OBJECT",
                "name": "GetAnnotationTasksFilterInput",
                "ofType": null
              }
            }
          },
          {
            "name": "pagination",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "PaginationInput",
              "ofType": null
            },
            "defaultValue": "null"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "GetAnnotationTasksResponse",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "pageInfo",
            "type": {
              "kind": "OBJECT",
              "name": "Pagination",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "tasks",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "AnnotationTask",
                  "ofType": null
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          },
          {
            "kind": "INTERFACE",
            "name": "PaginatedResponse"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "GetApiKeysResponse",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "keys",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "ApiKey",
                  "ofType": null
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "GetApplicationInput",
        "inputFields": [
          {
            "name": "applicationId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "GetApplicationResponse",
        "fields": [
          {
            "name": "application",
            "type": {
              "kind": "OBJECT",
              "name": "Application",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "GetApplicationsResponse",
        "fields": [
          {
            "name": "applications",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "ApplicationSummary",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "GetAssistantBoardInput",
        "inputFields": [
          {
            "name": "boardId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "GetAssistantBoardResponse",
        "fields": [
          {
            "name": "board",
            "type": {
              "kind": "OBJECT",
              "name": "AssistantBoard",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "GetAssistantThreadInput",
        "inputFields": [
          {
            "name": "fromEventId",
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "limit",
            "type": {
              "kind": "SCALAR",
              "name": "Int",
              "ofType": null
            },
            "defaultValue": "50"
          },
          {
            "name": "threadId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "GetAssistantThreadResponse",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "thread",
            "type": {
              "kind": "OBJECT",
              "name": "AssistantThread",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "GetAssistantThreadsResponse",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "pagination",
            "type": {
              "kind": "OBJECT",
              "name": "Pagination",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "threads",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "AssistantThread",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "GetBillInput",
        "inputFields": [
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "GetBillResponse",
        "fields": [
          {
            "name": "bill",
            "type": {
              "kind": "OBJECT",
              "name": "Bill",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "processingState",
            "type": {
              "kind": "OBJECT",
              "name": "BillProcessingState",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "GetBillingAddressResponse",
        "fields": [
          {
            "name": "address",
            "type": {
              "kind": "OBJECT",
              "name": "Address",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "GetBillsEmailInboxAddressResponse",
        "fields": [
          {
            "name": "billsEmailAddress",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "GetBillsFilterInput",
        "inputFields": [
          {
            "name": "amountMax",
            "type": {
              "kind": "SCALAR",
              "name": "Float",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "amountMin",
            "type": {
              "kind": "SCALAR",
              "name": "Float",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "currency",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "ENUM",
                    "name": "Currency",
                    "ofType": null
                  }
                }
              }
            },
            "defaultValue": "[]"
          },
          {
            "name": "dueDateSince",
            "type": {
              "kind": "SCALAR",
              "name": "Date",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "dueDateUntil",
            "type": {
              "kind": "SCALAR",
              "name": "Date",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "invoiceDateSince",
            "type": {
              "kind": "SCALAR",
              "name": "Date",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "invoiceDateUntil",
            "type": {
              "kind": "SCALAR",
              "name": "Date",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "recipientId",
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "statuses",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "ENUM",
                    "name": "BillStatus",
                    "ofType": null
                  }
                }
              }
            },
            "defaultValue": "[]"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "GetBillsInput",
        "inputFields": [
          {
            "name": "filter",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "GetBillsFilterInput",
              "ofType": null
            }
          },
          {
            "name": "pagination",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "PaginationInput",
              "ofType": null
            }
          },
          {
            "name": "sort",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "GetBillsSortInput",
              "ofType": null
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "GetBillsResponse",
        "fields": [
          {
            "name": "bills",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "Bill",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "pageInfo",
            "type": {
              "kind": "OBJECT",
              "name": "Pagination",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          },
          {
            "kind": "INTERFACE",
            "name": "PaginatedResponse"
          }
        ]
      },
      {
        "kind": "ENUM",
        "name": "GetBillsSortColumn",
        "enumValues": [
          {
            "name": "BILL_DATE"
          },
          {
            "name": "CREATED_AT"
          },
          {
            "name": "DUE_DATE"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "GetBillsSortInput",
        "inputFields": [
          {
            "name": "sortColumn",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "GetBillsSortColumn",
                "ofType": null
              }
            }
          },
          {
            "name": "sortOrder",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "OrderBy",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "GetBrandingPreferencesResponse",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "preferences",
            "type": {
              "kind": "OBJECT",
              "name": "BrandingPreferences",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "GetBulkPaymentResponse",
        "fields": [
          {
            "name": "bulkPayment",
            "type": {
              "kind": "OBJECT",
              "name": "BulkPayment",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "GetCardAuthorizationsInput",
        "inputFields": [
          {
            "name": "accountId",
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            }
          },
          {
            "name": "amountMax",
            "type": {
              "kind": "SCALAR",
              "name": "Float",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "amountMin",
            "type": {
              "kind": "SCALAR",
              "name": "Float",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "cardId",
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            }
          },
          {
            "name": "funding",
            "type": {
              "kind": "ENUM",
              "name": "FundingType",
              "ofType": null
            }
          },
          {
            "name": "paginationInput",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "PaginationInput",
              "ofType": null
            }
          },
          {
            "name": "since",
            "type": {
              "kind": "SCALAR",
              "name": "DateTime",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "until",
            "type": {
              "kind": "SCALAR",
              "name": "DateTime",
              "ofType": null
            },
            "defaultValue": "null"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "GetCardAuthorizationsResponse",
        "fields": [
          {
            "name": "authorizations",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "CardAuthorization",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "pageInfo",
            "type": {
              "kind": "OBJECT",
              "name": "Pagination",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          },
          {
            "kind": "INTERFACE",
            "name": "PaginatedResponse"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "GetConnectedAccountInput",
        "inputFields": [
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "GetConnectedAccountResponse",
        "fields": [
          {
            "name": "account",
            "type": {
              "kind": "OBJECT",
              "name": "ConnectedAccount",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "GetConnectedAccountsResponse",
        "fields": [
          {
            "name": "accounts",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "ConnectedAccount",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "GetContractInput",
        "inputFields": [
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "GetContractResponse",
        "fields": [
          {
            "name": "contract",
            "type": {
              "kind": "OBJECT",
              "name": "Contract",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "GetContractsCashManagementInput",
        "inputFields": [
          {
            "name": "endDate",
            "type": {
              "kind": "SCALAR",
              "name": "Date",
              "ofType": null
            }
          },
          {
            "name": "frequency",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "Frequency",
                "ofType": null
              }
            },
            "defaultValue": "MONTHLY"
          },
          {
            "name": "startDate",
            "type": {
              "kind": "SCALAR",
              "name": "Date",
              "ofType": null
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "GetContractsCashManagementResponse",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "UNION",
                  "name": "DefaultOrAccountingConnectionRequiredError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "variance",
            "type": {
              "kind": "OBJECT",
              "name": "ContractsVariance",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "GetContractsCashflowFilterInput",
        "inputFields": [
          {
            "name": "endDate",
            "type": {
              "kind": "SCALAR",
              "name": "Date",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "includeFullAggregateEndPeriod",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "defaultValue": "true"
          },
          {
            "name": "includeFullAggregateStartPeriod",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "defaultValue": "false"
          },
          {
            "name": "startDate",
            "type": {
              "kind": "SCALAR",
              "name": "Date",
              "ofType": null
            },
            "defaultValue": "null"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "GetContractsCashflowGroupByInput",
        "inputFields": [
          {
            "name": "aggregationPeriod",
            "type": {
              "kind": "ENUM",
              "name": "ContractsCashflowAggregatePeriod",
              "ofType": null
            },
            "defaultValue": "YEAR"
          },
          {
            "name": "frequency",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "Frequency",
                "ofType": null
              }
            },
            "defaultValue": "MONTHLY"
          },
          {
            "name": "rowCategory",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "ContractsCashflowRowCategory",
                "ofType": null
              }
            },
            "defaultValue": "CONTRACT"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "GetContractsCashflowInput",
        "inputFields": [
          {
            "name": "filter",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "INPUT_OBJECT",
                "name": "GetContractsCashflowFilterInput",
                "ofType": null
              }
            },
            "defaultValue": "{endDate: null, includeFullAggregateEndPeriod: true, includeFullAggregateStartPeriod: false, startDate: null}"
          },
          {
            "name": "groupBy",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "INPUT_OBJECT",
                "name": "GetContractsCashflowGroupByInput",
                "ofType": null
              }
            },
            "defaultValue": "{aggregationPeriod: YEAR, frequency: MONTHLY, rowCategory: CONTRACT}"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "GetContractsCashflowResponse",
        "fields": [
          {
            "name": "cells",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "OBJECT",
                        "name": "ContractsCashflowCell",
                        "ofType": null
                      }
                    }
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "columnAggregates",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "ContractsCashflowAggregate",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "columnMetadata",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "ContractsCashflowColumnMetadata",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "rowAggregateColumnMetadata",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "ContractsCashflowColumnMetadata",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "rowAggregates",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "OBJECT",
                        "name": "ContractsCashflowAggregate",
                        "ofType": null
                      }
                    }
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "rowMetadata",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "ContractsCashflowRowMetadata",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "tableAggregates",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "ContractsCashflowAggregate",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "GetContractsFilterInput",
        "inputFields": [
          {
            "name": "recipientId",
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "sameSeriesAsContractId",
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "statuses",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "ENUM",
                  "name": "ContractStatus",
                  "ofType": null
                }
              }
            },
            "defaultValue": "null"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "GetContractsInput",
        "inputFields": [
          {
            "name": "filter",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "GetContractsFilterInput",
              "ofType": null
            }
          },
          {
            "name": "pagination",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "PaginationInput",
              "ofType": null
            }
          },
          {
            "name": "sort",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "GetContractsSortInput",
              "ofType": null
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "GetContractsResponse",
        "fields": [
          {
            "name": "contracts",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "Contract",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "pageInfo",
            "type": {
              "kind": "OBJECT",
              "name": "Pagination",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          },
          {
            "kind": "INTERFACE",
            "name": "PaginatedResponse"
          }
        ]
      },
      {
        "kind": "ENUM",
        "name": "GetContractsSortColumn",
        "enumValues": [
          {
            "name": "DISPLAY_NAME"
          },
          {
            "name": "NEXT_PAYMENT_DUE_DATE"
          },
          {
            "name": "SEQUENCE"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "GetContractsSortInput",
        "inputFields": [
          {
            "name": "sortColumn",
            "type": {
              "kind": "ENUM",
              "name": "GetContractsSortColumn",
              "ofType": null
            }
          },
          {
            "name": "sortOrder",
            "type": {
              "kind": "ENUM",
              "name": "OrderBy",
              "ofType": null
            }
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "GetConversionTimelineInput",
        "inputFields": [
          {
            "name": "destinationCurrency",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            }
          },
          {
            "name": "requestTime",
            "type": {
              "kind": "SCALAR",
              "name": "DateTime",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "sourceCurrency",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "GetCreditApplicationResponse",
        "fields": [
          {
            "name": "application",
            "type": {
              "kind": "OBJECT",
              "name": "CreditApplication",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "GetCurrentUserCustomersResponse",
        "fields": [
          {
            "name": "customers",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "Customer",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "GetCustomerTierSettingsResponse",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "tierSettings",
            "type": {
              "kind": "UNION",
              "name": "TierSettings",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "GetDepartmentsResponse",
        "fields": [
          {
            "name": "departments",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "Department",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "GetDocusignAuthUrlInput",
        "inputFields": [
          {
            "name": "sessionState",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "GetDocusignConnectionsResponse",
        "fields": [
          {
            "name": "connections",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "DocusignConnection",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "GetEligibleBusinessContactUsersInput",
        "inputFields": [
          {
            "name": "customerId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "GetEligibleBusinessContactUsersResponse",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "users",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "User",
                  "ofType": null
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "GetEventInstanceInput",
        "inputFields": [
          {
            "name": "eventId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            }
          },
          {
            "name": "ordinal",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "GetEventInstanceResponse",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "eventInstance",
            "type": {
              "kind": "UNION",
              "name": "EventInstance",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "GetEventInstancesInput",
        "inputFields": [
          {
            "name": "approvalStatus",
            "type": {
              "kind": "ENUM",
              "name": "ApprovalRequestStatus",
              "ofType": null
            },
            "defaultValue": "APPROVED"
          },
          {
            "name": "endDateInclusive",
            "type": {
              "kind": "SCALAR",
              "name": "Date",
              "ofType": null
            }
          },
          {
            "name": "instanceType",
            "type": {
              "kind": "ENUM",
              "name": "EventInstanceType",
              "ofType": null
            }
          },
          {
            "name": "paginationInput",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "PaginationInput",
              "ofType": null
            },
            "defaultValue": "{}"
          },
          {
            "name": "sort",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "GetEventInstancesSortInput",
              "ofType": null
            },
            "defaultValue": "{}"
          },
          {
            "name": "startDateInclusive",
            "type": {
              "kind": "SCALAR",
              "name": "Date",
              "ofType": null
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "GetEventInstancesResponse",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "eventInstances",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "UNION",
                  "name": "EventInstance",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "pageInfo",
            "type": {
              "kind": "OBJECT",
              "name": "Pagination",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          },
          {
            "kind": "INTERFACE",
            "name": "PaginatedResponse"
          }
        ]
      },
      {
        "kind": "ENUM",
        "name": "GetEventInstancesSortColumn",
        "enumValues": [
          {
            "name": "SCHEDULED_DATE"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "GetEventInstancesSortInput",
        "inputFields": [
          {
            "name": "sortColumn",
            "type": {
              "kind": "ENUM",
              "name": "GetEventInstancesSortColumn",
              "ofType": null
            }
          },
          {
            "name": "sortOrder",
            "type": {
              "kind": "ENUM",
              "name": "OrderBy",
              "ofType": null
            }
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "GetExpectedPaymentApprovalFlowInput",
        "inputFields": [
          {
            "name": "destinationAmount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "INPUT_OBJECT",
                "name": "VariableMoneyInput",
                "ofType": null
              }
            }
          },
          {
            "name": "fixedAmount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "FixedAmount",
                "ofType": null
              }
            }
          },
          {
            "name": "forceManualApproval",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "defaultValue": "false"
          },
          {
            "name": "newRecipientManagerId",
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            }
          },
          {
            "name": "recipientId",
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            }
          },
          {
            "name": "sourceAmount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "INPUT_OBJECT",
                "name": "VariableMoneyInput",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "GetFileInput",
        "inputFields": [
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "GetFileResponse",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "file",
            "type": {
              "kind": "OBJECT",
              "name": "File",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "GetFundingInstructionsPdfResponse",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "pdfUrl",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "GetGoogleConnectionResponse",
        "fields": [
          {
            "name": "connection",
            "type": {
              "kind": "OBJECT",
              "name": "GoogleConnection",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "GetInvoiceInput",
        "inputFields": [
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "GetInvoiceResponse",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "invoice",
            "type": {
              "kind": "OBJECT",
              "name": "Invoice",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "GetInvoicesFilterInput",
        "inputFields": [
          {
            "name": "amountMax",
            "type": {
              "kind": "SCALAR",
              "name": "Float",
              "ofType": null
            }
          },
          {
            "name": "amountMin",
            "type": {
              "kind": "SCALAR",
              "name": "Float",
              "ofType": null
            }
          },
          {
            "name": "currency",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "ENUM",
                    "name": "Currency",
                    "ofType": null
                  }
                }
              }
            },
            "defaultValue": "[]"
          },
          {
            "name": "dueDateSince",
            "type": {
              "kind": "SCALAR",
              "name": "Date",
              "ofType": null
            }
          },
          {
            "name": "dueDateUntil",
            "type": {
              "kind": "SCALAR",
              "name": "Date",
              "ofType": null
            }
          },
          {
            "name": "invoiceDateSince",
            "type": {
              "kind": "SCALAR",
              "name": "Date",
              "ofType": null
            }
          },
          {
            "name": "invoiceDateUntil",
            "type": {
              "kind": "SCALAR",
              "name": "Date",
              "ofType": null
            }
          },
          {
            "name": "payerId",
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            }
          },
          {
            "name": "statuses",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "ENUM",
                    "name": "InvoiceStatus",
                    "ofType": null
                  }
                }
              }
            },
            "defaultValue": "[]"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "GetInvoicesInput",
        "inputFields": [
          {
            "name": "filter",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "GetInvoicesFilterInput",
              "ofType": null
            }
          },
          {
            "name": "pagination",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "PaginationInput",
              "ofType": null
            }
          },
          {
            "name": "sort",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "GetInvoicesSortInput",
              "ofType": null
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "GetInvoicesResponse",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "invoices",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "Invoice",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "pageInfo",
            "type": {
              "kind": "OBJECT",
              "name": "Pagination",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          },
          {
            "kind": "INTERFACE",
            "name": "PaginatedResponse"
          }
        ]
      },
      {
        "kind": "ENUM",
        "name": "GetInvoicesSortColumn",
        "enumValues": [
          {
            "name": "CREATED_AT"
          },
          {
            "name": "DUE_DATE"
          },
          {
            "name": "INVOICE_DATE"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "GetInvoicesSortInput",
        "inputFields": [
          {
            "name": "sortColumn",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "GetInvoicesSortColumn",
                "ofType": null
              }
            }
          },
          {
            "name": "sortOrder",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "OrderBy",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "GetMultiLayerApprovalRulesRequest",
        "inputFields": [
          {
            "name": "id",
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            }
          },
          {
            "name": "requestedType",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "RequestedType",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "GetMultiLayerApprovalRulesResponse",
        "fields": [
          {
            "name": "approvalRules",
            "type": {
              "kind": "OBJECT",
              "name": "MultiLayerApprovalRules",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "GetMultiLayerApprovalRulesVersionsRequest",
        "inputFields": [
          {
            "name": "requestedType",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "RequestedType",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "GetMultiLayerApprovalRulesVersionsResponse",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "versions",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "MultiLayerApprovalRulesVersion",
                  "ofType": null
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "GetNominalAccountsResponse",
        "fields": [
          {
            "name": "accounts",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "NominalAccount",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "GetOmiUserProfileResponse",
        "fields": [
          {
            "name": "contractsEmailAddress",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "GetOrgsWithTasksInput",
        "inputFields": [
          {
            "name": "schemaType",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "SchemaType",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "GetOrgsWithTasksResponse",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "orgs",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "Org",
                  "ofType": null
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "GetPayerInput",
        "inputFields": [
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "GetPayerResponse",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "payer",
            "type": {
              "kind": "OBJECT",
              "name": "Payer",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "GetPayersFilterInput",
        "inputFields": [
          {
            "name": "nameSearchQuery",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            }
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "GetPayersInput",
        "inputFields": [
          {
            "name": "filter",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "GetPayersFilterInput",
              "ofType": null
            }
          },
          {
            "name": "paginationInput",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "PaginationInput",
              "ofType": null
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "GetPayersResponse",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "pageInfo",
            "type": {
              "kind": "OBJECT",
              "name": "Pagination",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "payers",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "Payer",
                  "ofType": null
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          },
          {
            "kind": "INTERFACE",
            "name": "PaginatedResponse"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "GetPayment2Response",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "payment",
            "type": {
              "kind": "OBJECT",
              "name": "Payment2Details",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "GetPaymentFeesInput",
        "inputFields": [
          {
            "name": "chargeType",
            "type": {
              "kind": "ENUM",
              "name": "SWIFTChargeType",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "destinationAmount",
            "type": {
              "kind": "SCALAR",
              "name": "Float",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "fixedAmount",
            "type": {
              "kind": "ENUM",
              "name": "FixedAmount",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "paymentMethod",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "PaymentMethod",
                "ofType": null
              }
            }
          },
          {
            "name": "recipientCountry",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "recipientCurrency",
            "type": {
              "kind": "ENUM",
              "name": "Currency",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "recipientId",
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "sourceAmount",
            "type": {
              "kind": "SCALAR",
              "name": "Float",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "sourceCurrency",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "GetPaymentFeesResponse",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "fee",
            "type": {
              "kind": "UNION",
              "name": "Fee",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "GetPaymentTimelineInput",
        "inputFields": [
          {
            "name": "fundingMethod",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "FundingMethodInput",
              "ofType": null
            }
          },
          {
            "name": "method",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "PaymentMethod",
                "ofType": null
              }
            }
          },
          {
            "name": "recipientId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            }
          },
          {
            "name": "requestTime",
            "type": {
              "kind": "SCALAR",
              "name": "DateTime",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "sourceAmount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "INPUT_OBJECT",
                "name": "VariableMoneyInput",
                "ofType": null
              }
            }
          },
          {
            "name": "sourceCurrency",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "GetPayments2Filters",
        "inputFields": [
          {
            "name": "bulkPaymentId",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "currencies",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "SCALAR",
                  "name": "String",
                  "ofType": null
                }
              }
            },
            "defaultValue": "null"
          },
          {
            "name": "currentUserCanResolve",
            "type": {
              "kind": "SCALAR",
              "name": "Boolean",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "destinationCurrencies",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "SCALAR",
                  "name": "String",
                  "ofType": null
                }
              }
            },
            "defaultValue": "null"
          },
          {
            "name": "maxAmount",
            "type": {
              "kind": "SCALAR",
              "name": "Float",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "methods",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "ENUM",
                  "name": "PaymentMethod",
                  "ofType": null
                }
              }
            },
            "defaultValue": "null"
          },
          {
            "name": "minAmount",
            "type": {
              "kind": "SCALAR",
              "name": "Float",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "paymentIds",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "SCALAR",
                  "name": "String",
                  "ofType": null
                }
              }
            },
            "defaultValue": "null"
          },
          {
            "name": "recipientIds",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "SCALAR",
                  "name": "String",
                  "ofType": null
                }
              }
            },
            "defaultValue": "null"
          },
          {
            "name": "requestedByIds",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "SCALAR",
                  "name": "String",
                  "ofType": null
                }
              }
            },
            "defaultValue": "null"
          },
          {
            "name": "scheduledDate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "INPUT_OBJECT",
                "name": "OptionalDateRangeInput",
                "ofType": null
              }
            },
            "defaultValue": "{fromInclusive: null, toInclusive: null}"
          },
          {
            "name": "searchQuery",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "sourceCurrencies",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "SCALAR",
                  "name": "String",
                  "ofType": null
                }
              }
            },
            "defaultValue": "null"
          },
          {
            "name": "statuses",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "ENUM",
                  "name": "PaymentStatus",
                  "ofType": null
                }
              }
            },
            "defaultValue": "null"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "GetPayments2Input",
        "inputFields": [
          {
            "name": "filters",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "INPUT_OBJECT",
                "name": "GetPayments2Filters",
                "ofType": null
              }
            },
            "defaultValue": "{bulkPaymentId: null, currencies: null, currentUserCanResolve: null, destinationCurrencies: null, maxAmount: null, methods: null, minAmount: null, paymentIds: null, recipientIds: null, requestedByIds: null, scheduledDate: {fromInclusive: null, toInclusive: null}, searchQuery: null, sourceCurrencies: null, statuses: null}"
          },
          {
            "name": "pagination",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "PaginationInput",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "sort",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "INPUT_OBJECT",
                "name": "GetPayments2SortInput",
                "ofType": null
              }
            },
            "defaultValue": "{direction: DESC, field: SCHEDULED_DATE}"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "GetPayments2Response",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "pageInfo",
            "type": {
              "kind": "OBJECT",
              "name": "Pagination",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "payments",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "Payment2",
                  "ofType": null
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          },
          {
            "kind": "INTERFACE",
            "name": "PaginatedResponse"
          }
        ]
      },
      {
        "kind": "ENUM",
        "name": "GetPayments2SortField",
        "enumValues": [
          {
            "name": "SCHEDULED_DATE"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "GetPayments2SortInput",
        "inputFields": [
          {
            "name": "direction",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "OrderBy",
                "ofType": null
              }
            }
          },
          {
            "name": "field",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "GetPayments2SortField",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "GetPaymentsFilterInput",
        "inputFields": [
          {
            "name": "amountMax",
            "type": {
              "kind": "SCALAR",
              "name": "Float",
              "ofType": null
            }
          },
          {
            "name": "amountMin",
            "type": {
              "kind": "SCALAR",
              "name": "Float",
              "ofType": null
            }
          },
          {
            "name": "createdSinceUtc",
            "type": {
              "kind": "SCALAR",
              "name": "Date",
              "ofType": null
            }
          },
          {
            "name": "createdUntilUtc",
            "type": {
              "kind": "SCALAR",
              "name": "Date",
              "ofType": null
            }
          },
          {
            "name": "dueDateSinceUtc",
            "type": {
              "kind": "SCALAR",
              "name": "Date",
              "ofType": null
            }
          },
          {
            "name": "dueDateUntilUtc",
            "type": {
              "kind": "SCALAR",
              "name": "Date",
              "ofType": null
            }
          },
          {
            "name": "recipientEmail",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            }
          },
          {
            "name": "recipientName",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            }
          },
          {
            "name": "searchQuery",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            }
          },
          {
            "name": "statuses",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "ENUM",
                  "name": "SuperSheetsPaymentStatus",
                  "ofType": null
                }
              }
            }
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "GetPaymentsInput",
        "inputFields": [
          {
            "name": "filter",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "GetPaymentsFilterInput",
              "ofType": null
            }
          },
          {
            "name": "pagination",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "PaginationInput",
              "ofType": null
            }
          },
          {
            "name": "sort",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "GetPaymentsSortInput",
              "ofType": null
            }
          }
        ]
      },
      {
        "kind": "ENUM",
        "name": "GetPaymentsSortColumn",
        "enumValues": [
          {
            "name": "AMOUNT"
          },
          {
            "name": "COMPLETED_AT"
          },
          {
            "name": "CREATED_AT"
          },
          {
            "name": "DUE_DATE"
          },
          {
            "name": "RECIPIENT_NAME"
          },
          {
            "name": "STATUS"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "GetPaymentsSortInput",
        "inputFields": [
          {
            "name": "sortColumn",
            "type": {
              "kind": "ENUM",
              "name": "GetPaymentsSortColumn",
              "ofType": null
            }
          },
          {
            "name": "sortOrder",
            "type": {
              "kind": "ENUM",
              "name": "OrderBy",
              "ofType": null
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "GetPendingCreditAccountRepaymentsResponse",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "repayments",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "CreditAccountRepayment",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "GetPendingCreditApplicationsResponse",
        "fields": [
          {
            "name": "creditApplications",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "CreditApplication",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "GetPreferencesResponse",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "preferences",
            "type": {
              "kind": "OBJECT",
              "name": "Preferences",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "GetProcurementRequestsInput",
        "inputFields": [
          {
            "name": "approvalStatus",
            "type": {
              "kind": "ENUM",
              "name": "ApprovalRequestStatus",
              "ofType": null
            }
          },
          {
            "name": "currentUserCanResolve",
            "type": {
              "kind": "SCALAR",
              "name": "Boolean",
              "ofType": null
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "GetProcurementRequestsResponse",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "requests",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "ProcurementRequest",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "GetRatesInput",
        "inputFields": [
          {
            "name": "conversionDate",
            "type": {
              "kind": "SCALAR",
              "name": "DateTime",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "destinationCurrency",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            }
          },
          {
            "name": "sourceCurrency",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "GetRatesResponse",
        "fields": [
          {
            "name": "currencyPairNotTradeable",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "rate",
            "type": {
              "kind": "UNION",
              "name": "RateInfo",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "GetRecipientAccountingDefaultsInput",
        "inputFields": [
          {
            "name": "recipientId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "GetRecipientInput",
        "inputFields": [
          {
            "name": "approvalStatuses",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "ENUM",
                    "name": "ApprovalRequestStatus",
                    "ofType": null
                  }
                }
              }
            },
            "defaultValue": "[APPROVED]"
          },
          {
            "name": "recipientId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            }
          },
          {
            "name": "versionId",
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            }
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "GetRecipientInvitationsInput",
        "inputFields": [
          {
            "name": "paginationInput",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "PaginationInput",
              "ofType": null
            }
          },
          {
            "name": "statuses",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "ENUM",
                  "name": "RecipientInvitationStatus",
                  "ofType": null
                }
              }
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "GetRecipientInvitationsResponse",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "pageInfo",
            "type": {
              "kind": "OBJECT",
              "name": "Pagination",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "recipientInvitations",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "RecipientInvitation",
                  "ofType": null
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          },
          {
            "kind": "INTERFACE",
            "name": "PaginatedResponse"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "GetRecipientPaymentInput",
        "inputFields": [
          {
            "name": "paymentId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            }
          },
          {
            "name": "recipientId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "GetRecipientPaymentResponse",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "payment",
            "type": {
              "kind": "OBJECT",
              "name": "RecipientPayment",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "GetRecipientPaymentsFilter",
        "inputFields": [
          {
            "name": "amountMax",
            "type": {
              "kind": "SCALAR",
              "name": "Float",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "amountMin",
            "type": {
              "kind": "SCALAR",
              "name": "Float",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "since",
            "type": {
              "kind": "SCALAR",
              "name": "DateTime",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "until",
            "type": {
              "kind": "SCALAR",
              "name": "DateTime",
              "ofType": null
            },
            "defaultValue": "null"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "GetRecipientPaymentsInput",
        "inputFields": [
          {
            "name": "filter",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "GetRecipientPaymentsFilter",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "pagination",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "PaginationInput",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "recipientId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            }
          },
          {
            "name": "sort",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "GetActivitiesSortInput",
              "ofType": null
            },
            "defaultValue": "null"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "GetRecipientPaymentsResponse",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "pageInfo",
            "type": {
              "kind": "OBJECT",
              "name": "Pagination",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "payments",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "RecipientPayment",
                  "ofType": null
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          },
          {
            "kind": "INTERFACE",
            "name": "PaginatedResponse"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "GetRecipientResponse",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "recipient",
            "type": {
              "kind": "OBJECT",
              "name": "Recipient",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "GetRecipientTaxFormInput",
        "inputFields": [
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "GetRecipientTaxFormResponse",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "taxForm",
            "type": {
              "kind": "OBJECT",
              "name": "RecipientTaxForm",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "GetRecipientsInput",
        "inputFields": [
          {
            "name": "filter",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "RecipientsFilter",
              "ofType": null
            }
          },
          {
            "name": "paginationInput",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "PaginationInput",
              "ofType": null
            }
          },
          {
            "name": "sort",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "GetRecipientsSortInput",
              "ofType": null
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "GetRecipientsResponse",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "pageInfo",
            "type": {
              "kind": "OBJECT",
              "name": "Pagination",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "recipients",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "Recipient",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          },
          {
            "kind": "INTERFACE",
            "name": "PaginatedResponse"
          }
        ]
      },
      {
        "kind": "ENUM",
        "name": "GetRecipientsSortColumn",
        "enumValues": [
          {
            "name": "CREATED_AT"
          },
          {
            "name": "CURRENCY"
          },
          {
            "name": "NAME"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "GetRecipientsSortInput",
        "inputFields": [
          {
            "name": "sortColumn",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "GetRecipientsSortColumn",
                "ofType": null
              }
            }
          },
          {
            "name": "sortOrder",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "OrderBy",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "GetRecipientsWithoutContractFilterInput",
        "inputFields": [
          {
            "name": "isAccountingVendor",
            "type": {
              "kind": "SCALAR",
              "name": "Boolean",
              "ofType": null
            },
            "defaultValue": "true"
          },
          {
            "name": "isImportantRecipient",
            "type": {
              "kind": "SCALAR",
              "name": "Boolean",
              "ofType": null
            },
            "defaultValue": "true"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "GetRecipientsWithoutContractInput",
        "inputFields": [
          {
            "name": "filter",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "GetRecipientsWithoutContractFilterInput",
              "ofType": null
            },
            "defaultValue": "{isAccountingVendor: true, isImportantRecipient: true}"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "GetRecipientsWithoutContractResponse",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "pageInfo",
            "type": {
              "kind": "OBJECT",
              "name": "Pagination",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "recipients",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "Recipient",
                  "ofType": null
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          },
          {
            "kind": "INTERFACE",
            "name": "PaginatedResponse"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "GetScheduledEventInput",
        "inputFields": [
          {
            "name": "eventId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "GetScheduledEventResponse",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "event",
            "type": {
              "kind": "UNION",
              "name": "ScheduledEvent",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "GetScheduledEventsInput",
        "inputFields": [
          {
            "name": "amountMax",
            "type": {
              "kind": "SCALAR",
              "name": "Float",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "amountMin",
            "type": {
              "kind": "SCALAR",
              "name": "Float",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "approvalStatuses",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "ENUM",
                  "name": "ApprovalRequestStatus",
                  "ofType": null
                }
              }
            },
            "defaultValue": "[APPROVED]"
          },
          {
            "name": "currencies",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "ENUM",
                  "name": "Currency",
                  "ofType": null
                }
              }
            },
            "defaultValue": "null"
          },
          {
            "name": "fundingStatuses",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "ENUM",
                  "name": "FundingStatus",
                  "ofType": null
                }
              }
            },
            "defaultValue": "null"
          },
          {
            "name": "paginationInput",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "PaginationInput",
              "ofType": null
            },
            "defaultValue": "{}"
          },
          {
            "name": "pendingApprovalByCurrentUser",
            "type": {
              "kind": "SCALAR",
              "name": "Boolean",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "recipientIds",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                }
              }
            },
            "defaultValue": "null"
          },
          {
            "name": "requesterUserId",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "scheduleCategory",
            "type": {
              "kind": "ENUM",
              "name": "ScheduleCategory",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "selfApproved",
            "type": {
              "kind": "SCALAR",
              "name": "Boolean",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "since",
            "type": {
              "kind": "SCALAR",
              "name": "DateTime",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "sortInput",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "GetScheduledEventsSortInput",
              "ofType": null
            }
          },
          {
            "name": "statuses",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "ENUM",
                  "name": "ScheduledEventStatus",
                  "ofType": null
                }
              }
            },
            "defaultValue": "null"
          },
          {
            "name": "until",
            "type": {
              "kind": "SCALAR",
              "name": "DateTime",
              "ofType": null
            },
            "defaultValue": "null"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "GetScheduledEventsResponse",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "events",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "UNION",
                  "name": "ScheduledEvent",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "pageInfo",
            "type": {
              "kind": "OBJECT",
              "name": "Pagination",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          },
          {
            "kind": "INTERFACE",
            "name": "PaginatedResponse"
          }
        ]
      },
      {
        "kind": "ENUM",
        "name": "GetScheduledEventsSortColumn",
        "enumValues": [
          {
            "name": "DATE"
          },
          {
            "name": "RECIPIENT_NAME"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "GetScheduledEventsSortInput",
        "inputFields": [
          {
            "name": "sortColumn",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "GetScheduledEventsSortColumn",
                "ofType": null
              }
            }
          },
          {
            "name": "sortOrder",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "OrderBy",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "GetSheetsTierSettingsResponse",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "tierSettings",
            "type": {
              "kind": "OBJECT",
              "name": "SheetsTierSettings",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "GetSlackConnectionResponse",
        "fields": [
          {
            "name": "connection",
            "type": {
              "kind": "OBJECT",
              "name": "SlackConnection",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "ENUM",
        "name": "GetStatementsSortColumn",
        "enumValues": [
          {
            "name": "PERIOD"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "GetTransactionInput",
        "inputFields": [
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "GetTransactionResponse",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "transaction",
            "type": {
              "kind": "OBJECT",
              "name": "Transaction",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "GetTransactionsFilterInput",
        "inputFields": [
          {
            "name": "accountId",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "amountMax",
            "type": {
              "kind": "SCALAR",
              "name": "Float",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "amountMin",
            "type": {
              "kind": "SCALAR",
              "name": "Float",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "cardHolderId",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "cardId",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "currency",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "ENUM",
                  "name": "Currency",
                  "ofType": null
                }
              }
            },
            "defaultValue": "null"
          },
          {
            "name": "fundingType",
            "type": {
              "kind": "ENUM",
              "name": "FundingType",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "recipientId",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "searchQuery",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "since",
            "type": {
              "kind": "SCALAR",
              "name": "Date",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "transactionTypes",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "ENUM",
                  "name": "TransactionType",
                  "ofType": null
                }
              }
            },
            "defaultValue": "null"
          },
          {
            "name": "until",
            "type": {
              "kind": "SCALAR",
              "name": "Date",
              "ofType": null
            },
            "defaultValue": "null"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "GetTransactionsInput",
        "inputFields": [
          {
            "name": "filter",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "GetTransactionsFilterInput",
              "ofType": null
            }
          },
          {
            "name": "paginationInput",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "PaginationInput",
              "ofType": null
            }
          },
          {
            "name": "sort",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "GetTransactionsSortInput",
              "ofType": null
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "GetTransactionsResponse",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "pageInfo",
            "type": {
              "kind": "OBJECT",
              "name": "Pagination",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "transactions",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "Transaction",
                  "ofType": null
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          },
          {
            "kind": "INTERFACE",
            "name": "PaginatedResponse"
          }
        ]
      },
      {
        "kind": "ENUM",
        "name": "GetTransactionsSortColumn",
        "enumValues": [
          {
            "name": "AMOUNT"
          },
          {
            "name": "CURRENCY"
          },
          {
            "name": "STATUS"
          },
          {
            "name": "TRANSACTION_DATE"
          },
          {
            "name": "TRANSACTION_TYPE"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "GetTransactionsSortInput",
        "inputFields": [
          {
            "name": "sortColumn",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "GetTransactionsSortColumn",
                "ofType": null
              }
            }
          },
          {
            "name": "sortOrder",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "OrderBy",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "GetUserInput",
        "inputFields": [
          {
            "name": "userId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "GetUsersFilterInput",
        "inputFields": [
          {
            "name": "active",
            "type": {
              "kind": "SCALAR",
              "name": "Boolean",
              "ofType": null
            },
            "defaultValue": "true"
          },
          {
            "name": "canApprovePayments",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "defaultValue": "false"
          },
          {
            "name": "canManageRecipients",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "defaultValue": "false"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "GetUsersInput",
        "inputFields": [
          {
            "name": "filter",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "GetUsersFilterInput",
              "ofType": null
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "GetVendorFeedbackFormDataResponse",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "org",
            "type": {
              "kind": "OBJECT",
              "name": "Org",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "vendor",
            "type": {
              "kind": "OBJECT",
              "name": "Recipient",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "GetVendorFeedbackInput",
        "inputFields": [
          {
            "name": "vendorId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "GetVendorFeedbackResponse",
        "fields": [
          {
            "name": "average",
            "type": {
              "kind": "SCALAR",
              "name": "Float",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "feedback",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "VendorFeedback",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "GetVendorsMissingContractsResponse",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "vendors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "VendorAccountingInfo",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "GetVerificationLetterInput",
        "inputFields": [
          {
            "name": "accountId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "GetVerificationLetterResponse",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "pdfUrl",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "GetWireAmountForExternalFundingResponse",
        "fields": [
          {
            "name": "amount",
            "type": {
              "kind": "OBJECT",
              "name": "Money",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "numPayments",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "numPaymentsPendingFx",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "GoogleConnection",
        "fields": [
          {
            "name": "connectionId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "Holiday",
        "fields": [
          {
            "name": "date",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Date",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "SCALAR",
        "name": "ID"
      },
      {
        "kind": "OBJECT",
        "name": "IneligibleForReferral",
        "fields": [
          {
            "name": "void",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "InitiateACHDebitInput",
        "inputFields": [
          {
            "name": "amount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "INPUT_OBJECT",
                "name": "MoneyInput",
                "ofType": null
              }
            }
          },
          {
            "name": "connectedAccountId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            }
          },
          {
            "name": "depositAccountId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            }
          },
          {
            "name": "idempotencyKey",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            }
          },
          {
            "name": "reason",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "InitiateACHDebitResponse",
        "fields": [
          {
            "name": "activity",
            "type": {
              "kind": "OBJECT",
              "name": "Activity",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "InsufficientBalanceError",
        "fields": [
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "path",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "SCALAR",
                  "name": "String",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "stackTrace",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "ErrorInterface"
          }
        ]
      },
      {
        "kind": "SCALAR",
        "name": "Int"
      },
      {
        "kind": "OBJECT",
        "name": "IntConstrainedValue",
        "fields": [
          {
            "name": "isDefault",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "naturalNumber",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "value",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "IntValueInput",
        "inputFields": [
          {
            "name": "value",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "InternalTransfer",
        "fields": [
          {
            "name": "amount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "Money",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "confirmationNumber",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "description",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "destinationAccount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "Account",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "sourceAccount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "Account",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "status",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "ExecutionStatus",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "transactions",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "InternalTransferTransactions",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "InternalTransferSummary",
        "fields": [
          {
            "name": "amount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "VariableMoney",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "confirmationNumber",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "destinationAccount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "Account",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "sourceAccount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "Account",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "InternalTransferTransactions",
        "fields": [
          {
            "name": "destinationTransaction",
            "type": {
              "kind": "OBJECT",
              "name": "Transaction",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "sourceTransaction",
            "type": {
              "kind": "OBJECT",
              "name": "Transaction",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "TransactionPair"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "InvalidRecipientError",
        "fields": [
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "path",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "SCALAR",
                  "name": "String",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "stackTrace",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "ErrorInterface"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "InvalidWidget",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "DefaultError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "title",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseWidget"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "InviteRecipientInput",
        "inputFields": [
          {
            "name": "contactEmail",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            }
          },
          {
            "name": "contactName",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            }
          },
          {
            "name": "isCompany",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            }
          },
          {
            "name": "isTaxFormRequired",
            "type": {
              "kind": "SCALAR",
              "name": "Boolean",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "managerId",
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "recipientName",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "InviteRecipientResponse",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "recipientInvitation",
            "type": {
              "kind": "OBJECT",
              "name": "RecipientInvitation",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "InviteUserInput",
        "inputFields": [
          {
            "name": "dateOfBirth",
            "type": {
              "kind": "SCALAR",
              "name": "Date",
              "ofType": null
            }
          },
          {
            "name": "email",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            }
          },
          {
            "name": "firstName",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            }
          },
          {
            "name": "lastName",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            }
          },
          {
            "name": "phone",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            }
          },
          {
            "name": "role",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "UserRole",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "InviteUserResponse",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "user",
            "type": {
              "kind": "OBJECT",
              "name": "User",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "Invoice",
        "fields": [
          {
            "name": "attachments",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "File",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "createdAt",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "DateTime",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "depositAccount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "Account",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "description",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "dueDate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Date",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "invoiceAmount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "Money",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "invoiceDate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Date",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "invoiceNumber",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "invoiceUrl",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "isPastDue",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "lineItems",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "InvoiceLineItem",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "note",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "Note",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "payer",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "Payer",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "payerNote",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "paymentMethod",
            "type": {
              "kind": "ENUM",
              "name": "PaymentMethod",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "status",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "InvoiceStatus",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "InvoiceEmail",
        "fields": [
          {
            "name": "fromEmail",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "fromName",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "subject",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "textBody",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "timestamp",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "DateTime",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "InvoiceLineItem",
        "fields": [
          {
            "name": "description",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "ordinal",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "total",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Float",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "InvoiceLineItemInput",
        "inputFields": [
          {
            "name": "description",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            }
          },
          {
            "name": "ordinal",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            }
          },
          {
            "name": "total",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Float",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "ENUM",
        "name": "InvoiceStatus",
        "enumValues": [
          {
            "name": "CANCELLED"
          },
          {
            "name": "PAID"
          },
          {
            "name": "UNPAID"
          }
        ]
      },
      {
        "kind": "SCALAR",
        "name": "JSON"
      },
      {
        "kind": "OBJECT",
        "name": "LayerConfig",
        "fields": [
          {
            "name": "approvers",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "Approver",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "logic",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "ApprovalLogic",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "LayerConfigInput",
        "inputFields": [
          {
            "name": "approvers",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ApproverInput",
                    "ofType": null
                  }
                }
              }
            }
          },
          {
            "name": "logic",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "ApprovalLogic",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "LayerState",
        "fields": [
          {
            "name": "approverStates",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "ApproverState",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "logic",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "ApprovalLogic",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "status",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "LayerStatus",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "ENUM",
        "name": "LayerStatus",
        "enumValues": [
          {
            "name": "ACTIVE"
          },
          {
            "name": "NOT_ACTIVE"
          },
          {
            "name": "SATISFIED"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "LegacyTierCustomer",
        "fields": [
          {
            "name": "void",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "LevroBalanceFunding",
        "fields": [
          {
            "name": "void",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "Limit",
        "fields": [
          {
            "name": "frequency",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "Frequency",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "threshold",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "Money",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "utilization",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "Money",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "LimitInput",
        "inputFields": [
          {
            "name": "frequency",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "Frequency",
                "ofType": null
              }
            }
          },
          {
            "name": "threshold",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "INPUT_OBJECT",
                "name": "MoneyInput",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "LinkAccountingVendorInput",
        "inputFields": [
          {
            "name": "accountingVendorId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            }
          },
          {
            "name": "levroRecipientId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "LinkAccountingVendorResponse",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "linkedVendorId",
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "LinkAndCreateAccountingVendorInput",
        "inputFields": [
          {
            "name": "accountingVendorId",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            }
          },
          {
            "name": "createAndLinkAccountingVendorId",
            "type": {
              "kind": "SCALAR",
              "name": "Boolean",
              "ofType": null
            }
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "LinkManuallyVerifiedPlaidAccountInput",
        "inputFields": [
          {
            "name": "plaidAccount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "INPUT_OBJECT",
                "name": "PlaidAccount",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "LinkManuallyVerifiedPlaidAccountResponse",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "LiteGetCurrentUserProfileResponse",
        "fields": [
          {
            "name": "customer",
            "type": {
              "kind": "OBJECT",
              "name": "Customer",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "userProfile",
            "type": {
              "kind": "UNION",
              "name": "UserProfileResponse",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "LiteInviteUserInput",
        "inputFields": [
          {
            "name": "email",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            }
          },
          {
            "name": "firstName",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            }
          },
          {
            "name": "lastName",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            }
          },
          {
            "name": "phoneNumber",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            }
          },
          {
            "name": "role",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "UserRole",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "LiteInviteUserResponse",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "user",
            "type": {
              "kind": "OBJECT",
              "name": "User",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "LiteSignUpInput",
        "inputFields": [
          {
            "name": "companyLegalName",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            }
          },
          {
            "name": "dbaName",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            }
          },
          {
            "name": "firstName",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            }
          },
          {
            "name": "lastName",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            }
          },
          {
            "name": "phoneNumber",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "LiveRate",
        "fields": [
          {
            "name": "asOf",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "DateTime",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "client",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Float",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "markup",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Float",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "midmarket",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Float",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseRate"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "Location",
        "fields": [
          {
            "name": "page",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "text",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "xMax",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Float",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "xMin",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Float",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "yMax",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Float",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "yMin",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Float",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "ENUM",
        "name": "ManualApprovalRequiredReason",
        "enumValues": [
          {
            "name": "RECIPIENT_PENDING_APPROVAL"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "MapDocVaultFormFieldsInput",
        "inputFields": [
          {
            "name": "formFieldsJsonSchema",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "MapDocVaultFormFieldsResponse",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "mappedFormFields",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "MaybeRecipientTINVerificationStatus",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "RecipientMissingTINVerificationInfo"
          },
          {
            "kind": "OBJECT",
            "name": "RecipientTINVerificationInfo"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "Merchant",
        "fields": [
          {
            "name": "category",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "location",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "type",
            "type": {
              "kind": "SCALAR",
              "name": "Int",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "Money",
        "fields": [
          {
            "name": "amount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Float",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "currency",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "MoneyAccountLimit",
        "fields": [
          {
            "name": "limitType",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "AccountLimitType",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "threshold",
            "type": {
              "kind": "OBJECT",
              "name": "Money",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "utilization",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "Money",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "AccountLimitInterface"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "MoneyFormula",
        "fields": [
          {
            "name": "fixedAmount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "Money",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "hasVariableComponent",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "MoneyFormulaInput",
        "inputFields": [
          {
            "name": "fixedAmount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "INPUT_OBJECT",
                "name": "MoneyInput",
                "ofType": null
              }
            }
          },
          {
            "name": "hasVariableComponent",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "MoneyInput",
        "inputFields": [
          {
            "name": "amount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Float",
                "ofType": null
              }
            }
          },
          {
            "name": "currency",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "MultiCurrencyMoney",
        "fields": [
          {
            "name": "amounts",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "Money",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "equivalentAmount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "Money",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "MultiCurrencyMoneyFormula",
        "fields": [
          {
            "name": "amounts",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "Money",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "equivalentAmount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "Money",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "hasVariableComponent",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "MultiLayerApprovalRules",
        "fields": [
          {
            "name": "approvalFlowsAndCriteria",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "ApprovalFlowAndCriterion",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "multiLayerApprovalEnabled",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "releaseStep",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "MultiLayerApprovalRulesInput",
        "inputFields": [
          {
            "name": "approvalFlowsAndCriteria",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ApprovalFlowAndCriterionInput",
                    "ofType": null
                  }
                }
              }
            }
          },
          {
            "name": "currency",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            }
          },
          {
            "name": "releaseStep",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "MultiLayerApprovalRulesVersion",
        "fields": [
          {
            "name": "active",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "effectiveFrom",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "DateTime",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "effectiveUntil",
            "type": {
              "kind": "SCALAR",
              "name": "DateTime",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "MultiLayerApprovalState",
        "fields": [
          {
            "name": "adminApproval",
            "type": {
              "kind": "OBJECT",
              "name": "Approval",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "currentUserResolutionAbility",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "UserResolutionAbility",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "layerStates",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "LayerState",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "releaseState",
            "type": {
              "kind": "OBJECT",
              "name": "ReleaseState",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "requestedAmount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "Money",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "Mutation",
        "fields": [
          {
            "name": "acceptTos",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "EmptyResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "AcceptTosInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "addContractsToSeries",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "AddContractsToSeriesResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "AddContractsToSeriesInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "adminUpdateContract",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "AdminUpdateContractResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "AdminUpdateContractInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "analyzeBulkPaymentFile",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "BulkPaymentAnalysisResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "AnalyzeBulkPaymentFileInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "applyCreditAccount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ApplyCreditAccountResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ApplyCreditAccountInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "approveCreditApplication",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ApproveCreditApplicationResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ApproveCreditApplicationInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "approveExpenseAccurals",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ExpenseAccrualsResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ExpenseAccrualIDsInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "attachActivityFiles",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "AttachActivityFilesResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "AttachActivityFilesInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "attachEventInstanceFiles",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "AttachEventInstanceFilesResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "AttachEventInstanceFilesInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "attachScheduledEventFiles",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "AttachScheduledEventFilesResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "AttachScheduledEventFilesInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "attachTransactionFiles",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "AttachTransactionFilesResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "AttachTransactionFilesInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "cancelAutoPay",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "EmptyResponse",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "cancelBill",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "CancelBillResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "CancelBillInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "cancelEventInstance",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "CancelEventInstanceResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "CancelEventInstanceInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "cancelPayments",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "SuperSheetsPaymentsResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "PaymentIDsInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "cancelScheduledEvent",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "CancelScheduledEventResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "CancelScheduledEventInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "checkTokenVerification",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "CheckVerificationResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "CheckVerificationInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "checkTokenVerificationForCustomer",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "CheckVerificationResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "CheckVerificationForCustomerInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "closeAccount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "CloseAccountResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "CloseAccountInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "closeCard",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "CardActionResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "cardId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "closeCustomerAccount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "CloseCustomerAccountResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "CloseCustomerAccountInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "connectExternalAccount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ConnectAccountResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ConnectAccountInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "convertVendorMissingContract",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ConvertVendorMissingContractResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ConvertVendorMissingContractInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "createAccount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "CreateAccountResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "CreateAccountInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "createActivityComment",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "CreateActivityCommentResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "CreateActivityCommentInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "createAndLinkAccountingVendor",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "CreateAndLinkAccountingVendorResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "CreateAndLinkAccountingVendorInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "createBill",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "CreateBillResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "CreateBillInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "createCard",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "CreateCardResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "CreateCardInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "createCheckDeposit",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "CreateCheckDepositResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "CreateCheckDepositInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "createContractComment",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "CreateContractCommentResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "CreateContractCommentInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "createContractFromProcurementRequest",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "CreateContractFromProcurementRequestResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "CreateContractFromProcurementRequestInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "createDepartment",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "CreateDepartmentResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "CreateDepartmentInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "createDraftAccruals",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ExpenseAccrualsResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "CreateDraftAccrualsInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "createDraftPayment",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "CreateSuperSheetsPaymentResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "CreateDraftPaymentInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "createDraftPayments",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "CreateSuperSheetsPaymentsResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "CreateDraftPaymentsInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "createEmptyContract",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "GetContractResponse",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "createEventInstanceComment",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "CreateEventInstanceCommentResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "CreateEventInstanceCommentInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "createFile",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "CreateFileResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "CreateFileInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "createInvoice",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "CreateInvoiceResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "CreateInvoiceInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "createPayer",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "CreatePayerResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "CreatePayerInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "createPlaidLinkToken",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "CreatePlaidLinkTokenResponse",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "createProcurementRequest",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "CreateProcurementRequestResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "CreateProcurementRequestInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "createRecipientUserFromInvitation",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "CreateRecipientUserFromInvitationResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "CreateRecipientUserFromInvitationInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "createSampleContracts",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "GetContractsResponse",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "createScheduledEventComment",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "CreateScheduledEventCommentResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "CreateScheduledEventCommentInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "createTokenVerification",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "CreateVerificationResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "CreateVerificationInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "createTokenVerificationForCustomer",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "CreateVerificationResponse",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "createTransactionComment",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "CreateTransactionCommentResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "CreateTransactionCommentInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "deleteActivityComment",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "DeleteActivityCommentResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "DeleteActivityCommentInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "deleteContractComment",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "DeleteContractCommentResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "DeleteContractCommentInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "deleteContracts",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "DeleteContractsResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "DeleteContractsInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "deleteDepartment",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "EmptyResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "DeleteDepartmentInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "deleteEventInstanceComment",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "DeleteEventInstanceCommentResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "DeleteEventInstanceCommentInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "deleteScheduledEventComment",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "DeleteScheduledEventCommentResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "DeleteScheduledEventCommentInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "deleteTransactionComment",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "DeleteTransactionCommentResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "DeleteTransactionCommentInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "deleteVendorFeedback",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "EmptyResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "DeleteVendorFeedbackInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "disableRecipient",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "DisableRecipientResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "DisableRecipientInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "disassociateAndDeleteFile",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "EmptyResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "fileId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "disconnectAccountingConnection",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "EmptyResponse",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "disconnectExternalAccount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "DisconnectExternalAccountResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "DisconnectExternalAccountInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "dismissVendorMissingContract",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "EmptyResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "DismissVendorMissingContractInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "freezeCard",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "CardActionResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "cardId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "generateApiKey",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "GenerateApiKeyResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "GenerateApiKeyInput",
                  "ofType": null
                }
              }
            ]
          },
          {
            "name": "generateDocusignAuthUrl",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "GenerateDocusignAuthUrlResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "GetDocusignAuthUrlInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "generateGoogleAuthUrl",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "GenerateOAuthUrlResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "GenerateOAuthUrlInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "generateSlackAuthUrl",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "GenerateOAuthUrlResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "GenerateOAuthUrlInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "generateStripeCheckoutSession",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "GenerateStripeCheckoutSessionResponse",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "generateStripeCustomerSession",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "GenerateStripeCustomerSession",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "generateStripePortalUrl",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "GenerateStripePortalUrlResponse",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "generateStripeSubscription",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "GenerateStripeSubscriptionResponse",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "generateVendorFeedbackToken",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "GeneratedVendorFeedbackTokenResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "GenerateVendorFeedbackTokenInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "initiateAchDebit",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "InitiateACHDebitResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "InitiateACHDebitInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "inviteRecipient",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "InviteRecipientResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "InviteRecipientInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "inviteUser",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "InviteUserResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "InviteUserInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "linkAccountingVendor",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "LinkAccountingVendorResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "LinkAccountingVendorInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "linkManuallyVerifiedPlaidAccount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "LinkManuallyVerifiedPlaidAccountResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "LinkManuallyVerifiedPlaidAccountInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "liteCreateFile",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "CreateFileResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "CreateFileInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "liteDisassociateAndDeleteFile",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "EmptyResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "GetFileInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "liteGenerateFileUrlForDownload",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "FileUrlResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "GetFileInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "liteGenerateFileUrlForUpload",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "FileUrlResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "GetFileInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "liteInviteUser",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "LiteInviteUserResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "LiteInviteUserInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "liteSignUp",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "EmptyResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "LiteSignUpInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "liteVerifyFileUpload",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "EmptyResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "GetFileInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "mapDocVaultFormFields",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "MapDocVaultFormFieldsResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "MapDocVaultFormFieldsInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "noop",
            "type": {
              "kind": "SCALAR",
              "name": "Void",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "overrideRecipientTINVerification",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "OverrideRecipientTINVerificationResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "OverrideRecipientTINVerificationInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "parseContracts",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ParseContractsResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ParseContractsInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "payCreditAccount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "CreditAccountPaymentResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "CreditAccountPaymentInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "processAssistantMessage",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ProcessAssistantMessageResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ProcessAssistantMessageInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "recordPaypalCreds",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "EmptyResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "PaypalCredentialsInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "recordVendorFeedback",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "EmptyResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "RecordVendorFeedbackInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "refreshConnectionData",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "EmptyResponse",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "refreshStripeSession",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "EmptyResponse",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "registerDocusignCallback",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "EmptyResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "RegisterDocusignCallbackInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "registerGoogleCallback",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "EmptyResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "RegisterOAuthCallbackInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "registerSlackCallback",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "EmptyResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "RegisterOAuthCallbackInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "rejectExpenseAccurals",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ExpenseAccrualsResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ExpenseAccrualIDsInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "releasePayments",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ReleaseSuperSheetsPaymentsResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "PaymentIDsInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "replaceCard",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ReplaceCardResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ReplaceCardInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "reportCardLost",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "CardActionResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "cardId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "reportCardStolen",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "CardActionResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "cardId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "requestConversion",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "RequestConversionResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "RequestConversionInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "requestInternalTransfer",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "RequestInternalTransferResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "RequestInternalTransferInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "requestPayment",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "RequestPaymentResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "RequestPaymentInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "requestPayments",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "RequestPaymentsResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "RequestPaymentsInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "requestRecipient",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "RequestRecipientResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "RequestRecipientInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "requestRecipientFromInvitation",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "RequestRecipientFromInvitationResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "RequestRecipientFromInvitationInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "requestRecipients",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "RequestRecipientsResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "RequestRecipientsInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "requestTINNameMatch",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "RequestTINNameMatchResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "RequestTINNameMatchInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "resetOwnMfa",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ResetUserMFAResponse",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "resetUserMfa",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ResetUserMFAResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ResetUserMFAInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "resolvePayments",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ResolvePaymentsResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ResolvePaymentsInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "resolveProcurementRequest",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ResolveProcurementRequestResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ResolveProcurementRequestInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "resolveRecipients",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ResolveRecipientRequestsResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ResolveRecipientRequestsInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "revokeApiKey",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "RevokeApiKeyResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "RevokeApiKeyInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "revokeRecipientInvitation",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "RevokeRecipientInvitationResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "RevokeRecipientInvitationInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "setActiveContractVersion",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "SetActiveContractVersionResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "SetActiveContractVersionInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "setAutoPayMethod",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "EmptyResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "SetAutoPayInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "setCustomerAccountingDefaults",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "SetDefaultsResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "SetCustomerAccountingDefaultsInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "setMultiLayerApprovalRules",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "SetMultiLayerApprovalRulesResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "SetMultiLayerApprovalRulesRequest",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "setOrgPreferences",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "SetPreferencesResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "SetPreferencesInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "setRecipientAccountingDefaults",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "SetDefaultsResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "SetRecipientAccountingDefaultsInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "setSelfPreferences",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "SetPreferencesResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "SetPreferencesInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "toggleCustomerFreeze",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ToggleCustomerFreezeResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ToggleCustomerFreezeInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "turnOffFeatureFlag",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ToggleCustomerFeatureFlagResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ToggleCustomerFeatureFlagInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "turnOnFeatureFlag",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ToggleCustomerFeatureFlagResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ToggleCustomerFeatureFlagInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "unfreezeCard",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "CardActionResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "cardId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "updateAccount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "UpdateAccountResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "UpdateAccountInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "updateBill",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "UpdateBillResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "UpdateBillInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "updateBusinessContact",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "UpdateBusinessContactResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "UpdateBusinessContactInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "updateCard",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "UpdateCardResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "UpdateCardInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "updateContractCashflowPeriodDates",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "UpdateContractCashflowPeriodDatesResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "UpdateContractCashflowPeriodDatesInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "updateContractCashflowPeriodTotals",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "UpdateContractCashflowPeriodTotalsResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "UpdateContractCashflowPeriodTotalsInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "updateContractFields",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "UpdateContractResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "UpdateContractFieldsInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "updateContractPaymentObligations",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "UpdateContractResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "UpdateContractPaymentObligationsInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "updateCustomerInfo",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "UpdateCustomerInfoResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "UpdateCustomerInfoInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "updateCustomerTier",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "UpdateCustomerTierResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "UpdateCustomerTierInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "updateDraftAccruals",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ExpenseAccrualsResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "UpdateDraftExpenseAccrualsInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "updateDraftPayment",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "SuperSheetsPaymentResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "UpdateDraftPaymentInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "updateInvoiceStatus",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "UpdateInvoiceStatusResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "UpdateInvoiceStatusInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "updateLevroOpsUserRole",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "UpdateLevroOpsUserRoleResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "UpdateLevroOpsUserRoleInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "updateProcurementRequest",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "UpdateProcurementRequestResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "UpdateProcurementRequestInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "updateRecipient",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "UpdateRecipientResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "UpdateRecipientInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "updateUser",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "UpdateUserResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "UpdateUserInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "uploadParseAndMapFieldsFromDoc",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "MapDocVaultFormFieldsResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "UploadParseAndMapFieldsFromDocInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "verifyDocument",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "VerifyDocumentResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "VerifyDocumentInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "verifyFileUpload",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "EmptyResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "fileId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "writeActivityNote",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "WriteActivityNoteResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "WriteActivityNoteInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "writeAnnotation",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "WriteAnnotationResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "WriteAnnotationInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "writeEventInstanceNote",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "WriteEventInstanceNoteResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "WriteEventInstanceNoteInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "writeScheduledEventNote",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "WriteScheduledEventNoteResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "WriteScheduledEventNoteInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "writeTransactionNote",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "WriteTransactionNoteResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "WriteTransactionNoteInput",
                    "ofType": null
                  }
                }
              }
            ]
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "NominalAccount",
        "fields": [
          {
            "name": "classification",
            "type": {
              "kind": "ENUM",
              "name": "NominalAccountClassification",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "code",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "parentNominalAccount",
            "type": {
              "kind": "OBJECT",
              "name": "NominalAccount",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "status",
            "type": {
              "kind": "ENUM",
              "name": "AccountingCategoryStatus",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "ENUM",
        "name": "NominalAccountClassification",
        "enumValues": [
          {
            "name": "ASSET"
          },
          {
            "name": "EQUITY"
          },
          {
            "name": "EXPENSE"
          },
          {
            "name": "INCOME"
          },
          {
            "name": "LIABILITY"
          },
          {
            "name": "UNKNOWN"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "Note",
        "fields": [
          {
            "name": "memo",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "NoteInput",
        "inputFields": [
          {
            "name": "memo",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "OmiPreferences",
        "fields": [
          {
            "name": "defaultOptOutDays",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "IntConstrainedValue",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "incomeStatementAccountsOnly",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ToggleConstrainedValue",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "missingContractsLookbackAmount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "IntConstrainedValue",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "missingContractsLookbackMonths",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "IntConstrainedValue",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "notificationDays",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "IntConstrainedValue",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "OmiPreferencesInput",
        "inputFields": [
          {
            "name": "defaultOptOutDays",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IntValueInput",
              "ofType": null
            }
          },
          {
            "name": "incomeStatementAccountsOnly",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "ToggleValueInput",
              "ofType": null
            }
          },
          {
            "name": "missingContractsLookbackAmount",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IntValueInput",
              "ofType": null
            }
          },
          {
            "name": "missingContractsLookbackMonths",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IntValueInput",
              "ofType": null
            }
          },
          {
            "name": "notificationDays",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "IntValueInput",
              "ofType": null
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "OmiTablePreferences",
        "fields": [
          {
            "name": "contractTable",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "BlobConstrainedValue",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "OmiTablePreferencesInput",
        "inputFields": [
          {
            "name": "contractTable",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BlobValueInput",
              "ofType": null
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "OneTime",
        "fields": [
          {
            "name": "date",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Date",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "OptionalDateRangeInput",
        "inputFields": [
          {
            "name": "fromInclusive",
            "type": {
              "kind": "SCALAR",
              "name": "Date",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "toInclusive",
            "type": {
              "kind": "SCALAR",
              "name": "Date",
              "ofType": null
            },
            "defaultValue": "null"
          }
        ]
      },
      {
        "kind": "ENUM",
        "name": "OrderBy",
        "enumValues": [
          {
            "name": "ASC"
          },
          {
            "name": "DESC"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "Org",
        "fields": [
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "OverrideRecipientTINVerificationInput",
        "inputFields": [
          {
            "name": "recipientId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            }
          },
          {
            "name": "tin",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "OverrideRecipientTINVerificationResponse",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "success",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "PaginatedResponse",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "pageInfo",
            "type": {
              "kind": "OBJECT",
              "name": "Pagination",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ],
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "CardsResponse"
          },
          {
            "kind": "OBJECT",
            "name": "GetAccountStatementsResponse"
          },
          {
            "kind": "OBJECT",
            "name": "GetAccountingVendorsResponse"
          },
          {
            "kind": "OBJECT",
            "name": "GetAccountsResponse"
          },
          {
            "kind": "OBJECT",
            "name": "GetAccrualsResponse"
          },
          {
            "kind": "OBJECT",
            "name": "GetActivitiesResponse"
          },
          {
            "kind": "OBJECT",
            "name": "GetAnnotationTasksResponse"
          },
          {
            "kind": "OBJECT",
            "name": "GetBillsResponse"
          },
          {
            "kind": "OBJECT",
            "name": "GetCardAuthorizationsResponse"
          },
          {
            "kind": "OBJECT",
            "name": "GetContractsResponse"
          },
          {
            "kind": "OBJECT",
            "name": "GetEventInstancesResponse"
          },
          {
            "kind": "OBJECT",
            "name": "GetInvoicesResponse"
          },
          {
            "kind": "OBJECT",
            "name": "GetPayersResponse"
          },
          {
            "kind": "OBJECT",
            "name": "GetPayments2Response"
          },
          {
            "kind": "OBJECT",
            "name": "GetRecipientInvitationsResponse"
          },
          {
            "kind": "OBJECT",
            "name": "GetRecipientPaymentsResponse"
          },
          {
            "kind": "OBJECT",
            "name": "GetRecipientsResponse"
          },
          {
            "kind": "OBJECT",
            "name": "GetRecipientsWithoutContractResponse"
          },
          {
            "kind": "OBJECT",
            "name": "GetScheduledEventsResponse"
          },
          {
            "kind": "OBJECT",
            "name": "GetTransactionsResponse"
          },
          {
            "kind": "OBJECT",
            "name": "SuperSheetsPaymentsResponse"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "Pagination",
        "fields": [
          {
            "name": "pageNumber",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "perPage",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "total",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "PaginationInput",
        "inputFields": [
          {
            "name": "pageNumber",
            "type": {
              "kind": "SCALAR",
              "name": "Int",
              "ofType": null
            }
          },
          {
            "name": "perPage",
            "type": {
              "kind": "SCALAR",
              "name": "Int",
              "ofType": null
            }
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "ParseContractError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "DefaultError"
          },
          {
            "kind": "OBJECT",
            "name": "DefaultParseContractError"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "ParseContractsInput",
        "inputFields": [
          {
            "name": "fileIds",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID",
                    "ofType": null
                  }
                }
              }
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "ParseContractsResponse",
        "fields": [
          {
            "name": "contracts",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "Contract",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "UNION",
                  "name": "ParseContractError",
                  "ofType": null
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ParsedRecipient",
        "fields": [
          {
            "name": "accountNumber",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "address",
            "type": {
              "kind": "OBJECT",
              "name": "Address",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "bankAddress",
            "type": {
              "kind": "OBJECT",
              "name": "Address",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "companyName",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "country",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "currency",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "displayName",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "email",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "firstName",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "isCompany",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "isIban",
            "type": {
              "kind": "SCALAR",
              "name": "Boolean",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "lastName",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "rawAddress",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "routingNumber",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "routingNumber2",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "swift",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "taxId",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "ParsedRecipientInput",
        "inputFields": [
          {
            "name": "accountNumber",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            }
          },
          {
            "name": "address",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "AddressInput",
              "ofType": null
            }
          },
          {
            "name": "bankAddress",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "AddressInput",
              "ofType": null
            }
          },
          {
            "name": "companyName",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            }
          },
          {
            "name": "country",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            }
          },
          {
            "name": "currency",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            }
          },
          {
            "name": "displayName",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            }
          },
          {
            "name": "email",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            }
          },
          {
            "name": "rawAddress",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            }
          },
          {
            "name": "routingNumber",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            }
          },
          {
            "name": "routingNumber2",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            }
          },
          {
            "name": "swift",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            }
          },
          {
            "name": "taxId",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "PayPalCredentials",
        "fields": [
          {
            "name": "clientIdLast4",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "clientSecretLast4",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "PayPalCredentialsResponse",
        "fields": [
          {
            "name": "credentials",
            "type": {
              "kind": "OBJECT",
              "name": "PayPalCredentials",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "Payer",
        "fields": [
          {
            "name": "address",
            "type": {
              "kind": "OBJECT",
              "name": "Address",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "contactName",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "defaultDepositAccount",
            "type": {
              "kind": "OBJECT",
              "name": "Account",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "email",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "payerName",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "phoneNumber",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "Payment",
        "fields": [
          {
            "name": "achTraceNumber",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "additionalDescription",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "amount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "Money",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "bill",
            "type": {
              "kind": "OBJECT",
              "name": "Bill",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "confirmationNumber",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "conversion",
            "type": {
              "kind": "OBJECT",
              "name": "Conversion",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "failedTransaction",
            "type": {
              "kind": "OBJECT",
              "name": "Transaction",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "fee",
            "type": {
              "kind": "OBJECT",
              "name": "Money",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "feeTransaction",
            "type": {
              "kind": "OBJECT",
              "name": "Transaction",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "fundingMethod",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "UNION",
                "name": "FundingMethod",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "invoiceDate",
            "type": {
              "kind": "SCALAR",
              "name": "Date",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "invoiceNumber",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "isSwiftInfoReady",
            "type": {
              "kind": "SCALAR",
              "name": "Boolean",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "mtUrl",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "originatedBy",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "paymentRail",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "reason",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "recipient",
            "type": {
              "kind": "OBJECT",
              "name": "Recipient",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "reference",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "releaseDate",
            "type": {
              "kind": "SCALAR",
              "name": "Date",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "status",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "ExecutionStatus",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "swiftTrackingInfo",
            "type": {
              "kind": "OBJECT",
              "name": "SWIFTPaymentTrackingInfo",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "transaction",
            "type": {
              "kind": "OBJECT",
              "name": "Transaction",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "uetr",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "Payment2",
        "fields": [
          {
            "name": "asyncApprovalError",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "createdAt",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "DateTime",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "currentUserResolutionAbility",
            "type": {
              "kind": "ENUM",
              "name": "UserResolutionAbility",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "destinationAmount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "VariableMoney",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "fee",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "VariableMoney",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "fundingDeadline",
            "type": {
              "kind": "SCALAR",
              "name": "Date",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "method",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "PaymentMethod",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "ordinal",
            "type": {
              "kind": "SCALAR",
              "name": "Int",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "recipient",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "Recipient",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "requester",
            "type": {
              "kind": "OBJECT",
              "name": "User",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "schedule",
            "type": {
              "kind": "UNION",
              "name": "Schedule",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "scheduledDate",
            "type": {
              "kind": "SCALAR",
              "name": "DateTime",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "sourceAmount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "VariableMoney",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "status",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "PaymentStatus",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "Payment2Details",
        "fields": [
          {
            "name": "eventInstance",
            "type": {
              "kind": "UNION",
              "name": "EventInstance",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "payment",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "Payment2",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "paymentTimeline",
            "type": {
              "kind": "OBJECT",
              "name": "PaymentTimeline",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "scheduledPayment",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ScheduledPayment",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "PaymentBillInput",
        "inputFields": [
          {
            "name": "billDate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Date",
                "ofType": null
              }
            }
          },
          {
            "name": "billPaymentNominalAccountId",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            }
          },
          {
            "name": "description",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            }
          },
          {
            "name": "dueDate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Date",
                "ofType": null
              }
            }
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            }
          },
          {
            "name": "invoiceNumber",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            }
          },
          {
            "name": "lineItems",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "BillLineItemInput",
                    "ofType": null
                  }
                }
              }
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "PaymentDetailsWidget",
        "fields": [
          {
            "name": "details",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "Payment2Details",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "title",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseWidget"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "PaymentError",
        "fields": [
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "path",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "SCALAR",
                  "name": "String",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "stackTrace",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "ErrorInterface"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "PaymentIDInput",
        "inputFields": [
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "PaymentIDsInput",
        "inputFields": [
          {
            "name": "ids",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID",
                    "ofType": null
                  }
                }
              }
            }
          }
        ]
      },
      {
        "kind": "ENUM",
        "name": "PaymentMethod",
        "enumValues": [
          {
            "name": "LOCAL"
          },
          {
            "name": "PAYPAL"
          },
          {
            "name": "PRIORITY"
          },
          {
            "name": "VENMO"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "PaymentMethodBulkPaymentColumn",
        "fields": [
          {
            "name": "sourceColumn",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "values",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "ENUM",
                  "name": "PaymentMethod",
                  "ofType": null
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "PaymentRecipientInput",
        "inputFields": [
          {
            "name": "idempotencyKey",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            }
          },
          {
            "name": "managerId",
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "recipient",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "INPUT_OBJECT",
                "name": "RecipientInput",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "ENUM",
        "name": "PaymentRequestSource",
        "enumValues": [
          {
            "name": "ASSISTANT"
          },
          {
            "name": "FLATFILE"
          }
        ]
      },
      {
        "kind": "ENUM",
        "name": "PaymentStatus",
        "enumValues": [
          {
            "name": "AWAITING_FUNDS"
          },
          {
            "name": "CANCELED"
          },
          {
            "name": "COMPLETED"
          },
          {
            "name": "FAILED"
          },
          {
            "name": "IN_PROGRESS"
          },
          {
            "name": "PENDING_APPROVAL"
          },
          {
            "name": "PENDING_RELEASE"
          },
          {
            "name": "REJECTED"
          },
          {
            "name": "SCHEDULED"
          },
          {
            "name": "UNKNOWN"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "PaymentSummary",
        "fields": [
          {
            "name": "amount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "VariableMoney",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "confirmationNumber",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "conversionSummary",
            "type": {
              "kind": "OBJECT",
              "name": "ConversionSummary",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "reason",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "recipientSummary",
            "type": {
              "kind": "OBJECT",
              "name": "RecipientSummary",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "reference",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "PaymentTableWidget",
        "fields": [
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "payments",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "Payment2",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "title",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseWidget"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "PaymentTerms",
        "fields": [
          {
            "name": "netDays",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "PaymentTermsInput",
        "inputFields": [
          {
            "name": "netDays",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "PaymentTimeline",
        "fields": [
          {
            "name": "arrivalBufferBusinessDays",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "arrivalDate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Date",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "holidays",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "Holiday",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "sendDate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Date",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "PaymentTimelineResponse",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "paymentTimeline",
            "type": {
              "kind": "OBJECT",
              "name": "PaymentTimeline",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "PaymentsLocations",
        "fields": [
          {
            "name": "allFields",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "Location",
                  "ofType": null
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "PaypalCredentialsInput",
        "inputFields": [
          {
            "name": "clientId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            }
          },
          {
            "name": "clientSecret",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "Period",
        "fields": [
          {
            "name": "endTime",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "DateTime",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "month",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "startTime",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "DateTime",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "year",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "PeriodInput",
        "inputFields": [
          {
            "name": "endTime",
            "type": {
              "kind": "SCALAR",
              "name": "DateTime",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "startTime",
            "type": {
              "kind": "SCALAR",
              "name": "DateTime",
              "ofType": null
            },
            "defaultValue": "null"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "PermissionsResponse",
        "fields": [
          {
            "name": "permissions",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "String",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "ENUM",
        "name": "PinStatus",
        "enumValues": [
          {
            "name": "NOT_SET"
          },
          {
            "name": "SET"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "PlaidAccount",
        "inputFields": [
          {
            "name": "accountId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            }
          },
          {
            "name": "accountType",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "AccountType",
                "ofType": null
              }
            }
          },
          {
            "name": "bankName",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            }
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "PlaidError",
        "fields": [
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "path",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "SCALAR",
                  "name": "String",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "stackTrace",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "updateLinkToken",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "ErrorInterface"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "PreferenceError",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "DefaultError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "PreferenceName",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "ENUM",
        "name": "PreferenceName",
        "enumValues": [
          {
            "name": "BILL_PAY__LINE_ITEMS__SHOW_BILLABLE"
          },
          {
            "name": "BILL_PAY__LINE_ITEMS__SHOW_CLASS"
          },
          {
            "name": "BILL_PAY__LINE_ITEMS__SHOW_CUSTOMER"
          },
          {
            "name": "BILL_PAY__LINE_ITEMS__SHOW_DEPARTMENT"
          },
          {
            "name": "BILL_PAY__LINE_ITEMS__SHOW_LOCATION"
          },
          {
            "name": "BILL_PAY__SHOW_NOMINAL_PAYMENT_ACCOUNTS"
          },
          {
            "name": "BRANDING__LOGO_FILE"
          },
          {
            "name": "BRANDING__PRIMARY_COLOR"
          },
          {
            "name": "BRANDING__SECONDARY_COLOR"
          },
          {
            "name": "OMI_TABLE__CONTRACT"
          },
          {
            "name": "OMI__ACCOUNTING__INCOME_STATEMENT_ONLY"
          },
          {
            "name": "OMI__CONTRACTS__DEFAULT_OPT_OUT_DAYS"
          },
          {
            "name": "OMI__CONTRACTS__NOTIFICATION_DAYS"
          },
          {
            "name": "OMI__MISSING_CONTRACTS__LOOKBACK_AMOUNT"
          },
          {
            "name": "OMI__MISSING_CONTRACTS__LOOKBACK_MONTHS"
          },
          {
            "name": "PAYMENTS__RECIPIENT_BCC_EMAIL"
          }
        ]
      },
      {
        "kind": "ENUM",
        "name": "PreferenceScope",
        "enumValues": [
          {
            "name": "ORG"
          },
          {
            "name": "SELF"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "Preferences",
        "fields": [
          {
            "name": "billPay",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "BillPayPreferences",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "branding",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "BrandingPreferences",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "omi",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "OmiPreferences",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "omiTable",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "OmiTablePreferences",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "scope",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "PreferenceScope",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "ProcessAssistantMessageInput",
        "inputFields": [
          {
            "name": "fileIds",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                }
              }
            }
          },
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "INPUT_OBJECT",
                "name": "AssistantMessageInput",
                "ofType": null
              }
            }
          },
          {
            "name": "threadId",
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "ProcessAssistantMessageResponse",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "messageId",
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "thread",
            "type": {
              "kind": "OBJECT",
              "name": "AssistantThread",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "ProcurementRequest",
        "fields": [
          {
            "name": "annualContractValue",
            "type": {
              "kind": "OBJECT",
              "name": "MoneyFormula",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "approvalInfo",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ApprovalInfo",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "department",
            "type": {
              "kind": "OBJECT",
              "name": "Department",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "estimatedStartDate",
            "type": {
              "kind": "SCALAR",
              "name": "Date",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "file",
            "type": {
              "kind": "OBJECT",
              "name": "File",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "notes",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "owner",
            "type": {
              "kind": "OBJECT",
              "name": "User",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "vendor",
            "type": {
              "kind": "OBJECT",
              "name": "Recipient",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "vendorName",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "ENUM",
        "name": "Product",
        "enumValues": [
          {
            "name": "FULL_LEVRO"
          },
          {
            "name": "SUPERSHEETS"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "PurchaseTransactionMetadata",
        "fields": [
          {
            "name": "cardId",
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "cardPresent",
            "type": {
              "kind": "SCALAR",
              "name": "Boolean",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "coordinates",
            "type": {
              "kind": "OBJECT",
              "name": "Coordinates",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "digitalWallet",
            "type": {
              "kind": "ENUM",
              "name": "DigitalWalletType",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "ecommerce",
            "type": {
              "kind": "SCALAR",
              "name": "Boolean",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "merchant",
            "type": {
              "kind": "OBJECT",
              "name": "Merchant",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "originalCurrencyAmount",
            "type": {
              "kind": "OBJECT",
              "name": "Money",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "paymentMethod",
            "type": {
              "kind": "ENUM",
              "name": "CardPaymentMethod",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "recurring",
            "type": {
              "kind": "SCALAR",
              "name": "Boolean",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "verificationMethod",
            "type": {
              "kind": "ENUM",
              "name": "VerificationMethod",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "Query",
        "fields": [
          {
            "name": "adminGetContracts",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "AdminGetContractsResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "AdminGetContractsInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "adminGetCustomerOrgs",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "AdminGetCustomerOrgsResponse",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "checkRecipientInvitationToken",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "CheckRecipientInvitationTokenResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "token",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "String",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "exportAccruals",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ExportAccrualsResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ExportAccrualsInput",
                  "ofType": null
                }
              }
            ]
          },
          {
            "name": "exportPayments",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ExportPaymentsResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ExportPaymentsInput",
                  "ofType": null
                }
              }
            ]
          },
          {
            "name": "exportTransactions",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ExportTransactionsResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ExportTransactionsInput",
                  "ofType": null
                }
              }
            ]
          },
          {
            "name": "fxMarketStatus",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "FXMarketStatusResponse",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "getAccount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "GetAccountResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "GetAccountInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "getAccountInfo",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "AccountInfoResponse",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "getAccountLimits",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "AccountLimit",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "getAccountStatement",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "GetAccountStatementResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "GetAccountStatementFilterInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "getAccountStatements",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "GetAccountStatementsResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "GetAccountStatementsInput",
                  "ofType": null
                }
              }
            ]
          },
          {
            "name": "getAccountingClasses",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "GetAccountingCategoriesResponse",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "getAccountingConnection",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "GetAccountingConnectionResponse",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "getAccountingCustomers",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "GetAccountingCustomersResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "GetAccountingCustomersInput",
                  "ofType": null
                }
              }
            ]
          },
          {
            "name": "getAccountingDepartments",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "GetAccountingCategoriesResponse",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "getAccountingItems",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "GetAccountingItemsResponse",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "getAccountingLocations",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "GetAccountingCategoriesResponse",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "getAccountingTaxRates",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "GetAccountingTaxRatesResponse",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "getAccountingVendor",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "GetAccountingVendorResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "GetAccountingVendorInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "getAccountingVendors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "GetAccountingVendorsResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "GetAccountingVendorsInput",
                  "ofType": null
                }
              }
            ]
          },
          {
            "name": "getAccounts",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "GetAccountsResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "GetAccountsInput",
                  "ofType": null
                }
              }
            ]
          },
          {
            "name": "getAccrual",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ExpenseAccrualResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ExpenseAccrualIDInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "getAccruals",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "GetAccrualsResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "GetAccrualsInput",
                  "ofType": null
                }
              }
            ]
          },
          {
            "name": "getAchPullTimeline",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PaymentTimelineResponse",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "getActivationChecklist",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "GetActivationChecklistResponse",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "getActiveFeatures",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "ENUM",
                    "name": "FeatureFlag",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "getActivities",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "GetActivitiesResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "GetActivitiesInput",
                  "ofType": null
                }
              }
            ]
          },
          {
            "name": "getActivity",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "GetActivityResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "GetActivityInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "getAnnotationTasks",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "GetAnnotationTasksResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "GetAnnotationTasksInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "getApiKeys",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "GetApiKeysResponse",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "getApplication",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "GetApplicationResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "GetApplicationInput",
                  "ofType": null
                }
              }
            ]
          },
          {
            "name": "getApplications",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "GetApplicationsResponse",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "getAssistantBoard",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "GetAssistantBoardResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "GetAssistantBoardInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "getAssistantThread",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "GetAssistantThreadResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "GetAssistantThreadInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "getAssistantThreads",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "GetAssistantThreadsResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "PaginationInput",
                  "ofType": null
                }
              }
            ]
          },
          {
            "name": "getBill",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "GetBillResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "GetBillInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "getBillPaymentNominalAccounts",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "GetNominalAccountsResponse",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "getBillingAddress",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "GetBillingAddressResponse",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "getBills",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "GetBillsResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "GetBillsInput",
                  "ofType": null
                }
              }
            ]
          },
          {
            "name": "getBillsEmailInboxAddress",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "GetBillsEmailInboxAddressResponse",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "getBrandingPreferences",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "GetBrandingPreferencesResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "token",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "String",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "getBulkPayment",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "GetBulkPaymentResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "String",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "getCardAuthorizations",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "GetCardAuthorizationsResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "GetCardAuthorizationsInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "getCards",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "CardsResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "CardsInput",
                  "ofType": null
                }
              }
            ]
          },
          {
            "name": "getConnectedAccount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "GetConnectedAccountResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "GetConnectedAccountInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "getConnectedAccounts",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "GetConnectedAccountsResponse",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "getContract",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "GetContractResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "GetContractInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "getContracts",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "GetContractsResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "GetContractsInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "getContractsCashManagement",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "GetContractsCashManagementResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "GetContractsCashManagementInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "getContractsCashflow",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "GetContractsCashflowResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "GetContractsCashflowInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "getConversionTimeline",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PaymentTimelineResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "GetConversionTimelineInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "getCreditApplication",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "GetCreditApplicationResponse",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "getCurrentUser",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "UserResponse",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "getCurrentUserCustomers",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "GetCurrentUserCustomersResponse",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "getCustomerAccountingDefaults",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "GetAccountingDefaultsResponse",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "getCustomerBasic",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "CustomerResponse",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "getCustomerTierSettings",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "GetCustomerTierSettingsResponse",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "getDepartments",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "GetDepartmentsResponse",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "getDocusignConnections",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "GetDocusignConnectionsResponse",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "getEligibleBusinessContactUsers",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "GetEligibleBusinessContactUsersResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "GetEligibleBusinessContactUsersInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "getEventInstance",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "GetEventInstanceResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "GetEventInstanceInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "getEventInstances",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "GetEventInstancesResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "GetEventInstancesInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "getExpectedPaymentApprovalFlow",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ExpectedApprovalInfoResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "GetExpectedPaymentApprovalFlowInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "getFile",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "GetFileResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "GetFileInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "getFundingInstructionsPdf",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "GetFundingInstructionsPdfResponse",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "getGoogleConnection",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "GetGoogleConnectionResponse",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "getInvoice",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "GetInvoiceResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "GetInvoiceInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "getInvoices",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "GetInvoicesResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "GetInvoicesInput",
                  "ofType": null
                }
              }
            ]
          },
          {
            "name": "getMultiLayerApprovalRules",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "GetMultiLayerApprovalRulesResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "GetMultiLayerApprovalRulesRequest",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "getMultiLayerApprovalRulesVersions",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "GetMultiLayerApprovalRulesVersionsResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "GetMultiLayerApprovalRulesVersionsRequest",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "getNominalAccounts",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "GetNominalAccountsResponse",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "getOmiUserProfile",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "GetOmiUserProfileResponse",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "getOrgPreferences",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "GetPreferencesResponse",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "getOrgsWithTasks",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "GetOrgsWithTasksResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "GetOrgsWithTasksInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "getPayer",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "GetPayerResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "GetPayerInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "getPayers",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "GetPayersResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "GetPayersInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "getPayment",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "SuperSheetsPaymentResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "PaymentIDInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "getPayment2",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "GetPayment2Response",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "ordinal",
                "type": {
                  "kind": "SCALAR",
                  "name": "Int",
                  "ofType": null
                }
              },
              {
                "name": "paymentId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "String",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "getPaymentFees",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "GetPaymentFeesResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "GetPaymentFeesInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "getPaymentTimeline",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PaymentTimelineResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "GetPaymentTimelineInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "getPayments",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "SuperSheetsPaymentsResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "GetPaymentsInput",
                  "ofType": null
                }
              }
            ]
          },
          {
            "name": "getPayments2",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "GetPayments2Response",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "GetPayments2Input",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "getPaypalCreds",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PayPalCredentialsResponse",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "getPendingCreditAccountRepayments",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "GetPendingCreditAccountRepaymentsResponse",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "getPendingCreditApplications",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "GetPendingCreditApplicationsResponse",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "getProcurementRequests",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "GetProcurementRequestsResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "GetProcurementRequestsInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "getRates",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "GetRatesResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "GetRatesInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "getRecipient",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "GetRecipientResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "GetRecipientInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "getRecipientAccountingDefaults",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "GetAccountingDefaultsResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "GetRecipientAccountingDefaultsInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "getRecipientInvitations",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "GetRecipientInvitationsResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "GetRecipientInvitationsInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "getRecipientPayment",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "GetRecipientPaymentResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "GetRecipientPaymentInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "getRecipientPayments",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "GetRecipientPaymentsResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "GetRecipientPaymentsInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "getRecipientTaxForm",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "GetRecipientTaxFormResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "GetRecipientTaxFormInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "getRecipients",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "GetRecipientsResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "GetRecipientsInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "getRecipientsWithoutContracts",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "GetRecipientsWithoutContractResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "GetRecipientsWithoutContractInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "getScheduledEvent",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "GetScheduledEventResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "GetScheduledEventInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "getScheduledEvents",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "GetScheduledEventsResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "GetScheduledEventsInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "getSelfPreferences",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "GetPreferencesResponse",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "getSheetsTierSettings",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "GetSheetsTierSettingsResponse",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "getSlackConnection",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "GetSlackConnectionResponse",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "getTransaction",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "GetTransactionResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "GetTransactionInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "getTransactions",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "GetTransactionsResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "GetTransactionsInput",
                  "ofType": null
                }
              }
            ]
          },
          {
            "name": "getUser",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "UserResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "GetUserInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "getUserPermissions",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PermissionsResponse",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "getUsers",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "UsersResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "GetUsersInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "getVendorFeedback",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "GetVendorFeedbackResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "GetVendorFeedbackInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "getVendorFeedbackFormData",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "GetVendorFeedbackFormDataResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "token",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "String",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "getVendorsMissingContract",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "GetVendorsMissingContractsResponse",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "getVerificationLetter",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "GetVerificationLetterResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "GetVerificationLetterInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "getWireAmountForExternalFunding",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "GetWireAmountForExternalFundingResponse",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "liteGetCurrentUserProfile",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "LiteGetCurrentUserProfileResponse",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "liteGetFile",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "GetFileResponse",
                "ofType": null
              }
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "GetFileInput",
                    "ofType": null
                  }
                }
              }
            ]
          },
          {
            "name": "ping",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "RateInfo",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "CachedRate"
          },
          {
            "kind": "OBJECT",
            "name": "LiveRate"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "Recipient",
        "fields": [
          {
            "name": "accountNumber",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "accountNumberLastDigits",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "accountType",
            "type": {
              "kind": "ENUM",
              "name": "RecipientAccountType",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "accountingVendor",
            "type": {
              "kind": "UNION",
              "name": "RecipientAccountingVendor",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "address",
            "type": {
              "kind": "OBJECT",
              "name": "Address",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "approvalInfo",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ApprovalInfo",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "averageFeedback",
            "type": {
              "kind": "SCALAR",
              "name": "Float",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "companyName",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "country",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "creationTimeUtc",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "DateTime",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "currency",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "displayName",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "email",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "firstName",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "hasLinkedAccountingVendor",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "invitation",
            "type": {
              "kind": "OBJECT",
              "name": "RecipientInvitation",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "isCompany",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "isUsTaxResident",
            "type": {
              "kind": "SCALAR",
              "name": "Boolean",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "lastName",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "manager",
            "type": {
              "kind": "OBJECT",
              "name": "User",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "paypalEmail",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "paypalId",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "paypalPhone",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "routingNumber",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "routingNumber2",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "supportedPaymentMethods",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "ENUM",
                    "name": "PaymentMethod",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "swift",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "taxForms",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "RecipientTaxForm",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "taxId",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "usTin",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "usTinVerificationInfo",
            "type": {
              "kind": "UNION",
              "name": "MaybeRecipientTINVerificationStatus",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "user",
            "type": {
              "kind": "OBJECT",
              "name": "User",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "venmoHandle",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "versionId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "RecipientAccountInput",
        "inputFields": [
          {
            "name": "accountNumber",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            }
          },
          {
            "name": "accountType",
            "type": {
              "kind": "ENUM",
              "name": "RecipientAccountType",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "address",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "AddressInput",
              "ofType": null
            }
          },
          {
            "name": "companyName",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            }
          },
          {
            "name": "firstName",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            }
          },
          {
            "name": "lastName",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            }
          },
          {
            "name": "paypalEmail",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            }
          },
          {
            "name": "paypalId",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            }
          },
          {
            "name": "paypalPhone",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            }
          },
          {
            "name": "routingNumber",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            }
          },
          {
            "name": "routingNumber2",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            }
          },
          {
            "name": "supportedPaymentMethods",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "ENUM",
                    "name": "PaymentMethod",
                    "ofType": null
                  }
                }
              }
            }
          },
          {
            "name": "swift",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            }
          },
          {
            "name": "taxId",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "venmoHandle",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            }
          }
        ]
      },
      {
        "kind": "ENUM",
        "name": "RecipientAccountType",
        "enumValues": [
          {
            "name": "CHECKING"
          },
          {
            "name": "SAVINGS"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "RecipientAccountingVendor",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "AccountingVendor"
          },
          {
            "kind": "OBJECT",
            "name": "AccountingVendorSyncing"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "RecipientInput",
        "inputFields": [
          {
            "name": "accountNumber",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            }
          },
          {
            "name": "accountType",
            "type": {
              "kind": "ENUM",
              "name": "RecipientAccountType",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "address",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "AddressInput",
              "ofType": null
            }
          },
          {
            "name": "companyName",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            }
          },
          {
            "name": "country",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            }
          },
          {
            "name": "currency",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            }
          },
          {
            "name": "displayName",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            }
          },
          {
            "name": "email",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            }
          },
          {
            "name": "firstName",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            }
          },
          {
            "name": "isCompany",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            }
          },
          {
            "name": "isUsTaxResident",
            "type": {
              "kind": "SCALAR",
              "name": "Boolean",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "lastName",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            }
          },
          {
            "name": "linkAndCreateAccountingVendor",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "LinkAndCreateAccountingVendorInput",
              "ofType": null
            }
          },
          {
            "name": "paypalEmail",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            }
          },
          {
            "name": "paypalId",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            }
          },
          {
            "name": "paypalPhone",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            }
          },
          {
            "name": "routingNumber",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            }
          },
          {
            "name": "routingNumber2",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            }
          },
          {
            "name": "supportedPaymentMethods",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "ENUM",
                    "name": "PaymentMethod",
                    "ofType": null
                  }
                }
              }
            }
          },
          {
            "name": "swift",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            }
          },
          {
            "name": "taxId",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "usTin",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "venmoHandle",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "RecipientInvitation",
        "fields": [
          {
            "name": "approvalStatus",
            "type": {
              "kind": "ENUM",
              "name": "ApprovalRequestStatus",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "contactEmail",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "contactName",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "invitationStatus",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "RecipientInvitationStatus",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "invitedBy",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "User",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "isCompany",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "isTaxFormRequired",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "manager",
            "type": {
              "kind": "OBJECT",
              "name": "User",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "recipient",
            "type": {
              "kind": "OBJECT",
              "name": "Recipient",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "recipientName",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "resolverName",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "RecipientInvitationForRecipient",
        "fields": [
          {
            "name": "contactEmail",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "contactName",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "hasRecipientAccount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "invitedByOrgName",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "invitedByUserEmail",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "invitedByUserName",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "isCompany",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "isTaxFormRequired",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "recipientName",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "status",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "RecipientInvitationStatus",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "taxFormContinueUrl",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "ENUM",
        "name": "RecipientInvitationStatus",
        "enumValues": [
          {
            "name": "ACCEPTED"
          },
          {
            "name": "EXPIRED"
          },
          {
            "name": "INVITED"
          },
          {
            "name": "NEEDS_TAX_FORM"
          },
          {
            "name": "REVOKED"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "RecipientLocations",
        "fields": [
          {
            "name": "name",
            "type": {
              "kind": "OBJECT",
              "name": "Location",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "RecipientMissingTINVerificationInfo",
        "fields": [
          {
            "name": "null",
            "type": {
              "kind": "SCALAR",
              "name": "Boolean",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "RecipientNameError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "RecipientNameNoMatchError"
          },
          {
            "kind": "OBJECT",
            "name": "RecipientNamePartialMatchError"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "RecipientNameNoMatchError",
        "fields": [
          {
            "name": "errorCode",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "path",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "SCALAR",
                  "name": "String",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "stackTrace",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "ErrorInterface"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "RecipientNamePartialMatchError",
        "fields": [
          {
            "name": "actualName",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "errorCode",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "path",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "SCALAR",
                  "name": "String",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "stackTrace",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "ErrorInterface"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "RecipientPayment",
        "fields": [
          {
            "name": "amount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "Money",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "attachments",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "File",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "confirmationNumber",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "date",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Date",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "details",
            "type": {
              "kind": "OBJECT",
              "name": "RecipientPaymentDetail",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "RecipientPaymentDetail",
        "fields": [
          {
            "name": "achTraceNumber",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "invoiceDate",
            "type": {
              "kind": "SCALAR",
              "name": "Date",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "invoiceNumber",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "paymentRail",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "uetr",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "RecipientSummary",
        "fields": [
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "versionId",
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "RecipientTINVerificationInfo",
        "fields": [
          {
            "name": "status",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "TINMatchStatus",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "timestamp",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "DateTime",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "user",
            "type": {
              "kind": "OBJECT",
              "name": "User",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "RecipientTableWidget",
        "fields": [
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "recipients",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "Recipient",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "title",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseWidget"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "RecipientTaxForm",
        "fields": [
          {
            "name": "completedAt",
            "type": {
              "kind": "SCALAR",
              "name": "DateTime",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "status",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "TaxFormStatus",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "taxFormType",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "TaxFormType",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "zipUrl",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "RecipientUserIdentityInput",
        "inputFields": [
          {
            "name": "email",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            }
          },
          {
            "name": "firstName",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            }
          },
          {
            "name": "lastName",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            }
          },
          {
            "name": "phoneNumber",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "RecipientsFilter",
        "inputFields": [
          {
            "name": "approvalStatuses",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "ENUM",
                  "name": "ApprovalRequestStatus",
                  "ofType": null
                }
              }
            },
            "defaultValue": "[APPROVED]"
          },
          {
            "name": "currencies",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "ENUM",
                  "name": "Currency",
                  "ofType": null
                }
              }
            },
            "defaultValue": "null"
          },
          {
            "name": "isAccountingVendor",
            "type": {
              "kind": "SCALAR",
              "name": "Boolean",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "managerId",
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "recipientIds",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                }
              }
            }
          },
          {
            "name": "searchQuery",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            }
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "RecordVendorFeedbackInput",
        "inputFields": [
          {
            "name": "comment",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            }
          },
          {
            "name": "raterEmail",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            }
          },
          {
            "name": "rating",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            }
          },
          {
            "name": "token",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "Recurring",
        "fields": [
          {
            "name": "nInstances",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "rrule",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ReferralCode",
        "fields": [
          {
            "name": "code",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "ReferralResponse",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "IneligibleForReferral"
          },
          {
            "kind": "OBJECT",
            "name": "ReferralCode"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "RegisterDocusignCallbackInput",
        "inputFields": [
          {
            "name": "code",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            }
          },
          {
            "name": "sessionState",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            }
          },
          {
            "name": "state",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "RegisterOAuthCallbackInput",
        "inputFields": [
          {
            "name": "code",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            }
          },
          {
            "name": "sessionState",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            }
          },
          {
            "name": "state",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "ReleaseInfo",
        "fields": [
          {
            "name": "releasedBy",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "User",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "timestamp",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "DateTime",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ReleaseState",
        "fields": [
          {
            "name": "releaseInfo",
            "type": {
              "kind": "OBJECT",
              "name": "ReleaseInfo",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "ReleaseSuperSheetsPaymentError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "DefaultError"
          },
          {
            "kind": "OBJECT",
            "name": "PaymentError"
          },
          {
            "kind": "OBJECT",
            "name": "SuperSheetsPaymentValidationError"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "ReleaseSuperSheetsPaymentsResponse",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "UNION",
                  "name": "ReleaseSuperSheetsPaymentError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "payments",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "SuperSheetsPayment",
                  "ofType": null
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "RepaymentAccount",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "Account"
          },
          {
            "kind": "OBJECT",
            "name": "ConnectedAccount"
          }
        ]
      },
      {
        "kind": "ENUM",
        "name": "RepaymentAccountType",
        "enumValues": [
          {
            "name": "EXTERNAL"
          },
          {
            "name": "LEVRO"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "RepaymentInfo",
        "fields": [
          {
            "name": "frequency",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "Frequency",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "nextRepaymentDueDate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Date",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "repaymentAccount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "UNION",
                "name": "RepaymentAccount",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "ReplaceCardInput",
        "inputFields": [
          {
            "name": "cardId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            }
          },
          {
            "name": "shippingAddress",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "AddressInput",
              "ofType": null
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "ReplaceCardResponse",
        "fields": [
          {
            "name": "card",
            "type": {
              "kind": "OBJECT",
              "name": "Card",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "RequestConversionError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "ConversionBelowLimitError"
          },
          {
            "kind": "OBJECT",
            "name": "ConversionFailedError"
          },
          {
            "kind": "OBJECT",
            "name": "ConversionRateChangedError"
          },
          {
            "kind": "OBJECT",
            "name": "CurrencyPairNotTradeableError"
          },
          {
            "kind": "OBJECT",
            "name": "DefaultError"
          },
          {
            "kind": "OBJECT",
            "name": "DuplicateScheduledEventIdempotencyKeyError"
          },
          {
            "kind": "OBJECT",
            "name": "FXConversionUnavailableError"
          },
          {
            "kind": "OBJECT",
            "name": "FXMarketsClosedError"
          },
          {
            "kind": "OBJECT",
            "name": "InsufficientBalanceError"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "RequestConversionInput",
        "inputFields": [
          {
            "name": "amortized",
            "type": {
              "kind": "SCALAR",
              "name": "Boolean",
              "ofType": null
            }
          },
          {
            "name": "destinationAccountId",
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            }
          },
          {
            "name": "destinationAmount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "INPUT_OBJECT",
                "name": "VariableMoneyInput",
                "ofType": null
              }
            }
          },
          {
            "name": "destinationCurrency",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            }
          },
          {
            "name": "fileIds",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID",
                    "ofType": null
                  }
                }
              }
            }
          },
          {
            "name": "fixedAmount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "FixedAmount",
                "ofType": null
              }
            }
          },
          {
            "name": "forceManualApproval",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "defaultValue": "false"
          },
          {
            "name": "forceScheduled",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "defaultValue": "false"
          },
          {
            "name": "idempotencyKey",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            }
          },
          {
            "name": "note",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "INPUT_OBJECT",
                "name": "NoteInput",
                "ofType": null
              }
            }
          },
          {
            "name": "rrule",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            }
          },
          {
            "name": "sourceAccountId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            }
          },
          {
            "name": "sourceAmount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "INPUT_OBJECT",
                "name": "VariableMoneyInput",
                "ofType": null
              }
            }
          },
          {
            "name": "targetDate",
            "type": {
              "kind": "SCALAR",
              "name": "Date",
              "ofType": null
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "RequestConversionResponse",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "UNION",
                  "name": "RequestConversionError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "result",
            "type": {
              "kind": "UNION",
              "name": "RequestConversionResult",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "RequestConversionResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "RequestConversionScheduledResult"
          },
          {
            "kind": "OBJECT",
            "name": "RequestConversionSynchronousResult"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "RequestConversionScheduledResult",
        "fields": [
          {
            "name": "approvalInfo",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ApprovalInfo",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "eventId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "RequestConversionSynchronousResult",
        "fields": [
          {
            "name": "activityId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "confirmationNumber",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "RequestInternalTransferInput",
        "inputFields": [
          {
            "name": "amount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "INPUT_OBJECT",
                "name": "MoneyInput",
                "ofType": null
              }
            }
          },
          {
            "name": "destinationAccountId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            }
          },
          {
            "name": "fileIds",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                }
              }
            }
          },
          {
            "name": "idempotencyKey",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            }
          },
          {
            "name": "note",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "NoteInput",
              "ofType": null
            }
          },
          {
            "name": "sourceAccountId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "RequestInternalTransferResponse",
        "fields": [
          {
            "name": "activity",
            "type": {
              "kind": "OBJECT",
              "name": "Activity",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "RequestPaymentError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "ConversionBelowLimitError"
          },
          {
            "kind": "OBJECT",
            "name": "ConversionFailedError"
          },
          {
            "kind": "OBJECT",
            "name": "ConversionRateChangedError"
          },
          {
            "kind": "OBJECT",
            "name": "CurrencyPairNotTradeableError"
          },
          {
            "kind": "OBJECT",
            "name": "DefaultError"
          },
          {
            "kind": "OBJECT",
            "name": "DuplicatePaymentError"
          },
          {
            "kind": "OBJECT",
            "name": "DuplicateScheduledEventIdempotencyKeyError"
          },
          {
            "kind": "OBJECT",
            "name": "FXConversionUnavailableError"
          },
          {
            "kind": "OBJECT",
            "name": "FXMarketsClosedError"
          },
          {
            "kind": "OBJECT",
            "name": "InsufficientBalanceError"
          },
          {
            "kind": "OBJECT",
            "name": "InvalidRecipientError"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "RequestPaymentInput",
        "inputFields": [
          {
            "name": "allowDuplicate",
            "type": {
              "kind": "SCALAR",
              "name": "Boolean",
              "ofType": null
            }
          },
          {
            "name": "amortized",
            "type": {
              "kind": "SCALAR",
              "name": "Boolean",
              "ofType": null
            }
          },
          {
            "name": "bill",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "PaymentBillInput",
              "ofType": null
            }
          },
          {
            "name": "chargeType",
            "type": {
              "kind": "ENUM",
              "name": "SWIFTChargeType",
              "ofType": null
            }
          },
          {
            "name": "destinationAmount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "INPUT_OBJECT",
                "name": "VariableMoneyInput",
                "ofType": null
              }
            }
          },
          {
            "name": "fileIds",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "SCALAR",
                  "name": "ID",
                  "ofType": null
                }
              }
            },
            "defaultValue": "null"
          },
          {
            "name": "fixedAmount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "FixedAmount",
                "ofType": null
              }
            }
          },
          {
            "name": "forceManualApproval",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "defaultValue": "false"
          },
          {
            "name": "forceScheduled",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "defaultValue": "false"
          },
          {
            "name": "fundingMethod",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "INPUT_OBJECT",
                "name": "FundingMethodInput",
                "ofType": null
              }
            }
          },
          {
            "name": "idempotencyKey",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            }
          },
          {
            "name": "invoiceDate",
            "type": {
              "kind": "SCALAR",
              "name": "Date",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "invoiceNumber",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "linkAndCreateAccountingVendor",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "LinkAndCreateAccountingVendorInput",
              "ofType": null
            }
          },
          {
            "name": "method",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "PaymentMethod",
                "ofType": null
              }
            }
          },
          {
            "name": "note",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "NoteInput",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "purposeCode",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            }
          },
          {
            "name": "reason",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            }
          },
          {
            "name": "recipientId",
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            }
          },
          {
            "name": "recipientRequest",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "PaymentRecipientInput",
              "ofType": null
            }
          },
          {
            "name": "reference",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            }
          },
          {
            "name": "rrule",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            }
          },
          {
            "name": "showFilesToRecipient",
            "type": {
              "kind": "SCALAR",
              "name": "Boolean",
              "ofType": null
            },
            "defaultValue": "false"
          },
          {
            "name": "sourceAccountId",
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            }
          },
          {
            "name": "sourceAmount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "INPUT_OBJECT",
                "name": "VariableMoneyInput",
                "ofType": null
              }
            }
          },
          {
            "name": "targetDate",
            "type": {
              "kind": "SCALAR",
              "name": "Date",
              "ofType": null
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "RequestPaymentResponse",
        "fields": [
          {
            "name": "billErrors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "billId",
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "payment",
            "type": {
              "kind": "UNION",
              "name": "RequestPaymentResult",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "paymentErrors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "UNION",
                  "name": "RequestPaymentError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "recipient",
            "type": {
              "kind": "OBJECT",
              "name": "Recipient",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "recipientErrors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "requestedNewRecipient",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "RequestPaymentResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "RequestPaymentScheduledResult"
          },
          {
            "kind": "OBJECT",
            "name": "RequestPaymentSynchronousResult"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "RequestPaymentScheduledResult",
        "fields": [
          {
            "name": "approvalInfo",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ApprovalInfo",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "eventId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "fundingMethod",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "UNION",
                "name": "FundingMethod",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "fundingStatus",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "FundingStatus",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "RequestPaymentSynchronousResult",
        "fields": [
          {
            "name": "activityId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "confirmationNumber",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "scheduledPaymentId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "RequestPaymentsInput",
        "inputFields": [
          {
            "name": "fileId",
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "requestedPayments",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "RequestPaymentInput",
                    "ofType": null
                  }
                }
              }
            }
          },
          {
            "name": "source",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "PaymentRequestSource",
                "ofType": null
              }
            },
            "defaultValue": "ASSISTANT"
          },
          {
            "name": "sourceId",
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "defaultValue": "null"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "RequestPaymentsResponse",
        "fields": [
          {
            "name": "bulkPaymentId",
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "paymentResponses",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "RequestPaymentResponse",
                  "ofType": null
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "RequestRecipientFromInvitationInput",
        "inputFields": [
          {
            "name": "recipient",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "INPUT_OBJECT",
                "name": "RecipientInput",
                "ofType": null
              }
            }
          },
          {
            "name": "token",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "RequestRecipientFromInvitationResponse",
        "fields": [
          {
            "name": "anvilTaxFormUrl",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "recipientRequested",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "RequestRecipientInput",
        "inputFields": [
          {
            "name": "forceManualApproval",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "defaultValue": "false"
          },
          {
            "name": "idempotencyKey",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            }
          },
          {
            "name": "managerId",
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "overrideGbpConfirmation",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "defaultValue": "false"
          },
          {
            "name": "recipient",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "INPUT_OBJECT",
                "name": "RecipientInput",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "RequestRecipientResponse",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "nameMatchErrors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "UNION",
                  "name": "RecipientNameError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "recipient",
            "type": {
              "kind": "OBJECT",
              "name": "Recipient",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "RequestRecipientsInput",
        "inputFields": [
          {
            "name": "requests",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "RequestRecipientInput",
                    "ofType": null
                  }
                }
              }
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "RequestRecipientsResponse",
        "fields": [
          {
            "name": "responses",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "RequestRecipientResponse",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "RequestTINNameMatchInput",
        "inputFields": [
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            }
          },
          {
            "name": "recipientInvitationToken",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "tin",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "RequestTINNameMatchResponse",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "response",
            "type": {
              "kind": "ENUM",
              "name": "TINMatchResponseCategory",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "ENUM",
        "name": "RequestedType",
        "enumValues": [
          {
            "name": "BILL"
          },
          {
            "name": "PROCUREMENT_REQUEST"
          },
          {
            "name": "RECIPIENT_VERSION"
          },
          {
            "name": "SCHEDULED_CONVERSION"
          },
          {
            "name": "SCHEDULED_PAYMENT"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "ResetUserMFAInput",
        "inputFields": [
          {
            "name": "userId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "ResetUserMFAResponse",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "success",
            "type": {
              "kind": "SCALAR",
              "name": "Boolean",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "ResolvePaymentResult",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "paymentId",
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "ResolvePaymentsAsyncResult",
        "fields": [
          {
            "name": "paymentIds",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "ResolvePaymentsInput",
        "inputFields": [
          {
            "name": "fundingMethod",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "FundingMethodInput",
              "ofType": null
            }
          },
          {
            "name": "paymentIds",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID",
                    "ofType": null
                  }
                }
              }
            }
          },
          {
            "name": "resolution",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "ApprovalRequestStatus",
                "ofType": null
              }
            }
          },
          {
            "name": "useAdminOverride",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "defaultValue": "false"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "ResolvePaymentsResponse",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "result",
            "type": {
              "kind": "UNION",
              "name": "ResolvePaymentsResult",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "ResolvePaymentsResult",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "ResolvePaymentsAsyncResult"
          },
          {
            "kind": "OBJECT",
            "name": "ResolvePaymentsSyncResult"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "ResolvePaymentsSyncResult",
        "fields": [
          {
            "name": "results",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "ResolvePaymentResult",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "ResolveProcurementRequestInput",
        "inputFields": [
          {
            "name": "approve",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            }
          },
          {
            "name": "requestId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "ResolveProcurementRequestResponse",
        "fields": [
          {
            "name": "contract",
            "type": {
              "kind": "OBJECT",
              "name": "Contract",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "ResolveRecipientRequestResponse",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "recipient",
            "type": {
              "kind": "OBJECT",
              "name": "Recipient",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "ResolveRecipientRequestsInput",
        "inputFields": [
          {
            "name": "recipientVersionIds",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID",
                    "ofType": null
                  }
                }
              }
            }
          },
          {
            "name": "resolution",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "ApprovalRequestStatus",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "ResolveRecipientRequestsResponse",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "responses",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "ResolveRecipientRequestResponse",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "RevokeApiKeyInput",
        "inputFields": [
          {
            "name": "prefix",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "RevokeApiKeyResponse",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "success",
            "type": {
              "kind": "SCALAR",
              "name": "Boolean",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "RevokeRecipientInvitationInput",
        "inputFields": [
          {
            "name": "invitationId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "RevokeRecipientInvitationResponse",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "recipientInvitation",
            "type": {
              "kind": "OBJECT",
              "name": "RecipientInvitation",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "RoleApprover",
        "fields": [
          {
            "name": "role",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "ApproverUserRole",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "RoleApproverInput",
        "inputFields": [
          {
            "name": "role",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "ApproverUserRole",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "SWIFTAccountDetails",
        "fields": [
          {
            "name": "accountHolder",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "accountNumberIsIban",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "bankAddress",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "bankName",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "ibanOrAccountNumber",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "swiftCode",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "ENUM",
        "name": "SWIFTChargeType",
        "enumValues": [
          {
            "name": "OURS"
          },
          {
            "name": "SHARED"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "SWIFTForeignExchangeDetail",
        "fields": [
          {
            "name": "exchangeRate",
            "type": {
              "kind": "SCALAR",
              "name": "Float",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "sourceCurrency",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "targetCurrency",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "SWIFTPaymentTrackingEvent",
        "fields": [
          {
            "name": "chargeAmounts",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "Money",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "chargeType",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "confirmedAmount",
            "type": {
              "kind": "OBJECT",
              "name": "Money",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "foreignExchangeDetails",
            "type": {
              "kind": "OBJECT",
              "name": "SWIFTForeignExchangeDetail",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "forwardedToAgentBd",
            "type": {
              "kind": "OBJECT",
              "name": "BankDetail",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "fromBd",
            "type": {
              "kind": "OBJECT",
              "name": "BankDetail",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "fundsAvailable",
            "type": {
              "kind": "SCALAR",
              "name": "DateTime",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "instructedAmount",
            "type": {
              "kind": "OBJECT",
              "name": "Money",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "interbankSettlementAmount",
            "type": {
              "kind": "OBJECT",
              "name": "Money",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "interbankSettlementDate",
            "type": {
              "kind": "SCALAR",
              "name": "Date",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "lastUpdateTime",
            "type": {
              "kind": "SCALAR",
              "name": "DateTime",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "originatorBd",
            "type": {
              "kind": "OBJECT",
              "name": "BankDetail",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "senderAcknowledgementReceipt",
            "type": {
              "kind": "SCALAR",
              "name": "DateTime",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "serialParties",
            "type": {
              "kind": "OBJECT",
              "name": "SWIFTSerialParties",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "toBd",
            "type": {
              "kind": "OBJECT",
              "name": "BankDetail",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "trackerEventType",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "transactionStatus",
            "type": {
              "kind": "OBJECT",
              "name": "SWIFTTransactionStatus",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "valid",
            "type": {
              "kind": "SCALAR",
              "name": "Boolean",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "SWIFTPaymentTrackingInfo",
        "fields": [
          {
            "name": "completionTime",
            "type": {
              "kind": "SCALAR",
              "name": "DateTime",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "initiationTime",
            "type": {
              "kind": "SCALAR",
              "name": "DateTime",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "lastUpdateTime",
            "type": {
              "kind": "SCALAR",
              "name": "DateTime",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "paymentEvents",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "SWIFTPaymentTrackingEvent",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "transactionStatus",
            "type": {
              "kind": "OBJECT",
              "name": "SWIFTTransactionStatus",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "uetr",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "SWIFTSerialParties",
        "fields": [
          {
            "name": "creditorAgentBd",
            "type": {
              "kind": "OBJECT",
              "name": "BankDetail",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "creditorBd",
            "type": {
              "kind": "OBJECT",
              "name": "BankDetail",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "debtorAgentBd",
            "type": {
              "kind": "OBJECT",
              "name": "BankDetail",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "debtorBd",
            "type": {
              "kind": "OBJECT",
              "name": "BankDetail",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "instructingReimbursementAgentBd",
            "type": {
              "kind": "OBJECT",
              "name": "BankDetail",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "intermediaryAgent1Bd",
            "type": {
              "kind": "OBJECT",
              "name": "BankDetail",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "SWIFTTransactionStatus",
        "fields": [
          {
            "name": "reason",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "status",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "Schedule",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "OneTime"
          },
          {
            "kind": "OBJECT",
            "name": "Recurring"
          }
        ]
      },
      {
        "kind": "ENUM",
        "name": "ScheduleCategory",
        "enumValues": [
          {
            "name": "ONE_TIME_ON_ENABLE"
          },
          {
            "name": "ONE_TIME_SCHEDULED"
          },
          {
            "name": "ONE_TIME_SYNCHRONOUS"
          },
          {
            "name": "RECURRING"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "ScheduledConversion",
        "fields": [
          {
            "name": "approvalInfo",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ApprovalInfo",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "canAttachFiles",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "canCancel",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "canWriteNote",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "comments",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "Comment",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "creationTime",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "DateTime",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "currencyCostAveragingState",
            "type": {
              "kind": "OBJECT",
              "name": "CurrencyCostAveragingState",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "destinationAmount",
            "type": {
              "kind": "SCALAR",
              "name": "Float",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "destinationCurrency",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "files",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "File",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "instances",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "UNION",
                  "name": "EventInstance",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "levroActivation",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "ScheduledEventActivation",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "memo",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "note",
            "type": {
              "kind": "OBJECT",
              "name": "Note",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "schedule",
            "type": {
              "kind": "UNION",
              "name": "Schedule",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "sourceAmount",
            "type": {
              "kind": "SCALAR",
              "name": "Float",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "sourceCurrency",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "status",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "ScheduledEventStatus",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "userActivation",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "ScheduledEventActivation",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "ScheduledEventInterface"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "ScheduledEvent",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "ScheduledConversion"
          },
          {
            "kind": "OBJECT",
            "name": "ScheduledPayment"
          }
        ]
      },
      {
        "kind": "ENUM",
        "name": "ScheduledEventActivation",
        "enumValues": [
          {
            "name": "DISABLED"
          },
          {
            "name": "ENABLED"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "ScheduledEventInstance",
        "fields": [
          {
            "name": "canAttachFiles",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "canCancel",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "canWriteNote",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "canceled",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "comments",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "Comment",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "event",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "UNION",
                "name": "ScheduledEvent",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "eventId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "expectedExecutionTime",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "DateTime",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "files",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "File",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "note",
            "type": {
              "kind": "OBJECT",
              "name": "Note",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "ordinal",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "scheduledDateEt",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Date",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "ScheduledEventInstanceInterface"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "ScheduledEventInstanceInterface",
        "fields": [
          {
            "name": "canAttachFiles",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "canCancel",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "canWriteNote",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "comments",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "Comment",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "event",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "UNION",
                "name": "ScheduledEvent",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "eventId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "files",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "File",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "note",
            "type": {
              "kind": "OBJECT",
              "name": "Note",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "ordinal",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "scheduledDateEt",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Date",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": [],
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "ExecutedEventInstance"
          },
          {
            "kind": "OBJECT",
            "name": "ScheduledEventInstance"
          }
        ]
      },
      {
        "kind": "ENUM",
        "name": "ScheduledEventInstanceStatus",
        "enumValues": [
          {
            "name": "CANCELED"
          },
          {
            "name": "FAILED"
          },
          {
            "name": "FAILED_RESCHEDULABLE"
          },
          {
            "name": "INITIATED"
          },
          {
            "name": "SCHEDULED"
          },
          {
            "name": "SKIPPED_RESCHEDULABLE"
          },
          {
            "name": "SUCCEEDED"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "ScheduledEventInterface",
        "fields": [
          {
            "name": "approvalInfo",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ApprovalInfo",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "canAttachFiles",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "canCancel",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "canWriteNote",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "comments",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "Comment",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "creationTime",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "DateTime",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "files",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "File",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "instances",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "UNION",
                  "name": "EventInstance",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "levroActivation",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "ScheduledEventActivation",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "note",
            "type": {
              "kind": "OBJECT",
              "name": "Note",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "schedule",
            "type": {
              "kind": "UNION",
              "name": "Schedule",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "status",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "ScheduledEventStatus",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "userActivation",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "ScheduledEventActivation",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": [],
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "ScheduledConversion"
          },
          {
            "kind": "OBJECT",
            "name": "ScheduledPayment"
          }
        ]
      },
      {
        "kind": "ENUM",
        "name": "ScheduledEventStatus",
        "enumValues": [
          {
            "name": "CANCELED"
          },
          {
            "name": "FAILED"
          },
          {
            "name": "PENDING"
          },
          {
            "name": "SUCCEEDED"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "ScheduledPayment",
        "fields": [
          {
            "name": "approvalInfo",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ApprovalInfo",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "asyncApprovalError",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "bill",
            "type": {
              "kind": "OBJECT",
              "name": "Bill",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "canAttachFiles",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "canCancel",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "canWriteNote",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "comments",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "Comment",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "creationTime",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "DateTime",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "currencyCostAveragingState",
            "type": {
              "kind": "OBJECT",
              "name": "CurrencyCostAveragingState",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "destinationAmount",
            "type": {
              "kind": "SCALAR",
              "name": "Float",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "destinationCurrency",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "fee",
            "type": {
              "kind": "OBJECT",
              "name": "Money",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "files",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "File",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "fundingMethod",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "UNION",
                "name": "FundingMethod",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "fundingStatus",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "FundingStatus",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "instances",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "UNION",
                  "name": "EventInstance",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "invoiceDate",
            "type": {
              "kind": "SCALAR",
              "name": "Date",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "invoiceNumber",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "levroActivation",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "ScheduledEventActivation",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "note",
            "type": {
              "kind": "OBJECT",
              "name": "Note",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "paymentRail",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "purposeCode",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "reason",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "recipient",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "Recipient",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "reference",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "schedule",
            "type": {
              "kind": "UNION",
              "name": "Schedule",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "sourceAmount",
            "type": {
              "kind": "SCALAR",
              "name": "Float",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "sourceCurrency",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "status",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "ScheduledEventStatus",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "userActivation",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "ScheduledEventActivation",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "ScheduledEventInterface"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "SchedulingInfo",
        "fields": [
          {
            "name": "canCancel",
            "type": {
              "kind": "SCALAR",
              "name": "Boolean",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "currencyCostAveragingState",
            "type": {
              "kind": "OBJECT",
              "name": "CurrencyCostAveragingState",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "ordinal",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "schedule",
            "type": {
              "kind": "UNION",
              "name": "Schedule",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "scheduledDateEt",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Date",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "schedulingStatus",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "ScheduledEventInstanceStatus",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "ENUM",
        "name": "SchemaType",
        "enumValues": [
          {
            "name": "CONTRACT"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "SendBulkPaymentWidget",
        "fields": [
          {
            "name": "bulkPaymentData",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "BulkPaymentAnalysisResponse",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "file",
            "type": {
              "kind": "OBJECT",
              "name": "File",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "status",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "BulkPaymentWidgetStatus",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "title",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseWidget"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "SendPaymentWidget",
        "fields": [
          {
            "name": "destinationAmount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "VariableMoney",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "fixedAmount",
            "type": {
              "kind": "ENUM",
              "name": "FixedAmount",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "method",
            "type": {
              "kind": "ENUM",
              "name": "PaymentMethod",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "reason",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "recipient",
            "type": {
              "kind": "OBJECT",
              "name": "AssistantRecipientPrefill",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "recipientId",
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "reference",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "sourceAccountId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "sourceAmount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "VariableMoney",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "status",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "SendPaymentWidgetStatus",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "targetDate",
            "type": {
              "kind": "SCALAR",
              "name": "Date",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "title",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseWidget"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "SendPaymentWidgetStatus",
        "fields": [
          {
            "name": "paymentId",
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "status",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "WidgetStatusCategory",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseWidgetStatus"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "Sender",
        "fields": [
          {
            "name": "accountNumber",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "address",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "country",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "identifierType",
            "type": {
              "kind": "ENUM",
              "name": "BankDetailIdentifier",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "isIban",
            "type": {
              "kind": "SCALAR",
              "name": "Boolean",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "paymentRail",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "routingCode",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "SetActiveContractVersionInput",
        "inputFields": [
          {
            "name": "contractId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "SetActiveContractVersionResponse",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "SetAutoPayInput",
        "inputFields": [
          {
            "name": "accountId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            }
          },
          {
            "name": "accountType",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "RepaymentAccountType",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "SetCustomerAccountingDefaultsInput",
        "inputFields": [
          {
            "name": "classId",
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "departmentId",
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "locationId",
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "nominalExpenseAccountId",
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "nominalPaymentAccountId",
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "defaultValue": "null"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "SetDefaultsResponse",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "SetMultiLayerApprovalRulesRequest",
        "inputFields": [
          {
            "name": "approvalRules",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "MultiLayerApprovalRulesInput",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "effectiveFrom",
            "type": {
              "kind": "SCALAR",
              "name": "DateTime",
              "ofType": null
            }
          },
          {
            "name": "requestedType",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "RequestedType",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "SetMultiLayerApprovalRulesResponse",
        "fields": [
          {
            "name": "approvalRules",
            "type": {
              "kind": "OBJECT",
              "name": "MultiLayerApprovalRules",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "SetPreferenceError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "DefaultError"
          },
          {
            "kind": "OBJECT",
            "name": "PreferenceError"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "SetPreferencesInput",
        "inputFields": [
          {
            "name": "billPay",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BillPayPreferencesInput",
              "ofType": null
            }
          },
          {
            "name": "branding",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "BrandingPreferencesInput",
              "ofType": null
            }
          },
          {
            "name": "omi",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "OmiPreferencesInput",
              "ofType": null
            }
          },
          {
            "name": "omiTable",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "OmiTablePreferencesInput",
              "ofType": null
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "SetPreferencesResponse",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "SetPreferenceError",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "preferences",
            "type": {
              "kind": "OBJECT",
              "name": "Preferences",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "SetRecipientAccountingDefaultsInput",
        "inputFields": [
          {
            "name": "classId",
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "departmentId",
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "locationId",
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "nominalExpenseAccountId",
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "nominalPaymentAccountId",
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "recipientId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "ENUM",
        "name": "SheetsCustomerTier",
        "enumValues": [
          {
            "name": "BASIC"
          },
          {
            "name": "ENTERPRISE"
          },
          {
            "name": "PREMIUM"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "SheetsTierQuotaUsage",
        "fields": [
          {
            "name": "contracts",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "users",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "SheetsTierSettings",
        "fields": [
          {
            "name": "accountIntegrationEnabled",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "cashFlowEnabled",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "exportEnabled",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "maxContracts",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "maxUsers",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "tierQuotaUsage",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "SheetsTierQuotaUsage",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "SingleUserApprover",
        "fields": [
          {
            "name": "user",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "User",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "SingleUserApproverInput",
        "inputFields": [
          {
            "name": "userId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "SlackConnection",
        "fields": [
          {
            "name": "teamName",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "SpreadsheetValueInput",
        "inputFields": [
          {
            "name": "date",
            "type": {
              "kind": "SCALAR",
              "name": "DateTime",
              "ofType": null
            }
          },
          {
            "name": "number",
            "type": {
              "kind": "SCALAR",
              "name": "Float",
              "ofType": null
            }
          },
          {
            "name": "string",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "StaticContentWidget",
        "fields": [
          {
            "name": "html",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "title",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseWidget"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "StrBulkPaymentColumn",
        "fields": [
          {
            "name": "sourceColumn",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "values",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "SCALAR",
                  "name": "String",
                  "ofType": null
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "SCALAR",
        "name": "String"
      },
      {
        "kind": "ENUM",
        "name": "SuperSheetsAccrualStatus",
        "enumValues": [
          {
            "name": "APPROVED"
          },
          {
            "name": "DRAFT"
          },
          {
            "name": "REJECTED"
          },
          {
            "name": "REVERSED"
          },
          {
            "name": "REVERSING"
          },
          {
            "name": "SYNCED"
          },
          {
            "name": "SYNCING"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "SuperSheetsPayment",
        "fields": [
          {
            "name": "actionedAtUtc",
            "type": {
              "kind": "SCALAR",
              "name": "DateTime",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "amount",
            "type": {
              "kind": "OBJECT",
              "name": "Money",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "attachments",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "File",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "completedAtUtc",
            "type": {
              "kind": "SCALAR",
              "name": "DateTime",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "createdAtUtc",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "DateTime",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "dueDate",
            "type": {
              "kind": "SCALAR",
              "name": "Date",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "failedAtUtc",
            "type": {
              "kind": "SCALAR",
              "name": "DateTime",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "failureReason",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "method",
            "type": {
              "kind": "ENUM",
              "name": "PaymentMethod",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "paymentReason",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "recipient",
            "type": {
              "kind": "OBJECT",
              "name": "SuperSheetsRecipient",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "status",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "SuperSheetsPaymentStatus",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "SuperSheetsPaymentResponse",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "payment",
            "type": {
              "kind": "OBJECT",
              "name": "SuperSheetsPayment",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "ENUM",
        "name": "SuperSheetsPaymentStatus",
        "enumValues": [
          {
            "name": "CANCELED"
          },
          {
            "name": "COMPLETED"
          },
          {
            "name": "DELETED"
          },
          {
            "name": "DRAFT"
          },
          {
            "name": "FAILED"
          },
          {
            "name": "RELEASED"
          },
          {
            "name": "RELEASING"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "SuperSheetsPaymentValidationError",
        "fields": [
          {
            "name": "amount",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "SCALAR",
                  "name": "String",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "method",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "SCALAR",
                  "name": "String",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "paymentReason",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "SCALAR",
                  "name": "String",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "recipient",
            "type": {
              "kind": "OBJECT",
              "name": "SuperSheetsRecipientValidationErrors",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "SuperSheetsPaymentsResponse",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "pageInfo",
            "type": {
              "kind": "OBJECT",
              "name": "Pagination",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "payments",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "SuperSheetsPayment",
                  "ofType": null
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          },
          {
            "kind": "INTERFACE",
            "name": "PaginatedResponse"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "SuperSheetsRecipient",
        "fields": [
          {
            "name": "name",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "paypalEmail",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "venmoHandle",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "SuperSheetsRecipientInput",
        "inputFields": [
          {
            "name": "recipientName",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            }
          },
          {
            "name": "recipientPaypalEmail",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            }
          },
          {
            "name": "recipientVenmoHandle",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "SuperSheetsRecipientValidationErrors",
        "fields": [
          {
            "name": "name",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "SCALAR",
                  "name": "String",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "paypalEmail",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "SCALAR",
                  "name": "String",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "venmoHandle",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "SCALAR",
                  "name": "String",
                  "ofType": null
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "ENUM",
        "name": "TINMatchResponseCategory",
        "enumValues": [
          {
            "name": "ERROR"
          },
          {
            "name": "MATCH"
          },
          {
            "name": "NO_MATCH"
          }
        ]
      },
      {
        "kind": "ENUM",
        "name": "TINMatchStatus",
        "enumValues": [
          {
            "name": "ERROR"
          },
          {
            "name": "MANUAL_OVERRIDE"
          },
          {
            "name": "MATCH"
          },
          {
            "name": "NO_MATCH"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "TableWidget",
        "fields": [
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "tableColumns",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "String",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "tableRows",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "String",
                        "ofType": null
                      }
                    }
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "title",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseWidget"
          }
        ]
      },
      {
        "kind": "ENUM",
        "name": "TaxFormStatus",
        "enumValues": [
          {
            "name": "COMPLETED"
          },
          {
            "name": "PENDING"
          }
        ]
      },
      {
        "kind": "ENUM",
        "name": "TaxFormType",
        "enumValues": [
          {
            "name": "W8_BEN"
          },
          {
            "name": "W8_BEN_E"
          },
          {
            "name": "W9"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "TextConstrainedValue",
        "fields": [
          {
            "name": "isDefault",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "text",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "TextValueInput",
        "inputFields": [
          {
            "name": "text",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            }
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "TierSettings",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "CustomerTierSettings"
          },
          {
            "kind": "OBJECT",
            "name": "LegacyTierCustomer"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "ToggleConstrainedValue",
        "fields": [
          {
            "name": "canToggle",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "enabled",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "isDefault",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "ToggleCustomerFeatureFlagInput",
        "inputFields": [
          {
            "name": "customerId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            }
          },
          {
            "name": "flag",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "FeatureFlag",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "ToggleCustomerFeatureFlagResponse",
        "fields": [
          {
            "name": "customer",
            "type": {
              "kind": "OBJECT",
              "name": "Customer",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "ToggleCustomerFreezeInput",
        "inputFields": [
          {
            "name": "customerId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            }
          },
          {
            "name": "reason",
            "type": {
              "kind": "ENUM",
              "name": "FreezeReason",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "reasonDescription",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "ToggleCustomerFreezeResponse",
        "fields": [
          {
            "name": "customer",
            "type": {
              "kind": "OBJECT",
              "name": "Customer",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "ToggleValueInput",
        "inputFields": [
          {
            "name": "enabled",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "Transaction",
        "fields": [
          {
            "name": "accountId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "activity",
            "type": {
              "kind": "OBJECT",
              "name": "Activity",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "canAttachFiles",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "canWriteNote",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "cardHolderUser",
            "type": {
              "kind": "OBJECT",
              "name": "User",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "cardLast4",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "cardTransactionType",
            "type": {
              "kind": "ENUM",
              "name": "CardTransactionType",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "comments",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "Comment",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "counterparty",
            "type": {
              "kind": "OBJECT",
              "name": "Counterparty",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "currencyAmount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "Money",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "currencyBalance",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "Money",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "date",
            "type": {
              "kind": "SCALAR",
              "name": "Date",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "dateTime",
            "type": {
              "kind": "SCALAR",
              "name": "DateTime",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "description",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "direction",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "Direction",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "files",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "File",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "metadata",
            "type": {
              "kind": "UNION",
              "name": "TransactionMetadata",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "note",
            "type": {
              "kind": "OBJECT",
              "name": "Note",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "receiptAvailable",
            "type": {
              "kind": "SCALAR",
              "name": "Boolean",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "receiptUrl",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "relatedTransaction",
            "type": {
              "kind": "OBJECT",
              "name": "Transaction",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "status",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "ExecutionStatus",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "transactionType",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "TransactionType",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "TransactionMetadata",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "AtmTransactionMetadata"
          },
          {
            "kind": "OBJECT",
            "name": "PurchaseTransactionMetadata"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "TransactionPair",
        "fields": [
          {
            "name": "destinationTransaction",
            "type": {
              "kind": "OBJECT",
              "name": "Transaction",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "sourceTransaction",
            "type": {
              "kind": "OBJECT",
              "name": "Transaction",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": [],
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "ConversionTransactions"
          },
          {
            "kind": "OBJECT",
            "name": "InternalTransferTransactions"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "TransactionTableWidget",
        "fields": [
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "title",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "transactions",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "Transaction",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseWidget"
          }
        ]
      },
      {
        "kind": "ENUM",
        "name": "TransactionType",
        "enumValues": [
          {
            "name": "CARD"
          },
          {
            "name": "CONVERSION"
          },
          {
            "name": "DEPOSIT"
          },
          {
            "name": "FEE"
          },
          {
            "name": "INTEREST"
          },
          {
            "name": "INTERNAL_TRANSFER"
          },
          {
            "name": "OTHER"
          },
          {
            "name": "PAYMENT"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "USDAccountDetails",
        "fields": [
          {
            "name": "abaRoutingNumber",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "accountHolder",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "accountNumber",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "accountNumberIsIban",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "bankAddress",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "bankName",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "localPaymentRailName",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "swift",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "SWIFTAccountDetails",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "AccountDetailsWithLocalPayIns"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "UnmappedBulkPaymentColumn",
        "fields": [
          {
            "name": "sourceColumn",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "title",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "values",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "SCALAR",
                  "name": "String",
                  "ofType": null
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "UpdateAccountInput",
        "inputFields": [
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            }
          },
          {
            "name": "name",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "UpdateAccountResponse",
        "fields": [
          {
            "name": "account",
            "type": {
              "kind": "OBJECT",
              "name": "Account",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "UpdateBillInput",
        "inputFields": [
          {
            "name": "amount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Float",
                "ofType": null
              }
            }
          },
          {
            "name": "billDate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Date",
                "ofType": null
              }
            }
          },
          {
            "name": "billPaymentNominalAccountId",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            }
          },
          {
            "name": "currency",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            }
          },
          {
            "name": "description",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            }
          },
          {
            "name": "dueDate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Date",
                "ofType": null
              }
            }
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            }
          },
          {
            "name": "invoiceNumber",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            }
          },
          {
            "name": "lineItems",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "BillLineItemInput",
                    "ofType": null
                  }
                }
              }
            }
          },
          {
            "name": "method",
            "type": {
              "kind": "ENUM",
              "name": "PaymentMethod",
              "ofType": null
            }
          },
          {
            "name": "parsedRecipient",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "ParsedRecipientInput",
              "ofType": null
            }
          },
          {
            "name": "reason",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            }
          },
          {
            "name": "recipientId",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "UpdateBillResponse",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "UpdateBusinessContactInput",
        "inputFields": [
          {
            "name": "customerId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            }
          },
          {
            "name": "newBusinessContactUserId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "UpdateBusinessContactResponse",
        "fields": [
          {
            "name": "customer",
            "type": {
              "kind": "OBJECT",
              "name": "Customer",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "UpdateCardInput",
        "inputFields": [
          {
            "name": "cardId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            }
          },
          {
            "name": "cardName",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            }
          },
          {
            "name": "creditCardLimit",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "CreditCardLimitInput",
              "ofType": null
            }
          },
          {
            "name": "debitCardLimit",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "DebitCardLimitInput",
              "ofType": null
            }
          },
          {
            "name": "funding",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "FundingType",
                "ofType": null
              }
            }
          },
          {
            "name": "shippingAddress",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "AddressInput",
              "ofType": null
            }
          },
          {
            "name": "type",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "CardType",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "UpdateCardResponse",
        "fields": [
          {
            "name": "card",
            "type": {
              "kind": "OBJECT",
              "name": "Card",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "UpdateContractCashflowPeriodDatesInput",
        "inputFields": [
          {
            "name": "contractIds",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID",
                    "ofType": null
                  }
                }
              }
            }
          },
          {
            "name": "offsetByNPeriods",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            }
          },
          {
            "name": "offsetByPeriod",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "Frequency",
                "ofType": null
              }
            }
          },
          {
            "name": "periodEndDate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Date",
                "ofType": null
              }
            }
          },
          {
            "name": "periodStartDate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Date",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "UpdateContractCashflowPeriodDatesResponse",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "UpdateContractCashflowPeriodTotalsInput",
        "inputFields": [
          {
            "name": "contractId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            }
          },
          {
            "name": "perCurrencyTotals",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "MoneyFormulaInput",
                    "ofType": null
                  }
                }
              }
            }
          },
          {
            "name": "periodEndDate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Date",
                "ofType": null
              }
            }
          },
          {
            "name": "periodStartDate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Date",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "UpdateContractCashflowPeriodTotalsResponse",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "UpdateContractFieldsInput",
        "inputFields": [
          {
            "name": "annualContractValue",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "MoneyFormulaInput",
              "ofType": null
            }
          },
          {
            "name": "autoRenews",
            "type": {
              "kind": "SCALAR",
              "name": "Boolean",
              "ofType": null
            }
          },
          {
            "name": "billingTerms",
            "type": {
              "kind": "ENUM",
              "name": "BillingTerms",
              "ofType": null
            }
          },
          {
            "name": "departmentId",
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            }
          },
          {
            "name": "displayName",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            }
          },
          {
            "name": "endDate",
            "type": {
              "kind": "SCALAR",
              "name": "Date",
              "ofType": null
            }
          },
          {
            "name": "fileId",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            }
          },
          {
            "name": "hasEnded",
            "type": {
              "kind": "SCALAR",
              "name": "Boolean",
              "ofType": null
            }
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            }
          },
          {
            "name": "notes",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            }
          },
          {
            "name": "noticePeriodDays",
            "type": {
              "kind": "SCALAR",
              "name": "Int",
              "ofType": null
            }
          },
          {
            "name": "ownerId",
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            }
          },
          {
            "name": "ownerName",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            }
          },
          {
            "name": "parsedRecipient",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "ParsedRecipientInput",
              "ofType": null
            }
          },
          {
            "name": "paymentSummary",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            }
          },
          {
            "name": "paymentTerms",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "PaymentTermsInput",
              "ofType": null
            }
          },
          {
            "name": "purchaseOrderId",
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            }
          },
          {
            "name": "recipientId",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            }
          },
          {
            "name": "renewalDate",
            "type": {
              "kind": "SCALAR",
              "name": "Date",
              "ofType": null
            }
          },
          {
            "name": "signatureDate",
            "type": {
              "kind": "SCALAR",
              "name": "Date",
              "ofType": null
            }
          },
          {
            "name": "startDate",
            "type": {
              "kind": "SCALAR",
              "name": "Date",
              "ofType": null
            }
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "UpdateContractPaymentObligationsInput",
        "inputFields": [
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            }
          },
          {
            "name": "paymentObligations",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "ContractPaymentObligationInput",
                  "ofType": null
                }
              }
            },
            "defaultValue": "null"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "UpdateContractResponse",
        "fields": [
          {
            "name": "contract",
            "type": {
              "kind": "OBJECT",
              "name": "Contract",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "UpdateCustomerInfoInput",
        "inputFields": [
          {
            "name": "address",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "AddressInput",
              "ofType": null
            }
          },
          {
            "name": "phoneNumber",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "UpdateCustomerInfoResponse",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "UpdateCustomerInfoWidget",
        "fields": [
          {
            "name": "address",
            "type": {
              "kind": "OBJECT",
              "name": "Address",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "phoneNumber",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "status",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "WidgetStatus",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "title",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseWidget"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "UpdateCustomerTierInput",
        "inputFields": [
          {
            "name": "customerId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            }
          },
          {
            "name": "newTier",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "CustomerTier",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "UpdateCustomerTierResponse",
        "fields": [
          {
            "name": "customer",
            "type": {
              "kind": "OBJECT",
              "name": "Customer",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "UpdateDraftExpenseAccrualInput",
        "inputFields": [
          {
            "name": "accountingClassId",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "accountingDepartmentId",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "accountingExpenseAccountId",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "accountingJournalEntryId",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "accountingLiabilityAccountId",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "accountingLocationId",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "accountingVendorId",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "accrualDateUtc",
            "type": {
              "kind": "SCALAR",
              "name": "Date",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "amount",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "VariableMoneyInput",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "contractId",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "description",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            }
          },
          {
            "name": "postedAtUtc",
            "type": {
              "kind": "SCALAR",
              "name": "DateTime",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "quantity",
            "type": {
              "kind": "SCALAR",
              "name": "Float",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "recipientId",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "unitAmount",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "VariableMoneyInput",
              "ofType": null
            },
            "defaultValue": "null"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "UpdateDraftExpenseAccrualsInput",
        "inputFields": [
          {
            "name": "expenseAccruals",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "UpdateDraftExpenseAccrualInput",
                    "ofType": null
                  }
                }
              }
            }
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "UpdateDraftPaymentInput",
        "inputFields": [
          {
            "name": "amount",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "MoneyInput",
              "ofType": null
            }
          },
          {
            "name": "dueDateUtc",
            "type": {
              "kind": "SCALAR",
              "name": "Date",
              "ofType": null
            }
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            }
          },
          {
            "name": "method",
            "type": {
              "kind": "ENUM",
              "name": "PaymentMethod",
              "ofType": null
            }
          },
          {
            "name": "paymentReason",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            }
          },
          {
            "name": "recipient",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "SuperSheetsRecipientInput",
              "ofType": null
            }
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "UpdateInvoiceStatusInput",
        "inputFields": [
          {
            "name": "depositActivityId",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            }
          },
          {
            "name": "invoiceId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            }
          },
          {
            "name": "newStatus",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "InvoiceStatus",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "UpdateInvoiceStatusResponse",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "invoice",
            "type": {
              "kind": "OBJECT",
              "name": "Invoice",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "UpdateLevroOpsUserRoleInput",
        "inputFields": [
          {
            "name": "orgId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            }
          },
          {
            "name": "role",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "UserRole",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "UpdateLevroOpsUserRoleResponse",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "role",
            "type": {
              "kind": "ENUM",
              "name": "UserRole",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "UpdateProcurementRequestInput",
        "inputFields": [
          {
            "name": "annualContractValue",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "MoneyFormulaInput",
              "ofType": null
            }
          },
          {
            "name": "departmentId",
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "estimatedStartDate",
            "type": {
              "kind": "SCALAR",
              "name": "Date",
              "ofType": null
            }
          },
          {
            "name": "fileId",
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            }
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            }
          },
          {
            "name": "notes",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            }
          },
          {
            "name": "ownerId",
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            }
          },
          {
            "name": "vendorId",
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            }
          },
          {
            "name": "vendorName",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "UpdateProcurementRequestResponse",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "request",
            "type": {
              "kind": "OBJECT",
              "name": "ProcurementRequest",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "UpdateRecipientInput",
        "inputFields": [
          {
            "name": "accountInformation",
            "type": {
              "kind": "INPUT_OBJECT",
              "name": "RecipientAccountInput",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "displayName",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "email",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "managerId",
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "recipientId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            }
          },
          {
            "name": "usTin",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "UpdateRecipientResponse",
        "fields": [
          {
            "name": "accountInformationErrors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "recipient",
            "type": {
              "kind": "OBJECT",
              "name": "Recipient",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "UpdateUserError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "CannotReduceRecipientManagerPermissionError"
          },
          {
            "kind": "OBJECT",
            "name": "CannotUpdateBusinessContactRoleError"
          },
          {
            "kind": "OBJECT",
            "name": "DefaultError"
          },
          {
            "kind": "OBJECT",
            "name": "UserNotFoundError"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "UpdateUserInput",
        "inputFields": [
          {
            "name": "firstName",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "lastName",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "phone",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "role",
            "type": {
              "kind": "ENUM",
              "name": "UserRole",
              "ofType": null
            },
            "defaultValue": "null"
          },
          {
            "name": "userId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "UpdateUserResponse",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "UNION",
                  "name": "UpdateUserError",
                  "ofType": null
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "UploadParseAndMapFieldsFromDocInput",
        "inputFields": [
          {
            "name": "fileIds",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "String",
                    "ofType": null
                  }
                }
              }
            }
          },
          {
            "name": "formFieldsJsonSchema",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "defaultValue": "null"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "User",
        "fields": [
          {
            "name": "firstName",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "inactive",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "lastName",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "recipientId",
            "type": {
              "kind": "SCALAR",
              "name": "ID",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "restrictedDetails",
            "type": {
              "kind": "OBJECT",
              "name": "UserRestrictedDetails",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "UserGroupApprover",
        "fields": [
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "users",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "User",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "UserGroupApproverInput",
        "inputFields": [
          {
            "name": "groupId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "UserNotFoundError",
        "fields": [
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "path",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "SCALAR",
                  "name": "String",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "stackTrace",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "ErrorInterface"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "UserNotSignedUp",
        "fields": [
          {
            "name": "void",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "UserProfileResponse",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "User"
          },
          {
            "kind": "OBJECT",
            "name": "UserNotSignedUp"
          }
        ]
      },
      {
        "kind": "ENUM",
        "name": "UserResolutionAbility",
        "enumValues": [
          {
            "name": "FINAL_APPROVAL"
          },
          {
            "name": "INTERMEDIATE_APPROVAL"
          },
          {
            "name": "NONE"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "UserResponse",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "user",
            "type": {
              "kind": "OBJECT",
              "name": "User",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "UserRestrictedDetails",
        "fields": [
          {
            "name": "authInfo",
            "type": {
              "kind": "OBJECT",
              "name": "AuthInfo",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "dob",
            "type": {
              "kind": "SCALAR",
              "name": "Date",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "email",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "isUnitBusinessContact",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "phoneNumber",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "rolesInfo",
            "type": {
              "kind": "OBJECT",
              "name": "UserRolesInfo",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "ENUM",
        "name": "UserRole",
        "enumValues": [
          {
            "name": "ACCOUNTANT"
          },
          {
            "name": "ADMINISTRATOR"
          },
          {
            "name": "AUDITOR"
          },
          {
            "name": "CARDHOLDER"
          },
          {
            "name": "LITE_ADMIN"
          },
          {
            "name": "LITE_USER"
          },
          {
            "name": "RECIPIENT"
          },
          {
            "name": "REVIEWER"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "UserRolesInfo",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "role",
            "type": {
              "kind": "ENUM",
              "name": "UserRole",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "UsersResponse",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "users",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "User",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "VariableMoney",
        "fields": [
          {
            "name": "amount",
            "type": {
              "kind": "SCALAR",
              "name": "Float",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "currency",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "VariableMoneyInput",
        "inputFields": [
          {
            "name": "amount",
            "type": {
              "kind": "SCALAR",
              "name": "Float",
              "ofType": null
            }
          },
          {
            "name": "currency",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "VendorAccountingInfo",
        "fields": [
          {
            "name": "accountingCategories",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "AccountingCategory",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "firstTransactionDate",
            "type": {
              "kind": "SCALAR",
              "name": "Date",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "lastTransactionDate",
            "type": {
              "kind": "SCALAR",
              "name": "Date",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "nominalAccounts",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "NominalAccount",
                    "ofType": null
                  }
                }
              }
            },
            "args": []
          },
          {
            "name": "numRecentTransactions",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "recentSpend",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "Money",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "vendor",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "Recipient",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "vendorId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "VendorFeedback",
        "fields": [
          {
            "name": "comment",
            "type": {
              "kind": "SCALAR",
              "name": "String",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "createdAt",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "DateTime",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "raterEmail",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "rating",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "VendorManagerApprover",
        "fields": [
          {
            "name": "null",
            "type": {
              "kind": "SCALAR",
              "name": "Void",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "VendorManagerApproverInput",
        "inputFields": [
          {
            "name": "null",
            "type": {
              "kind": "SCALAR",
              "name": "Void",
              "ofType": null
            },
            "defaultValue": "null"
          }
        ]
      },
      {
        "kind": "ENUM",
        "name": "VerificationMethod",
        "enumValues": [
          {
            "name": "ADDRESS"
          },
          {
            "name": "ADDRESS_AND_CVV2"
          },
          {
            "name": "CVV2"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "VerifyDocumentInput",
        "inputFields": [
          {
            "name": "applicationId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            }
          },
          {
            "name": "documentId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            }
          },
          {
            "name": "jobId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "VerifyDocumentResponse",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "SCALAR",
        "name": "Void"
      },
      {
        "kind": "OBJECT",
        "name": "VolumeAccountLimit",
        "fields": [
          {
            "name": "limitType",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "AccountLimitType",
                "ofType": null
              }
            },
            "args": []
          },
          {
            "name": "nThreshold",
            "type": {
              "kind": "SCALAR",
              "name": "Int",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "nUtilized",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "AccountLimitInterface"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "Widget",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "AccountsWidget"
          },
          {
            "kind": "OBJECT",
            "name": "ApprovalFlowWidget"
          },
          {
            "kind": "OBJECT",
            "name": "BillDetailsWidget"
          },
          {
            "kind": "OBJECT",
            "name": "BillPayWidget"
          },
          {
            "kind": "OBJECT",
            "name": "BillTableWidget"
          },
          {
            "kind": "OBJECT",
            "name": "CardActionWidget"
          },
          {
            "kind": "OBJECT",
            "name": "CheckDepositWidget"
          },
          {
            "kind": "OBJECT",
            "name": "ContractCashflowWidget"
          },
          {
            "kind": "OBJECT",
            "name": "ContractDetailsWidget"
          },
          {
            "kind": "OBJECT",
            "name": "ContractTableWidget"
          },
          {
            "kind": "OBJECT",
            "name": "CreateConversionWidget"
          },
          {
            "kind": "OBJECT",
            "name": "CreateInvoiceWidget"
          },
          {
            "kind": "OBJECT",
            "name": "CreateRecipientWidget"
          },
          {
            "kind": "OBJECT",
            "name": "DownloadStatementsWidget"
          },
          {
            "kind": "OBJECT",
            "name": "FxRateHistoryWidget"
          },
          {
            "kind": "OBJECT",
            "name": "InvalidWidget"
          },
          {
            "kind": "OBJECT",
            "name": "PaymentDetailsWidget"
          },
          {
            "kind": "OBJECT",
            "name": "PaymentTableWidget"
          },
          {
            "kind": "OBJECT",
            "name": "RecipientTableWidget"
          },
          {
            "kind": "OBJECT",
            "name": "SendBulkPaymentWidget"
          },
          {
            "kind": "OBJECT",
            "name": "SendPaymentWidget"
          },
          {
            "kind": "OBJECT",
            "name": "StaticContentWidget"
          },
          {
            "kind": "OBJECT",
            "name": "TableWidget"
          },
          {
            "kind": "OBJECT",
            "name": "TransactionTableWidget"
          },
          {
            "kind": "OBJECT",
            "name": "UpdateCustomerInfoWidget"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "WidgetStatus",
        "fields": [
          {
            "name": "status",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "WidgetStatusCategory",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseWidgetStatus"
          }
        ]
      },
      {
        "kind": "ENUM",
        "name": "WidgetStatusCategory",
        "enumValues": [
          {
            "name": "ACTIONED"
          },
          {
            "name": "NEW"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "WireFunding",
        "fields": [
          {
            "name": "deadline",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "DateTime",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": []
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "WriteActivityNoteInput",
        "inputFields": [
          {
            "name": "activityId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            }
          },
          {
            "name": "note",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "INPUT_OBJECT",
                "name": "NoteInput",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "WriteActivityNoteResponse",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "note",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "Note",
                "ofType": null
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "WriteAnnotationInput",
        "inputFields": [
          {
            "name": "annotationJson",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            }
          },
          {
            "name": "taskId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "WriteAnnotationResponse",
        "fields": [
          {
            "name": "annotation",
            "type": {
              "kind": "OBJECT",
              "name": "Annotation",
              "ofType": null
            },
            "args": []
          },
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "WriteEventInstanceNoteInput",
        "inputFields": [
          {
            "name": "eventId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            }
          },
          {
            "name": "note",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "INPUT_OBJECT",
                "name": "NoteInput",
                "ofType": null
              }
            }
          },
          {
            "name": "ordinal",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Int",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "WriteEventInstanceNoteResponse",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "note",
            "type": {
              "kind": "OBJECT",
              "name": "Note",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "WriteScheduledEventNoteInput",
        "inputFields": [
          {
            "name": "eventId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            }
          },
          {
            "name": "note",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "INPUT_OBJECT",
                "name": "NoteInput",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "WriteScheduledEventNoteResponse",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "note",
            "type": {
              "kind": "OBJECT",
              "name": "Note",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "WriteTransactionNoteInput",
        "inputFields": [
          {
            "name": "note",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "INPUT_OBJECT",
                "name": "NoteInput",
                "ofType": null
              }
            }
          },
          {
            "name": "transactionId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID",
                "ofType": null
              }
            }
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "WriteTransactionNoteResponse",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "DefaultError",
                  "ofType": null
                }
              }
            },
            "args": []
          },
          {
            "name": "note",
            "type": {
              "kind": "OBJECT",
              "name": "Note",
              "ofType": null
            },
            "args": []
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseResponse"
          }
        ]
      },
      {
        "kind": "SCALAR",
        "name": "Any"
      }
    ],
    "directives": []
  }
} as unknown as IntrospectionQuery;